//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.3.0.0 (NJsonSchema v11.2.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class ApiBaseClass {
  protected getBaseUrl = (defaultUrl: string, baseUrl: string | undefined) => {
    return process.env.REACT_APP_API_BASE_URL || defaultUrl;
  };
}

export class BackOfficeAPI extends ApiBaseClass {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("https://api-qa.mybasepay.com", baseUrl);
    }

    /**
     * Invite user
     * @param body (optional) 
     * @return Success
     */
    inviteUser(body: InvitedUserRequestModel | undefined): Promise<string> {
        let url_ = this.baseUrl + "/backoffice/account/invite-user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInviteUser(_response);
        });
    }

    protected processInviteUser(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * add outreach
     * @param body (optional) 
     * @return Success
     */
    addOutreach(body: OutreachModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/account/outreach";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddOutreach(_response);
        });
    }

    protected processAddOutreach(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Is profile completed
     * @return Success
     */
    hasProfileCompleted(): Promise<boolean> {
        let url_ = this.baseUrl + "/backoffice/account/has/profile-completed";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHasProfileCompleted(_response);
        });
    }

    protected processHasProfileCompleted(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Is Exists My Customers
     * @return Success
     */
    isExistsMyCustomers(): Promise<boolean> {
        let url_ = this.baseUrl + "/backoffice/account/has/customers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processIsExistsMyCustomers(_response);
        });
    }

    protected processIsExistsMyCustomers(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Get my full profile
     * @return Success
     */
    getMyFullProfile(): Promise<FullBOUserResponseModel> {
        let url_ = this.baseUrl + "/backoffice/account/full-profile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMyFullProfile(_response);
        });
    }

    protected processGetMyFullProfile(response: Response): Promise<FullBOUserResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FullBOUserResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FullBOUserResponseModel>(null as any);
    }

    /**
     * Update company profile
     * @param body (optional) 
     * @return Success
     */
    updateCompanyProfile(body: CompanyRequestModel | undefined): Promise<string> {
        let url_ = this.baseUrl + "/backoffice/account/company";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateCompanyProfile(_response);
        });
    }

    protected processUpdateCompanyProfile(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Update selfEmployee profile
     * @param body (optional) 
     * @return Success
     */
    updateSelfEmployeeProfile(body: SelfEmployedRequestModel | undefined): Promise<string> {
        let url_ = this.baseUrl + "/backoffice/account/self-employee";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateSelfEmployeeProfile(_response);
        });
    }

    protected processUpdateSelfEmployeeProfile(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Update international profile
     * @param body (optional) 
     * @return Success
     */
    updateInternationalProfile(body: InternationalRequestModel | undefined): Promise<string> {
        let url_ = this.baseUrl + "/backoffice/account/international";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateInternationalProfile(_response);
        });
    }

    protected processUpdateInternationalProfile(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Banking Information
     * @return Success
     */
    getBankingInformation(): Promise<BankingInformationResponseModel> {
        let url_ = this.baseUrl + "/backoffice/account/settings/banking-information";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBankingInformation(_response);
        });
    }

    protected processGetBankingInformation(response: Response): Promise<BankingInformationResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BankingInformationResponseModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BankingInformationResponseModel>(null as any);
    }

    /**
     * Banking Information
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateBankingInformation(body: BankingInformationRequestModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/account/settings/banking-information";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateOrUpdateBankingInformation(_response);
        });
    }

    protected processCreateOrUpdateBankingInformation(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Price Agreement
     * @return Success
     */
    getPriceAgreement(): Promise<BOUsersPriceAgreementRespModel> {
        let url_ = this.baseUrl + "/backoffice/account/settings/price-agreement";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPriceAgreement(_response);
        });
    }

    protected processGetPriceAgreement(response: Response): Promise<BOUsersPriceAgreementRespModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BOUsersPriceAgreementRespModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BOUsersPriceAgreementRespModel>(null as any);
    }

    /**
     * Confirm Price Agreement
     * @param body (optional) 
     * @return Success
     */
    confirmPriceAgreement(body: BOUsersPriceAgreementConfirmModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/account/settings/price-agreement/confirm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processConfirmPriceAgreement(_response);
        });
    }

    protected processConfirmPriceAgreement(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Edit Price Agreement
     * @param body (optional) 
     * @return Success
     */
    editPriceAgreement(body: BOUsersPriceAgreementEditModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/account/settings/price-agreement/edit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEditPriceAgreement(_response);
        });
    }

    protected processEditPriceAgreement(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get Price Agreement file
     * @param fileKey (optional) 
     * @param fileName (optional) 
     * @return Success
     */
    getPriceAgreementFile(fileKey: string | undefined, fileName: string | undefined): Promise<ResourceDownloadResponse> {
        let url_ = this.baseUrl + "/backoffice/account/settings/download/price-agreement?";
        if (fileKey === null)
            throw new Error("The parameter 'fileKey' cannot be null.");
        else if (fileKey !== undefined)
            url_ += "FileKey=" + encodeURIComponent("" + fileKey) + "&";
        if (fileName === null)
            throw new Error("The parameter 'fileName' cannot be null.");
        else if (fileName !== undefined)
            url_ += "FileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPriceAgreementFile(_response);
        });
    }

    protected processGetPriceAgreementFile(response: Response): Promise<ResourceDownloadResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResourceDownloadResponse;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResourceDownloadResponse>(null as any);
    }

    /**
     * Get EntityInfo file
     * @return Success
     */
    getEntityInfoFile(): Promise<ResourceDownloadResponse> {
        let url_ = this.baseUrl + "/backoffice/account/settings/download/entity-info-file";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEntityInfoFile(_response);
        });
    }

    protected processGetEntityInfoFile(response: Response): Promise<ResourceDownloadResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResourceDownloadResponse;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResourceDownloadResponse>(null as any);
    }

    /**
     * Get link and key for upload EntityInfo file
     * @param document_ext Extension for file, one of [doc, docx, pdf, rtf]
     * @return Success
     */
    getEntityInfoFileUploadLink(document_ext: string): Promise<S3UploadResponse> {
        let url_ = this.baseUrl + "/backoffice/account/settings/upload/entity-info-file?";
        if (document_ext === undefined || document_ext === null)
            throw new Error("The parameter 'document_ext' must be defined and cannot be null.");
        else
            url_ += "document-ext=" + encodeURIComponent("" + document_ext) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEntityInfoFileUploadLink(_response);
        });
    }

    protected processGetEntityInfoFileUploadLink(response: Response): Promise<S3UploadResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as S3UploadResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<S3UploadResponse>(null as any);
    }

    /**
     * Get BankingInfo file
     * @return Success
     */
    getBankingInfoFile(): Promise<ResourceDownloadResponse> {
        let url_ = this.baseUrl + "/backoffice/account/settings/download/banking-info-file";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBankingInfoFile(_response);
        });
    }

    protected processGetBankingInfoFile(response: Response): Promise<ResourceDownloadResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResourceDownloadResponse;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResourceDownloadResponse>(null as any);
    }

    /**
     * Get link and key for upload BankingInfo file
     * @param document_ext Extension for file, one of [doc, docx, pdf, rtf]
     * @return Success
     */
    getBankingInfoFileUploadLink(document_ext: string): Promise<S3UploadResponse> {
        let url_ = this.baseUrl + "/backoffice/account/settings/upload/banking-info-file?";
        if (document_ext === undefined || document_ext === null)
            throw new Error("The parameter 'document_ext' must be defined and cannot be null.");
        else
            url_ += "document-ext=" + encodeURIComponent("" + document_ext) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBankingInfoFileUploadLink(_response);
        });
    }

    protected processGetBankingInfoFileUploadLink(response: Response): Promise<S3UploadResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as S3UploadResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<S3UploadResponse>(null as any);
    }

    /**
     * Entity Information
     * @return Success
     */
    getEntityInformation(): Promise<EntityInformationResponseModel> {
        let url_ = this.baseUrl + "/backoffice/account/settings/entity-information";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEntityInformation(_response);
        });
    }

    protected processGetEntityInformation(response: Response): Promise<EntityInformationResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EntityInformationResponseModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EntityInformationResponseModel>(null as any);
    }

    /**
     * entity Information
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateEntityInformation(body: EntityInformationRequestModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/account/settings/entity-information";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateOrUpdateEntityInformation(_response);
        });
    }

    protected processCreateOrUpdateEntityInformation(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Member logo information
     * @return Success
     */
    getMemberLogoInfo(): Promise<MemberLogoInfoViewModel> {
        let url_ = this.baseUrl + "/backoffice/account/settings/logo-information";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMemberLogoInfo(_response);
        });
    }

    protected processGetMemberLogoInfo(response: Response): Promise<MemberLogoInfoViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MemberLogoInfoViewModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MemberLogoInfoViewModel>(null as any);
    }

    /**
     * Member logo information
     * @param body (optional) 
     * @return No Content
     */
    setMemberLogoInfo(body: MemberLogoInfoEditModel | undefined): Promise<MemberLogoInfoViewModel> {
        let url_ = this.baseUrl + "/backoffice/account/settings/logo-information";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetMemberLogoInfo(_response);
        });
    }

    protected processSetMemberLogoInfo(response: Response): Promise<MemberLogoInfoViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            let result204: any = null;
            result204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MemberLogoInfoViewModel;
            return result204;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MemberLogoInfoViewModel>(null as any);
    }

    /**
     * Send additional info reply
     * @param body (optional) 
     * @return No Content
     */
    sendMemberAdditionalInfoReply(body: MemberAdditionalInfoReplyRequestModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/account/settings/additional-info-reply";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendMemberAdditionalInfoReply(_response);
        });
    }

    protected processSendMemberAdditionalInfoReply(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Billing information
     * @return Success
     */
    getCorporateBillingInfo(): Promise<ProfileCorporateBillingInfoModel> {
        let url_ = this.baseUrl + "/backoffice/account/settings/corporate-ta/billing-info";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCorporateBillingInfo(_response);
        });
    }

    protected processGetCorporateBillingInfo(response: Response): Promise<ProfileCorporateBillingInfoModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProfileCorporateBillingInfoModel;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProfileCorporateBillingInfoModel>(null as any);
    }

    /**
     * Set billing information
     * @return No Content
     */
    setCorporateBillingInfo(body: ProfileCorporateBillingInfoModel): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/account/settings/corporate-ta/billing-info";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetCorporateBillingInfo(_response);
        });
    }

    protected processSetCorporateBillingInfo(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Is only billing information unfilled
     * @return Success
     */
    hasOnlyBillingInformationUnfilled(): Promise<boolean> {
        let url_ = this.baseUrl + "/backoffice/account/settings/corporate-ta/has/only-billing-information-unfilled";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHasOnlyBillingInformationUnfilled(_response);
        });
    }

    protected processHasOnlyBillingInformationUnfilled(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * PrimaryContacts information
     * @return Success
     */
    getCorporatePrimaryContacts(): Promise<ProfileCorporatePrimaryContactInfoModel[]> {
        let url_ = this.baseUrl + "/backoffice/account/settings/corporate-ta/primary-contacts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCorporatePrimaryContacts(_response);
        });
    }

    protected processGetCorporatePrimaryContacts(response: Response): Promise<ProfileCorporatePrimaryContactInfoModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProfileCorporatePrimaryContactInfoModel[];
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProfileCorporatePrimaryContactInfoModel[]>(null as any);
    }

    /**
     * Set primary contacts information
     * @return No Content
     */
    setCorporatePrimaryContactsInfo(body: ProfileCorporatePrimaryContactsInfoModel): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/account/settings/corporate-ta/primary-contacts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetCorporatePrimaryContactsInfo(_response);
        });
    }

    protected processSetCorporatePrimaryContactsInfo(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Defines whether this contact is used in any active assignment
     * @return Success
     */
    contactHasActiveAssignmentRelation(contactId: string): Promise<boolean> {
        let url_ = this.baseUrl + "/backoffice/account/settings/corporate-ta/contacts/{contactId}/has-active-assignment";
        if (contactId === undefined || contactId === null)
            throw new Error("The parameter 'contactId' must be defined.");
        url_ = url_.replace("{contactId}", encodeURIComponent("" + contactId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processContactHasActiveAssignmentRelation(_response);
        });
    }

    protected processContactHasActiveAssignmentRelation(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Supervisors information
     * @return Success
     */
    getCorporateSupervisors(): Promise<ProfileCorporateSupervisorInfoModel[]> {
        let url_ = this.baseUrl + "/backoffice/account/settings/corporate-ta/supervisors";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCorporateSupervisors(_response);
        });
    }

    protected processGetCorporateSupervisors(response: Response): Promise<ProfileCorporateSupervisorInfoModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProfileCorporateSupervisorInfoModel[];
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProfileCorporateSupervisorInfoModel[]>(null as any);
    }

    /**
     * Set supervisors information
     * @return No Content
     */
    setCorporateSupervisorsInfo(body: ProfileCorporateSupervisorsInfoModel): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/account/settings/corporate-ta/supervisors";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetCorporateSupervisorsInfo(_response);
        });
    }

    protected processSetCorporateSupervisorsInfo(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * TimesheetApprovers information
     * @return Success
     */
    getCorporateTimesheetApprovers(): Promise<ProfileCorporateTimesheetApproverInfoModel[]> {
        let url_ = this.baseUrl + "/backoffice/account/settings/corporate-ta/timesheet-approvers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCorporateTimesheetApprovers(_response);
        });
    }

    protected processGetCorporateTimesheetApprovers(response: Response): Promise<ProfileCorporateTimesheetApproverInfoModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProfileCorporateTimesheetApproverInfoModel[];
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProfileCorporateTimesheetApproverInfoModel[]>(null as any);
    }

    /**
     * Set timesheetApprovers information
     * @return No Content
     */
    setCorporateTimesheetApproversInfo(body: ProfileCorporateTimesheetApproversInfoModel): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/account/settings/corporate-ta/timesheet-approvers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetCorporateTimesheetApproversInfo(_response);
        });
    }

    protected processSetCorporateTimesheetApproversInfo(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get aging summary report
     * @param pageNumber (optional) 
     * @param sortType (optional) 
     * @param sortField (optional) 
     * @param pageSize (optional) 
     * @return Success
     */
    getAgingSummaryReport(pageNumber: number | undefined, sortType: SortingEnum | undefined, sortField: AgingSummarySortFieldEnum | undefined, pageSize: number | undefined): Promise<AgingSummaryReportPagedResponse> {
        let url_ = this.baseUrl + "/backoffice/aging/summary?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (sortType === null)
            throw new Error("The parameter 'sortType' cannot be null.");
        else if (sortType !== undefined)
            url_ += "SortType=" + encodeURIComponent("" + sortType) + "&";
        if (sortField === null)
            throw new Error("The parameter 'sortField' cannot be null.");
        else if (sortField !== undefined)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAgingSummaryReport(_response);
        });
    }

    protected processGetAgingSummaryReport(response: Response): Promise<AgingSummaryReportPagedResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AgingSummaryReportPagedResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AgingSummaryReportPagedResponse>(null as any);
    }

    /**
     * Get aging summary excel report
     * @param pageNumber (optional) 
     * @param sortType (optional) 
     * @param sortField (optional) 
     * @param pageSize (optional) 
     * @return Success
     */
    getAgingSummaryExcelReport(pageNumber: number | undefined, sortType: SortingEnum | undefined, sortField: AgingSummarySortFieldEnum | undefined, pageSize: number | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/backoffice/aging/summary/excel?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (sortType === null)
            throw new Error("The parameter 'sortType' cannot be null.");
        else if (sortType !== undefined)
            url_ += "SortType=" + encodeURIComponent("" + sortType) + "&";
        if (sortField === null)
            throw new Error("The parameter 'sortField' cannot be null.");
        else if (sortField !== undefined)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAgingSummaryExcelReport(_response);
        });
    }

    protected processGetAgingSummaryExcelReport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Get aging detail report
     * @param pageNumber (optional) 
     * @param sortType (optional) 
     * @param pageSize (optional) 
     * @param dateRangeType (optional) 
     * @return Success
     */
    getAgingDetailReport(customerKey: string, pageNumber: number | undefined, sortType: SortingEnum | undefined, pageSize: number | undefined, dateRangeType: AgingDetailDateRangeTypeEnum | undefined): Promise<AgingDetailPagedResponse> {
        let url_ = this.baseUrl + "/backoffice/aging/{customerKey}/detail?";
        if (customerKey === undefined || customerKey === null)
            throw new Error("The parameter 'customerKey' must be defined.");
        url_ = url_.replace("{customerKey}", encodeURIComponent("" + customerKey));
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (sortType === null)
            throw new Error("The parameter 'sortType' cannot be null.");
        else if (sortType !== undefined)
            url_ += "SortType=" + encodeURIComponent("" + sortType) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (dateRangeType === null)
            throw new Error("The parameter 'dateRangeType' cannot be null.");
        else if (dateRangeType !== undefined)
            url_ += "DateRangeType=" + encodeURIComponent("" + dateRangeType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAgingDetailReport(_response);
        });
    }

    protected processGetAgingDetailReport(response: Response): Promise<AgingDetailPagedResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AgingDetailPagedResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AgingDetailPagedResponse>(null as any);
    }

    /**
     * Get aging detail excel report
     * @param pageNumber (optional) 
     * @param sortType (optional) 
     * @param pageSize (optional) 
     * @param dateRangeType (optional) 
     * @return Success
     */
    getAgingDetailExcelReport(customerKey: string, pageNumber: number | undefined, sortType: SortingEnum | undefined, pageSize: number | undefined, dateRangeType: AgingDetailDateRangeTypeEnum | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/backoffice/aging/{customerKey}/detail/excel?";
        if (customerKey === undefined || customerKey === null)
            throw new Error("The parameter 'customerKey' must be defined.");
        url_ = url_.replace("{customerKey}", encodeURIComponent("" + customerKey));
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (sortType === null)
            throw new Error("The parameter 'sortType' cannot be null.");
        else if (sortType !== undefined)
            url_ += "SortType=" + encodeURIComponent("" + sortType) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (dateRangeType === null)
            throw new Error("The parameter 'dateRangeType' cannot be null.");
        else if (dateRangeType !== undefined)
            url_ += "DateRangeType=" + encodeURIComponent("" + dateRangeType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAgingDetailExcelReport(_response);
        });
    }

    protected processGetAgingDetailExcelReport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Get aging total detail reports
     * @param pageNumber (optional) 
     * @param sortType (optional) 
     * @param pageSize (optional) 
     * @param dateRangeType (optional) 
     * @return Success
     */
    getAgingDetailTotalReport(pageNumber: number | undefined, sortType: SortingEnum | undefined, pageSize: number | undefined, dateRangeType: AgingDetailDateRangeTypeEnum | undefined): Promise<AgingTotalInfoViewModel> {
        let url_ = this.baseUrl + "/backoffice/aging/total/detail?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (sortType === null)
            throw new Error("The parameter 'sortType' cannot be null.");
        else if (sortType !== undefined)
            url_ += "SortType=" + encodeURIComponent("" + sortType) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (dateRangeType === null)
            throw new Error("The parameter 'dateRangeType' cannot be null.");
        else if (dateRangeType !== undefined)
            url_ += "DateRangeType=" + encodeURIComponent("" + dateRangeType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAgingDetailTotalReport(_response);
        });
    }

    protected processGetAgingDetailTotalReport(response: Response): Promise<AgingTotalInfoViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AgingTotalInfoViewModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AgingTotalInfoViewModel>(null as any);
    }

    /**
     * Get aging total detail excel report
     * @param pageNumber (optional) 
     * @param sortType (optional) 
     * @param pageSize (optional) 
     * @param dateRangeType (optional) 
     * @return Success
     */
    getAgingTotalDetailExcelReport(pageNumber: number | undefined, sortType: SortingEnum | undefined, pageSize: number | undefined, dateRangeType: AgingDetailDateRangeTypeEnum | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/backoffice/aging/total/detail/excel?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (sortType === null)
            throw new Error("The parameter 'sortType' cannot be null.");
        else if (sortType !== undefined)
            url_ += "SortType=" + encodeURIComponent("" + sortType) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (dateRangeType === null)
            throw new Error("The parameter 'dateRangeType' cannot be null.");
        else if (dateRangeType !== undefined)
            url_ += "DateRangeType=" + encodeURIComponent("" + dateRangeType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAgingTotalDetailExcelReport(_response);
        });
    }

    protected processGetAgingTotalDetailExcelReport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Get template names
     * @return Success
     */
    getTemplateNames(): Promise<AssignmentTemplateMiniViewModel[]> {
        let url_ = this.baseUrl + "/backoffice/assignment/templates/get-assignment-template-names";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTemplateNames(_response);
        });
    }

    protected processGetTemplateNames(response: Response): Promise<AssignmentTemplateMiniViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AssignmentTemplateMiniViewModel[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssignmentTemplateMiniViewModel[]>(null as any);
    }

    /**
     * Get template edit model
     * @return Success
     */
    getTemplateEditModel(templateId: string): Promise<AssignmentTemplateResponseModel> {
        let url_ = this.baseUrl + "/backoffice/assignment/templates/{templateId}/edit";
        if (templateId === undefined || templateId === null)
            throw new Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTemplateEditModel(_response);
        });
    }

    protected processGetTemplateEditModel(response: Response): Promise<AssignmentTemplateResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AssignmentTemplateResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssignmentTemplateResponseModel>(null as any);
    }

    /**
     * Get template details
     * @param templateId (optional) 
     * @return Success
     */
    getTemplateDetails(templateId: string | undefined): Promise<AssignmentTemplateDetailsResponse> {
        let url_ = this.baseUrl + "/backoffice/assignment/templates/get-template-details?";
        if (templateId === null)
            throw new Error("The parameter 'templateId' cannot be null.");
        else if (templateId !== undefined)
            url_ += "templateId=" + encodeURIComponent("" + templateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTemplateDetails(_response);
        });
    }

    protected processGetTemplateDetails(response: Response): Promise<AssignmentTemplateDetailsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AssignmentTemplateDetailsResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssignmentTemplateDetailsResponse>(null as any);
    }

    /**
     * Get assignment templates
     * @return Success
     */
    getAssignmentTemplates(pageNumber: number): Promise<UserPagedAssignmentTemplatesResponseModel> {
        let url_ = this.baseUrl + "/backoffice/assignment/templates?";
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAssignmentTemplates(_response);
        });
    }

    protected processGetAssignmentTemplates(response: Response): Promise<UserPagedAssignmentTemplatesResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserPagedAssignmentTemplatesResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserPagedAssignmentTemplatesResponseModel>(null as any);
    }

    /**
     * Delete assignment template
     * @return No Content
     */
    deleteAssignmentTemplate(templateId: string): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/assignment/templates/{templateId}";
        if (templateId === undefined || templateId === null)
            throw new Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAssignmentTemplate(_response);
        });
    }

    protected processDeleteAssignmentTemplate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Update template
     * @param templateId Template UUID
     * @return Success
     */
    updateTemplate(templateId: string, body: AssignmentPrimaryDocumentEditModel): Promise<CreateAssignmentResponse> {
        let url_ = this.baseUrl + "/backoffice/assignment/templates/{templateId}";
        if (templateId === undefined || templateId === null)
            throw new Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateTemplate(_response);
        });
    }

    protected processUpdateTemplate(response: Response): Promise<CreateAssignmentResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateAssignmentResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationDetailsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateAssignmentResponse>(null as any);
    }

    /**
     * Get assignments
     * @param page_number (optional) 
     * @param assignment_name (optional) 
     * @param assignment_statuses (optional) 
     * @param assignment_stage (optional) 
     * @param customer_ids (optional) 
     * @param worker_ids (optional) 
     * @param worker_types (optional) 
     * @param assignment_termination_reasons (optional) 
     * @return Success
     */
    getAssignments(page_number: number | undefined, assignment_name: string | undefined, assignment_statuses: AssignmentStatusTypeEnum[] | undefined, assignment_stage: AssignmentStageFilterEnum | undefined, customer_ids: string[] | undefined, worker_ids: string[] | undefined, worker_types: WorkerTypeEnum[] | undefined, assignment_termination_reasons: AssignmentTerminationReasonTypeEnum[] | undefined): Promise<UserPagedAssignmentResponseModel> {
        let url_ = this.baseUrl + "/backoffice/assignments?";
        if (page_number === null)
            throw new Error("The parameter 'page_number' cannot be null.");
        else if (page_number !== undefined)
            url_ += "page-number=" + encodeURIComponent("" + page_number) + "&";
        if (assignment_name === null)
            throw new Error("The parameter 'assignment_name' cannot be null.");
        else if (assignment_name !== undefined)
            url_ += "assignment-name=" + encodeURIComponent("" + assignment_name) + "&";
        if (assignment_statuses === null)
            throw new Error("The parameter 'assignment_statuses' cannot be null.");
        else if (assignment_statuses !== undefined)
            assignment_statuses && assignment_statuses.forEach(item => { url_ += "assignment-statuses=" + encodeURIComponent("" + item) + "&"; });
        if (assignment_stage === null)
            throw new Error("The parameter 'assignment_stage' cannot be null.");
        else if (assignment_stage !== undefined)
            url_ += "assignment-stage=" + encodeURIComponent("" + assignment_stage) + "&";
        if (customer_ids === null)
            throw new Error("The parameter 'customer_ids' cannot be null.");
        else if (customer_ids !== undefined)
            customer_ids && customer_ids.forEach(item => { url_ += "customer-ids=" + encodeURIComponent("" + item) + "&"; });
        if (worker_ids === null)
            throw new Error("The parameter 'worker_ids' cannot be null.");
        else if (worker_ids !== undefined)
            worker_ids && worker_ids.forEach(item => { url_ += "worker-ids=" + encodeURIComponent("" + item) + "&"; });
        if (worker_types === null)
            throw new Error("The parameter 'worker_types' cannot be null.");
        else if (worker_types !== undefined)
            worker_types && worker_types.forEach(item => { url_ += "worker-types=" + encodeURIComponent("" + item) + "&"; });
        if (assignment_termination_reasons === null)
            throw new Error("The parameter 'assignment_termination_reasons' cannot be null.");
        else if (assignment_termination_reasons !== undefined)
            assignment_termination_reasons && assignment_termination_reasons.forEach(item => { url_ += "assignment-termination-reasons=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAssignments(_response);
        });
    }

    protected processGetAssignments(response: Response): Promise<UserPagedAssignmentResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserPagedAssignmentResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserPagedAssignmentResponseModel>(null as any);
    }

    /**
     * Get splitted with me assignments
     * @param page_number (optional) 
     * @param assignment_name (optional) 
     * @return Success
     */
    getSplittedWithMeAssignments(page_number: number | undefined, assignment_name: string | undefined): Promise<UserPagedAssignmentResponseModel> {
        let url_ = this.baseUrl + "/backoffice/assignments/splitted-with-me?";
        if (page_number === null)
            throw new Error("The parameter 'page_number' cannot be null.");
        else if (page_number !== undefined)
            url_ += "page-number=" + encodeURIComponent("" + page_number) + "&";
        if (assignment_name === null)
            throw new Error("The parameter 'assignment_name' cannot be null.");
        else if (assignment_name !== undefined)
            url_ += "assignment-name=" + encodeURIComponent("" + assignment_name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSplittedWithMeAssignments(_response);
        });
    }

    protected processGetSplittedWithMeAssignments(response: Response): Promise<UserPagedAssignmentResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserPagedAssignmentResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserPagedAssignmentResponseModel>(null as any);
    }

    /**
     * Assignment detail
     * @return Success
     */
    getAssignmentDetail(assignmentId: string): Promise<AssignmentInfoUserResponseModel> {
        let url_ = this.baseUrl + "/backoffice/assignments/{assignmentId}/info";
        if (assignmentId === undefined || assignmentId === null)
            throw new Error("The parameter 'assignmentId' must be defined.");
        url_ = url_.replace("{assignmentId}", encodeURIComponent("" + assignmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAssignmentDetail(_response);
        });
    }

    protected processGetAssignmentDetail(response: Response): Promise<AssignmentInfoUserResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AssignmentInfoUserResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssignmentInfoUserResponseModel>(null as any);
    }

    /**
     * HideAssignmentPulsatingIndicator
     * @param body (optional) 
     * @return Success
     */
    hideAssignmentPulsatingIndicator(body: AssignmentHideIndicatorModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/assignments/hide-assignment-pulsating-indicator";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHideAssignmentPulsatingIndicator(_response);
        });
    }

    protected processHideAssignmentPulsatingIndicator(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Assignment detail by assignmentKey
     * @return Success
     */
    getAssignmentDetailByKey(assignmentKey: string): Promise<AssignmentInfoUserResponseModel> {
        let url_ = this.baseUrl + "/backoffice/assignments/key:{assignmentKey}/info";
        if (assignmentKey === undefined || assignmentKey === null)
            throw new Error("The parameter 'assignmentKey' must be defined.");
        url_ = url_.replace("{assignmentKey}", encodeURIComponent("" + assignmentKey));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAssignmentDetailByKey(_response);
        });
    }

    protected processGetAssignmentDetailByKey(response: Response): Promise<AssignmentInfoUserResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AssignmentInfoUserResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssignmentInfoUserResponseModel>(null as any);
    }

    /**
     * Member questionnaire stage.
     * @param assignmentId Assignment UUID
     * @param body (optional) 
     * @return No Content
     */
    fillMemberQuestionnaireData(assignmentId: string, body: AssignmentQuestionnaireInfoModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/assignments/{assignmentId}/questionnaire";
        if (assignmentId === undefined || assignmentId === null)
            throw new Error("The parameter 'assignmentId' must be defined.");
        url_ = url_.replace("{assignmentId}", encodeURIComponent("" + assignmentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFillMemberQuestionnaireData(_response);
        });
    }

    protected processFillMemberQuestionnaireData(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Contractor questionnaire stage.
     * @param assignmentId Assignment UUID
     * @param body (optional) 
     * @return No Content
     */
    fillСontractorQuestionnaireData(assignmentId: string, body: AssignmentQuestionnaireInfoModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/assignments/{assignmentId}/contractor-questionnaire";
        if (assignmentId === undefined || assignmentId === null)
            throw new Error("The parameter 'assignmentId' must be defined.");
        url_ = url_.replace("{assignmentId}", encodeURIComponent("" + assignmentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFillСontractorQuestionnaireData(_response);
        });
    }

    protected processFillСontractorQuestionnaireData(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Assignment additional info
     * @return Success
     */
    getAssignmentAdditionalInfo(assignmentId: string): Promise<AssignmentAdditionalInfoModel> {
        let url_ = this.baseUrl + "/backoffice/assignments/{assignmentId}/additional-info";
        if (assignmentId === undefined || assignmentId === null)
            throw new Error("The parameter 'assignmentId' must be defined.");
        url_ = url_.replace("{assignmentId}", encodeURIComponent("" + assignmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAssignmentAdditionalInfo(_response);
        });
    }

    protected processGetAssignmentAdditionalInfo(response: Response): Promise<AssignmentAdditionalInfoModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AssignmentAdditionalInfoModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssignmentAdditionalInfoModel>(null as any);
    }

    /**
     * Assignment detail excel.
     * @param assignmentId Assignment UUID
     * @return Success
     */
    getAssignmentsDetailExcel(assignmentId: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/backoffice/assignments/{assignmentId}/detail/excel";
        if (assignmentId === undefined || assignmentId === null)
            throw new Error("The parameter 'assignmentId' must be defined.");
        url_ = url_.replace("{assignmentId}", encodeURIComponent("" + assignmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAssignmentsDetailExcel(_response);
        });
    }

    protected processGetAssignmentsDetailExcel(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Send additional info reply
     * @param body (optional) 
     * @return No Content
     */
    sendAssignmentAdditionalInfoReply(body: AssignmentAdditionalInfoReplyRequestModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/assignments/additional-info-reply";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendAssignmentAdditionalInfoReply(_response);
        });
    }

    protected processSendAssignmentAdditionalInfoReply(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Assignment update schedulers
     * @param assignmentId Assignment UUID
     * @param body (optional) 
     * @return Success
     */
    updateFinanticalSchedulerInfo(assignmentId: string, body: AssignmentFinancialSchedulerEditModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/assignments/{assignmentId}/update-scheduler-info";
        if (assignmentId === undefined || assignmentId === null)
            throw new Error("The parameter 'assignmentId' must be defined.");
        url_ = url_.replace("{assignmentId}", encodeURIComponent("" + assignmentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateFinanticalSchedulerInfo(_response);
        });
    }

    protected processUpdateFinanticalSchedulerInfo(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Assignment remove schedulers
     * @param assignmentId Assignment UUID
     * @return Success
     */
    removeFinanticalSchedulerInfo(assignmentId: string): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/assignments/{assignmentId}/remove-scheduler-info";
        if (assignmentId === undefined || assignmentId === null)
            throw new Error("The parameter 'assignmentId' must be defined.");
        url_ = url_.replace("{assignmentId}", encodeURIComponent("" + assignmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveFinanticalSchedulerInfo(_response);
        });
    }

    protected processRemoveFinanticalSchedulerInfo(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Splitted with me assignment detail
     * @return Success
     */
    getSplittedWithMeAssignmentDetail(assignmentId: string): Promise<AssignmentInfoUserResponseModel> {
        let url_ = this.baseUrl + "/backoffice/assignments/splitted-with-me/{assignmentId}/info";
        if (assignmentId === undefined || assignmentId === null)
            throw new Error("The parameter 'assignmentId' must be defined.");
        url_ = url_.replace("{assignmentId}", encodeURIComponent("" + assignmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSplittedWithMeAssignmentDetail(_response);
        });
    }

    protected processGetSplittedWithMeAssignmentDetail(response: Response): Promise<AssignmentInfoUserResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AssignmentInfoUserResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssignmentInfoUserResponseModel>(null as any);
    }

    /**
     * Splitted with me assignment detail by assignmentKey
     * @return Success
     */
    getSplittedWithMeAssignmentDetailByKey(assignmentKey: string): Promise<AssignmentInfoUserResponseModel> {
        let url_ = this.baseUrl + "/backoffice/assignments/splitted-with-me/key:{assignmentKey}/info";
        if (assignmentKey === undefined || assignmentKey === null)
            throw new Error("The parameter 'assignmentKey' must be defined.");
        url_ = url_.replace("{assignmentKey}", encodeURIComponent("" + assignmentKey));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSplittedWithMeAssignmentDetailByKey(_response);
        });
    }

    protected processGetSplittedWithMeAssignmentDetailByKey(response: Response): Promise<AssignmentInfoUserResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AssignmentInfoUserResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssignmentInfoUserResponseModel>(null as any);
    }

    /**
     * Splitted with me assignment detail excel.
     * @param assignmentId Assignment UUID
     * @return Success
     */
    getSplittedWithMeAssignmentsDetailExcel(assignmentId: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/backoffice/assignments/splitted-with-me/{assignmentId}/detail/excel";
        if (assignmentId === undefined || assignmentId === null)
            throw new Error("The parameter 'assignmentId' must be defined.");
        url_ = url_.replace("{assignmentId}", encodeURIComponent("" + assignmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSplittedWithMeAssignmentsDetailExcel(_response);
        });
    }

    protected processGetSplittedWithMeAssignmentsDetailExcel(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Assignment termination model
     * @return Success
     */
    getAssignmentTerminationModel(assignmentId: string): Promise<AssignmentTerminationModel> {
        let url_ = this.baseUrl + "/backoffice/assignments/termination/{assignmentId}";
        if (assignmentId === undefined || assignmentId === null)
            throw new Error("The parameter 'assignmentId' must be defined.");
        url_ = url_.replace("{assignmentId}", encodeURIComponent("" + assignmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAssignmentTerminationModel(_response);
        });
    }

    protected processGetAssignmentTerminationModel(response: Response): Promise<AssignmentTerminationModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AssignmentTerminationModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssignmentTerminationModel>(null as any);
    }

    /**
     * Delete Assignment Termination
     * @return Success
     */
    deleteAssignmentTermination(assignmentId: string): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/assignments/termination/{assignmentId}";
        if (assignmentId === undefined || assignmentId === null)
            throw new Error("The parameter 'assignmentId' must be defined.");
        url_ = url_.replace("{assignmentId}", encodeURIComponent("" + assignmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAssignmentTermination(_response);
        });
    }

    protected processDeleteAssignmentTermination(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationDetailsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Create new Assignment Termination
     * @return Success
     */
    createNewAssignmentTermination(body: AssignmentTerminationCreateUpdateApiModel): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/assignments/termination";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateNewAssignmentTermination(_response);
        });
    }

    protected processCreateNewAssignmentTermination(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationDetailsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Update Assignment Termination
     * @return Success
     */
    updateAssignmentTermination(body: AssignmentTerminationCreateUpdateApiModel): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/assignments/termination";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateAssignmentTermination(_response);
        });
    }

    protected processUpdateAssignmentTermination(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationDetailsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get link and key for upload file
     * @param document_ext Extension for file, one of [doc, docx, pdf, rtf]
     * @return Success
     */
    getAssignmentTerminationAttachmentUploadLink(document_ext: string): Promise<S3UploadResponse> {
        let url_ = this.baseUrl + "/backoffice/assignments/termination/upload/attachment?";
        if (document_ext === undefined || document_ext === null)
            throw new Error("The parameter 'document_ext' must be defined and cannot be null.");
        else
            url_ += "document-ext=" + encodeURIComponent("" + document_ext) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAssignmentTerminationAttachmentUploadLink(_response);
        });
    }

    protected processGetAssignmentTerminationAttachmentUploadLink(response: Response): Promise<S3UploadResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as S3UploadResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<S3UploadResponse>(null as any);
    }

    /**
     * Get assignment termination attachment file
     * @param assignmentId Assignment UUID
     * @return Success
     */
    getAssignmentTerminationAttachmentFile(assignmentId: string): Promise<ResourceDownloadResponse[]> {
        let url_ = this.baseUrl + "/backoffice/assignments/termination/{assignmentId}/download/attachment";
        if (assignmentId === undefined || assignmentId === null)
            throw new Error("The parameter 'assignmentId' must be defined.");
        url_ = url_.replace("{assignmentId}", encodeURIComponent("" + assignmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAssignmentTerminationAttachmentFile(_response);
        });
    }

    protected processGetAssignmentTerminationAttachmentFile(response: Response): Promise<ResourceDownloadResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResourceDownloadResponse[];
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResourceDownloadResponse[]>(null as any);
    }

    /**
     * Get link and key for upload file
     * @param document_ext Extension for file, one of [doc, docx, pdf, rtf]
     * @return Success
     */
    getAssignmentAttachmentUploadLink(document_ext: string): Promise<S3UploadResponse> {
        let url_ = this.baseUrl + "/backoffice/assignments/attachment/upload?";
        if (document_ext === undefined || document_ext === null)
            throw new Error("The parameter 'document_ext' must be defined and cannot be null.");
        else
            url_ += "document-ext=" + encodeURIComponent("" + document_ext) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAssignmentAttachmentUploadLink(_response);
        });
    }

    protected processGetAssignmentAttachmentUploadLink(response: Response): Promise<S3UploadResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as S3UploadResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<S3UploadResponse>(null as any);
    }

    /**
     * Get attachment file
     * @param fileKey (optional) 
     * @param fileName (optional) 
     * @return Success
     */
    getAssignmentAttachmentFile(fileKey: string | undefined, fileName: string | undefined): Promise<ResourceDownloadResponse> {
        let url_ = this.baseUrl + "/backoffice/assignments/attachment/download?";
        if (fileKey === null)
            throw new Error("The parameter 'fileKey' cannot be null.");
        else if (fileKey !== undefined)
            url_ += "FileKey=" + encodeURIComponent("" + fileKey) + "&";
        if (fileName === null)
            throw new Error("The parameter 'fileName' cannot be null.");
        else if (fileName !== undefined)
            url_ += "FileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAssignmentAttachmentFile(_response);
        });
    }

    protected processGetAssignmentAttachmentFile(response: Response): Promise<ResourceDownloadResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResourceDownloadResponse;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResourceDownloadResponse>(null as any);
    }

    /**
     * get user placements
     * @param pageSize (optional) 
     * @param pageNumber (optional) 
     * @return Success
     */
    getPlacements(pageSize: number | undefined, pageNumber: number | undefined): Promise<AssignmentBullhornViewModelPagedResponseModel> {
        let url_ = this.baseUrl + "/backoffice/account/bullhorn/get-placements?";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPlacements(_response);
        });
    }

    protected processGetPlacements(response: Response): Promise<AssignmentBullhornViewModelPagedResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AssignmentBullhornViewModelPagedResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssignmentBullhornViewModelPagedResponseModel>(null as any);
    }

    /**
     * Login with bulhorn account
     * @param body (optional) 
     * @return Success
     */
    login(body: LoginRequestModel | undefined): Promise<BOUserBullhornSessionViewModel> {
        let url_ = this.baseUrl + "/backoffice/account/bullhorn/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLogin(_response);
        });
    }

    protected processLogin(response: Response): Promise<BOUserBullhornSessionViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BOUserBullhornSessionViewModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BOUserBullhornSessionViewModel>(null as any);
    }

    /**
     * First Login and connect to bulhorn account
     * @param body (optional) 
     * @return Success
     */
    connectAccount(body: LoginRequestModel | undefined): Promise<BOUserBullhornSessionViewModel> {
        let url_ = this.baseUrl + "/backoffice/account/bullhorn/connect-account";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processConnectAccount(_response);
        });
    }

    protected processConnectAccount(response: Response): Promise<BOUserBullhornSessionViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BOUserBullhornSessionViewModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BOUserBullhornSessionViewModel>(null as any);
    }

    /**
     * Disconnect bulhorn account
     * @return Success
     */
    disconnectAccount(): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/account/bullhorn/disconnect-account";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDisconnectAccount(_response);
        });
    }

    protected processDisconnectAccount(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Create new contractor company
     * @return Success
     */
    createNewContractorCompany(body: CreateContractorCompanyModel): Promise<CreateEntityResult> {
        let url_ = this.baseUrl + "/backoffice/contractor-companies";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateNewContractorCompany(_response);
        });
    }

    protected processCreateNewContractorCompany(response: Response): Promise<CreateEntityResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateEntityResult;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateEntityResult>(null as any);
    }

    /**
     * Get contractor companies for current member
     * @return Success
     */
    getContractorCompaniesForCurrentMember(): Promise<ContractorCompanyModel[]> {
        let url_ = this.baseUrl + "/backoffice/contractor-companies";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetContractorCompaniesForCurrentMember(_response);
        });
    }

    protected processGetContractorCompaniesForCurrentMember(response: Response): Promise<ContractorCompanyModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ContractorCompanyModel[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContractorCompanyModel[]>(null as any);
    }

    /**
     * Update contractor company
     * @param contractorCompanyId contractorCompanyId UUID
     * @return Success
     */
    updateContractorCompany(contractorCompanyId: string, body: UpdateContractorCompanyModel): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/contractor-companies/update/{contractorCompanyId}";
        if (contractorCompanyId === undefined || contractorCompanyId === null)
            throw new Error("The parameter 'contractorCompanyId' must be defined.");
        url_ = url_.replace("{contractorCompanyId}", encodeURIComponent("" + contractorCompanyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateContractorCompany(_response);
        });
    }

    protected processUpdateContractorCompany(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationDetailsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get contractor companies paged list for current member
     * @param pageNumber (optional) 
     * @return Success
     */
    getContractorCompaniesPagedListForCurrentMember(pageNumber: number | undefined): Promise<ContractorCompanyItemViewModelPagedResponseModel> {
        let url_ = this.baseUrl + "/backoffice/contractor-companies/paged?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetContractorCompaniesPagedListForCurrentMember(_response);
        });
    }

    protected processGetContractorCompaniesPagedListForCurrentMember(response: Response): Promise<ContractorCompanyItemViewModelPagedResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ContractorCompanyItemViewModelPagedResponseModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContractorCompanyItemViewModelPagedResponseModel>(null as any);
    }

    /**
     * Get contractor company detail
     * @return Success
     */
    getContractorCompanyDetailById(contractorCompanyId: string): Promise<ContractorCompanyDetailViewModel> {
        let url_ = this.baseUrl + "/backoffice/contractor-companies/{contractorCompanyId}";
        if (contractorCompanyId === undefined || contractorCompanyId === null)
            throw new Error("The parameter 'contractorCompanyId' must be defined.");
        url_ = url_.replace("{contractorCompanyId}", encodeURIComponent("" + contractorCompanyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetContractorCompanyDetailById(_response);
        });
    }

    protected processGetContractorCompanyDetailById(response: Response): Promise<ContractorCompanyDetailViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ContractorCompanyDetailViewModel;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContractorCompanyDetailViewModel>(null as any);
    }

    /**
     * Get contractor company detail
     * @return Success
     */
    getContractorCompanyDetailByKey(contractorCompanyKey: string): Promise<ContractorCompanyDetailViewModel> {
        let url_ = this.baseUrl + "/backoffice/contractor-companies/{contractorCompanyKey}";
        if (contractorCompanyKey === undefined || contractorCompanyKey === null)
            throw new Error("The parameter 'contractorCompanyKey' must be defined.");
        url_ = url_.replace("{contractorCompanyKey}", encodeURIComponent("" + contractorCompanyKey));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetContractorCompanyDetailByKey(_response);
        });
    }

    protected processGetContractorCompanyDetailByKey(response: Response): Promise<ContractorCompanyDetailViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ContractorCompanyDetailViewModel;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContractorCompanyDetailViewModel>(null as any);
    }

    /**
     * Get Contractor company file
     * @param workerId (optional) 
     * @return Success
     */
    getContractorCompanyFile(workerId: string | undefined): Promise<ResourceDownloadResponse> {
        let url_ = this.baseUrl + "/backoffice/contractor-companies/download/contractor-company-file?";
        if (workerId === null)
            throw new Error("The parameter 'workerId' cannot be null.");
        else if (workerId !== undefined)
            url_ += "workerId=" + encodeURIComponent("" + workerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetContractorCompanyFile(_response);
        });
    }

    protected processGetContractorCompanyFile(response: Response): Promise<ResourceDownloadResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResourceDownloadResponse;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResourceDownloadResponse>(null as any);
    }

    /**
     * Get link and key for upload Contractor company file
     * @param document_ext Extension for file, one of [doc, docx, pdf, rtf]
     * @param workerId (optional) 
     * @return Success
     */
    getContractorCompanyFileUploadLink(document_ext: string, workerId: string | undefined): Promise<S3UploadResponse> {
        let url_ = this.baseUrl + "/backoffice/contractor-companies/upload/contractor-company-file?";
        if (document_ext === undefined || document_ext === null)
            throw new Error("The parameter 'document_ext' must be defined and cannot be null.");
        else
            url_ += "document-ext=" + encodeURIComponent("" + document_ext) + "&";
        if (workerId === null)
            throw new Error("The parameter 'workerId' cannot be null.");
        else if (workerId !== undefined)
            url_ += "workerId=" + encodeURIComponent("" + workerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetContractorCompanyFileUploadLink(_response);
        });
    }

    protected processGetContractorCompanyFileUploadLink(response: Response): Promise<S3UploadResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as S3UploadResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<S3UploadResponse>(null as any);
    }

    /**
     * Get customers paged list
     * @param pageNumber (optional) 
     * @param status (optional) 
     * @param customerName (optional) 
     * @param companyIds (optional) 
     * @return Success
     */
    getCustomersPagedList(pageNumber: number | undefined, status: CustomerStatusFilterEnum | undefined, customerName: string | undefined, companyIds: string[] | undefined): Promise<CustomerPagedResponseModel> {
        let url_ = this.baseUrl + "/backoffice/customers?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (customerName === null)
            throw new Error("The parameter 'customerName' cannot be null.");
        else if (customerName !== undefined)
            url_ += "CustomerName=" + encodeURIComponent("" + customerName) + "&";
        if (companyIds === null)
            throw new Error("The parameter 'companyIds' cannot be null.");
        else if (companyIds !== undefined)
            companyIds && companyIds.forEach(item => { url_ += "CompanyIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCustomersPagedList(_response);
        });
    }

    protected processGetCustomersPagedList(response: Response): Promise<CustomerPagedResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomerPagedResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerPagedResponseModel>(null as any);
    }

    /**
     * Get info for Customer
     * @return Success
     */
    getCustomerInfo(customerId: string): Promise<CustomerInfoResponseModel> {
        let url_ = this.baseUrl + "/backoffice/customers/{customerId}/info";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCustomerInfo(_response);
        });
    }

    protected processGetCustomerInfo(response: Response): Promise<CustomerInfoResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomerInfoResponseModel;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerInfoResponseModel>(null as any);
    }

    /**
     * Get info for Customer
     * @return Success
     */
    getCustomerInfoByKey(customerKey: string): Promise<CustomerInfoResponseModel> {
        let url_ = this.baseUrl + "/backoffice/customers/key:{customerKey}/info";
        if (customerKey === undefined || customerKey === null)
            throw new Error("The parameter 'customerKey' must be defined.");
        url_ = url_.replace("{customerKey}", encodeURIComponent("" + customerKey));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCustomerInfoByKey(_response);
        });
    }

    protected processGetCustomerInfoByKey(response: Response): Promise<CustomerInfoResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomerInfoResponseModel;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerInfoResponseModel>(null as any);
    }

    /**
     * HideCustomerPulsatingIndicator
     * @param body (optional) 
     * @return Success
     */
    hideCustomerPulsatingIndicator(body: CustomerHideIndicatorModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/customers/hide-customer-pulsating-indicator";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHideCustomerPulsatingIndicator(_response);
        });
    }

    protected processHideCustomerPulsatingIndicator(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Create new draft customer
     * @return Success
     */
    createNewDraftCustomer(body: CreateCustomerRequest): Promise<CreateCustomerResponse> {
        let url_ = this.baseUrl + "/backoffice/customers/drafts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateNewDraftCustomer(_response);
        });
    }

    protected processCreateNewDraftCustomer(response: Response): Promise<CreateCustomerResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateCustomerResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateCustomerResponse>(null as any);
    }

    /**
     * Get edit model for Customer draft
     * @return Success
     */
    getCustomerDraftEdit(customerId: string): Promise<CustomerDraftResponse> {
        let url_ = this.baseUrl + "/backoffice/customers/drafts/{customerId}/edit";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCustomerDraftEdit(_response);
        });
    }

    protected processGetCustomerDraftEdit(response: Response): Promise<CustomerDraftResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomerDraftResponse;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerDraftResponse>(null as any);
    }

    /**
     * Update existed draft Customer info
     * @param customerId Customer UUID
     * @return Success
     */
    updateCustomerDraft(customerId: string, body: CreateCustomerRequest): Promise<CreateCustomerResponse> {
        let url_ = this.baseUrl + "/backoffice/customers/drafts/{customerId}";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateCustomerDraft(_response);
        });
    }

    protected processUpdateCustomerDraft(response: Response): Promise<CreateCustomerResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateCustomerResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateCustomerResponse>(null as any);
    }

    /**
     * Delete Customer draft record
     * @return No Content
     */
    deleteCustomerDraft(customerId: string): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/customers/drafts/{customerId}";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteCustomerDraft(_response);
        });
    }

    protected processDeleteCustomerDraft(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Try publish existed (Not implemented)
     * @return Success
     */
    publishCustomerDraft(customerId: string): Promise<CustomerDraftResponse> {
        let url_ = this.baseUrl + "/backoffice/customers/drafts/{customerId}/publish";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPublishCustomerDraft(_response);
        });
    }

    protected processPublishCustomerDraft(response: Response): Promise<CustomerDraftResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomerDraftResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerDraftResponse>(null as any);
    }

    /**
     * Create new customer
     * @return Success
     */
    createNewCustomer(body: CreateCustomerRequest): Promise<CreateCustomerResponse> {
        let url_ = this.baseUrl + "/backoffice/customers/requests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateNewCustomer(_response);
        });
    }

    protected processCreateNewCustomer(response: Response): Promise<CreateCustomerResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateCustomerResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateCustomerResponse>(null as any);
    }

    /**
     * Migrate existed draft to request Customer.
     * @param customerId Customer UUID
     * @return Success
     */
    migrateCustomerDraft(customerId: string, body: CreateCustomerRequest): Promise<CreateCustomerResponse> {
        let url_ = this.baseUrl + "/backoffice/customers/requests/{customerId}";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMigrateCustomerDraft(_response);
        });
    }

    protected processMigrateCustomerDraft(response: Response): Promise<CreateCustomerResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateCustomerResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateCustomerResponse>(null as any);
    }

    /**
     * Get list of Customers
     * @return Success
     */
    getMyCustomerList(): Promise<CustomerResponseModel[]> {
        let url_ = this.baseUrl + "/backoffice/customers/by/status/non-draft";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMyCustomerList(_response);
        });
    }

    protected processGetMyCustomerList(response: Response): Promise<CustomerResponseModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomerResponseModel[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerResponseModel[]>(null as any);
    }

    /**
     * Get Agreement Details file
     * @param customerId Customer UUID
     * @param fileKey (optional) 
     * @param fileName (optional) 
     * @return Success
     */
    getCustomerAgreementDetailsFile(customerId: string, fileKey: string | undefined, fileName: string | undefined): Promise<ResourceDownloadResponse> {
        let url_ = this.baseUrl + "/backoffice/customers/{customerId}/download/agreement-details?";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        if (fileKey === null)
            throw new Error("The parameter 'fileKey' cannot be null.");
        else if (fileKey !== undefined)
            url_ += "FileKey=" + encodeURIComponent("" + fileKey) + "&";
        if (fileName === null)
            throw new Error("The parameter 'fileName' cannot be null.");
        else if (fileName !== undefined)
            url_ += "FileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCustomerAgreementDetailsFile(_response);
        });
    }

    protected processGetCustomerAgreementDetailsFile(response: Response): Promise<ResourceDownloadResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResourceDownloadResponse;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResourceDownloadResponse>(null as any);
    }

    /**
     * Get link and key for upload agreement file
     * @param document_ext Extension for file, one of [doc, docx, pdf, rtf]
     * @return Success
     */
    getCustomerAgreementUploadLink(document_ext: string): Promise<S3UploadResponse> {
        let url_ = this.baseUrl + "/backoffice/customers/upload/agreement-link?";
        if (document_ext === undefined || document_ext === null)
            throw new Error("The parameter 'document_ext' must be defined and cannot be null.");
        else
            url_ += "document-ext=" + encodeURIComponent("" + document_ext) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCustomerAgreementUploadLink(_response);
        });
    }

    protected processGetCustomerAgreementUploadLink(response: Response): Promise<S3UploadResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as S3UploadResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<S3UploadResponse>(null as any);
    }

    /**
     * Get additional info for Customer
     * @param customerId Customer UUID
     * @return Success
     */
    getCustomerAdditionalInfo(customerId: string): Promise<CustomerAdditionalInfoResponseModel> {
        let url_ = this.baseUrl + "/backoffice/customers/{customerId}/additional-info";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCustomerAdditionalInfo(_response);
        });
    }

    protected processGetCustomerAdditionalInfo(response: Response): Promise<CustomerAdditionalInfoResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomerAdditionalInfoResponseModel;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerAdditionalInfoResponseModel>(null as any);
    }

    /**
     * Get certificate of insurance created file
     * @param customerId Customer UUID
     * @return Success
     */
    getCustomerCertificateOfInsuranceCreatedFileForMember(customerId: string): Promise<ResourceDownloadResponse> {
        let url_ = this.baseUrl + "/backoffice/customers/{customerId}/additional-info/download/certificate-of-insurance-created";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCustomerCertificateOfInsuranceCreatedFileForMember(_response);
        });
    }

    protected processGetCustomerCertificateOfInsuranceCreatedFileForMember(response: Response): Promise<ResourceDownloadResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResourceDownloadResponse;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResourceDownloadResponse>(null as any);
    }

    /**
     * Get Temp to perm conversion file
     * @param customerId Customer UUID
     * @return Success
     */
    getCustomerTempToPermConversionFile(customerId: string): Promise<ResourceDownloadResponse> {
        let url_ = this.baseUrl + "/backoffice/customers/{customerId}/download/additional-info/temp-to-perm-conversion";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCustomerTempToPermConversionFile(_response);
        });
    }

    protected processGetCustomerTempToPermConversionFile(response: Response): Promise<ResourceDownloadResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResourceDownloadResponse;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResourceDownloadResponse>(null as any);
    }

    /**
     * Get customers by assignments
     * @param assignment_statuses (optional) 
     * @return Success
     */
    getCustomersByAssignments(assignment_statuses: AssignmentStatusTypeEnum[] | undefined): Promise<CustomerSearchResponseModel[]> {
        let url_ = this.baseUrl + "/backoffice/customers/search/assignments?";
        if (assignment_statuses === null)
            throw new Error("The parameter 'assignment_statuses' cannot be null.");
        else if (assignment_statuses !== undefined)
            assignment_statuses && assignment_statuses.forEach(item => { url_ += "assignment-statuses=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCustomersByAssignments(_response);
        });
    }

    protected processGetCustomersByAssignments(response: Response): Promise<CustomerSearchResponseModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomerSearchResponseModel[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerSearchResponseModel[]>(null as any);
    }

    /**
     * Customer detail excel.
     * @param customerId Customer UUID
     * @return Success
     */
    getCustomersDetailExcel(customerId: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/backoffice/customers/{customerId}/detail/excel";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCustomersDetailExcel(_response);
        });
    }

    protected processGetCustomersDetailExcel(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Get customers for timesheet status report
     * @return Success
     */
    getCustomersForTimesheetStatusReport(): Promise<CustomerSearchResponseModel[]> {
        let url_ = this.baseUrl + "/backoffice/customers/timesheet-status-report";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCustomersForTimesheetStatusReport(_response);
        });
    }

    protected processGetCustomersForTimesheetStatusReport(response: Response): Promise<CustomerSearchResponseModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomerSearchResponseModel[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerSearchResponseModel[]>(null as any);
    }

    /**
     * Get onboarding documentation file
     * @param customerId Customer UUID
     * @param fileKey File key
     * @return Success
     */
    getCustomerOnboardingDocumentationFile(customerId: string, fileKey: string): Promise<ResourceDownloadResponse> {
        let url_ = this.baseUrl + "/backoffice/customers/{customerId}/download/onboarding-documentation?";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        if (fileKey === undefined || fileKey === null)
            throw new Error("The parameter 'fileKey' must be defined and cannot be null.");
        else
            url_ += "fileKey=" + encodeURIComponent("" + fileKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCustomerOnboardingDocumentationFile(_response);
        });
    }

    protected processGetCustomerOnboardingDocumentationFile(response: Response): Promise<ResourceDownloadResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResourceDownloadResponse;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResourceDownloadResponse>(null as any);
    }

    /**
     * Get SOW template file
     * @param customerId Customer UUID
     * @return Success
     */
    getSOWTemplateFile(customerId: string): Promise<ResourceDownloadResponse> {
        let url_ = this.baseUrl + "/backoffice/customers/{customerId}/download/sow-template";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSOWTemplateFile(_response);
        });
    }

    protected processGetSOWTemplateFile(response: Response): Promise<ResourceDownloadResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResourceDownloadResponse;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResourceDownloadResponse>(null as any);
    }

    /**
     * Send additional info reply
     * @param body (optional) 
     * @return No Content
     */
    sendCustomerAdditionalInfoReply(body: CustomerAdditionalInfoReplyRequestModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/customers/additional-info-reply";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendCustomerAdditionalInfoReply(_response);
        });
    }

    protected processSendCustomerAdditionalInfoReply(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Update existed Customer info
     * @param customerId Customer UUID
     * @return Success
     */
    updateCustomerInfo(customerId: string, body: CreateCustomerRequest): Promise<CreateCustomerResponse> {
        let url_ = this.baseUrl + "/backoffice/customers/{customerId}";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateCustomerInfo(_response);
        });
    }

    protected processUpdateCustomerInfo(response: Response): Promise<CreateCustomerResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateCustomerResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateCustomerResponse>(null as any);
    }

    /**
     * Get edit model for Customer
     * @param customerId Customer UUID
     * @return Success
     */
    getCustomerEditModel(customerId: string): Promise<CustomerEditResponse> {
        let url_ = this.baseUrl + "/backoffice/customers/{customerId}/edit";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCustomerEditModel(_response);
        });
    }

    protected processGetCustomerEditModel(response: Response): Promise<CustomerEditResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomerEditResponse;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerEditResponse>(null as any);
    }

    /**
     * Get purchase order file
     * @param customerId Customer UUID
     * @return Success
     */
    getCustomerPurchaseOrderFile(customerId: string): Promise<ResourceDownloadResponse> {
        let url_ = this.baseUrl + "/backoffice/customers/{customerId}/download/purchase-order";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCustomerPurchaseOrderFile(_response);
        });
    }

    protected processGetCustomerPurchaseOrderFile(response: Response): Promise<ResourceDownloadResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResourceDownloadResponse;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResourceDownloadResponse>(null as any);
    }

    /**
     * Create new draft Assignment
     * @return Success
     */
    createNewDraftAssignment(body: AssignmentPrimaryDocumentEditModel): Promise<CreateAssignmentResponse> {
        let url_ = this.baseUrl + "/backoffice/assignments/drafts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateNewDraftAssignment(_response);
        });
    }

    protected processCreateNewDraftAssignment(response: Response): Promise<CreateAssignmentResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateAssignmentResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationDetailsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateAssignmentResponse>(null as any);
    }

    /**
     * Update draft Assignment
     * @param assignmentId Assignment UUID
     * @return Success
     */
    updateDraftAssignment(assignmentId: string, body: AssignmentPrimaryDocumentEditModel): Promise<CreateAssignmentResponse> {
        let url_ = this.baseUrl + "/backoffice/assignments/drafts/{assignmentId}";
        if (assignmentId === undefined || assignmentId === null)
            throw new Error("The parameter 'assignmentId' must be defined.");
        url_ = url_.replace("{assignmentId}", encodeURIComponent("" + assignmentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateDraftAssignment(_response);
        });
    }

    protected processUpdateDraftAssignment(response: Response): Promise<CreateAssignmentResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateAssignmentResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationDetailsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateAssignmentResponse>(null as any);
    }

    /**
     * Delete draft Assignment
     * @param assignmentId Assignment UUID
     * @return No Content
     */
    deleteAssignmentDraft(assignmentId: string): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/assignments/drafts/{assignmentId}";
        if (assignmentId === undefined || assignmentId === null)
            throw new Error("The parameter 'assignmentId' must be defined.");
        url_ = url_.replace("{assignmentId}", encodeURIComponent("" + assignmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAssignmentDraft(_response);
        });
    }

    protected processDeleteAssignmentDraft(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Assignment merge edit model
     * @return Success
     */
    getAssignmentDraftEditModel(assignmentId: string): Promise<AssignmentEditUserResponseModel> {
        let url_ = this.baseUrl + "/backoffice/assignments/drafts/{assignmentId}/edit";
        if (assignmentId === undefined || assignmentId === null)
            throw new Error("The parameter 'assignmentId' must be defined.");
        url_ = url_.replace("{assignmentId}", encodeURIComponent("" + assignmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAssignmentDraftEditModel(_response);
        });
    }

    protected processGetAssignmentDraftEditModel(response: Response): Promise<AssignmentEditUserResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AssignmentEditUserResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssignmentEditUserResponseModel>(null as any);
    }

    /**
     * Get draft Worker file
     * @param assignmentId (optional) 
     * @return Success
     */
    getDraftWorkerFile(assignmentId: string | undefined): Promise<ResourceDownloadResponse> {
        let url_ = this.baseUrl + "/backoffice/assignments/drafts/download/worker-file?";
        if (assignmentId === null)
            throw new Error("The parameter 'assignmentId' cannot be null.");
        else if (assignmentId !== undefined)
            url_ += "assignmentId=" + encodeURIComponent("" + assignmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDraftWorkerFile(_response);
        });
    }

    protected processGetDraftWorkerFile(response: Response): Promise<ResourceDownloadResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResourceDownloadResponse;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResourceDownloadResponse>(null as any);
    }

    /**
     * Get financial reports paged list
     * @param body (optional) 
     * @return Success
     */
    getFinancialReportsPagedList(body: FinancialReportsRequestModel | undefined): Promise<FinancialResponseModel> {
        let url_ = this.baseUrl + "/backoffice/financialReports";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFinancialReportsPagedList(_response);
        });
    }

    protected processGetFinancialReportsPagedList(response: Response): Promise<FinancialResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FinancialResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FinancialResponseModel>(null as any);
    }

    /**
     * Get financial reports settings
     * @return Success
     */
    getFinancialReportsSettings(): Promise<FinancialFilterViewModel> {
        let url_ = this.baseUrl + "/backoffice/financialReports/get-financial-settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFinancialReportsSettings(_response);
        });
    }

    protected processGetFinancialReportsSettings(response: Response): Promise<FinancialFilterViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FinancialFilterViewModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FinancialFilterViewModel>(null as any);
    }

    /**
     * Set financial reports settings
     * @param body (optional) 
     * @return Success
     */
    setFinancialReportsSettings(body: FinancialFilterViewModel | undefined): Promise<FinancialFilterViewModel> {
        let url_ = this.baseUrl + "/backoffice/financialReports/set-financial-settings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetFinancialReportsSettings(_response);
        });
    }

    protected processSetFinancialReportsSettings(response: Response): Promise<FinancialFilterViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FinancialFilterViewModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FinancialFilterViewModel>(null as any);
    }

    /**
     * Get all financial reports filters
     * @return Success
     */
    getAllFinancialReportsFilters(): Promise<FinancialReportFieldFilterModel[]> {
        let url_ = this.baseUrl + "/backoffice/financialReports/filters";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllFinancialReportsFilters(_response);
        });
    }

    protected processGetAllFinancialReportsFilters(response: Response): Promise<FinancialReportFieldFilterModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FinancialReportFieldFilterModel[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FinancialReportFieldFilterModel[]>(null as any);
    }

    /**
     * FinancialReports detail excel.
     * @param body (optional) 
     * @return Success
     */
    getFinancialReportsExcel(body: FinancialReportsRequestModel | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/backoffice/financialReports/excel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFinancialReportsExcel(_response);
        });
    }

    protected processGetFinancialReportsExcel(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Get weekly trend billing report paged
     * @param from (optional) 
     * @param to (optional) 
     * @param pageSize (optional) 
     * @param pageNumber (optional) 
     * @param orderBy (optional) 
     * @param direction (optional) 
     * @return Success
     */
    getWeeklyTrendBillingReport(from: Date | undefined, to: Date | undefined, pageSize: number | undefined, pageNumber: number | undefined, orderBy: TrendBillingSortFieldEnum | undefined, direction: SortingEnum | undefined): Promise<WeeklyTrendBillingPagedResponse> {
        let url_ = this.baseUrl + "/backoffice/financialReports/weekly-trend-report?";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (direction === null)
            throw new Error("The parameter 'direction' cannot be null.");
        else if (direction !== undefined)
            url_ += "Direction=" + encodeURIComponent("" + direction) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWeeklyTrendBillingReport(_response);
        });
    }

    protected processGetWeeklyTrendBillingReport(response: Response): Promise<WeeklyTrendBillingPagedResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WeeklyTrendBillingPagedResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WeeklyTrendBillingPagedResponse>(null as any);
    }

    /**
     * WeeklyTrendReport detail excel.
     * @param from (optional) 
     * @param to (optional) 
     * @param pageSize (optional) 
     * @param pageNumber (optional) 
     * @param orderBy (optional) 
     * @param direction (optional) 
     * @return Success
     */
    getWeeklyTrendReportExcel(from: Date | undefined, to: Date | undefined, pageSize: number | undefined, pageNumber: number | undefined, orderBy: TrendBillingSortFieldEnum | undefined, direction: SortingEnum | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/backoffice/financialReports/weekly-trend-report/excel?";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (direction === null)
            throw new Error("The parameter 'direction' cannot be null.");
        else if (direction !== undefined)
            url_ += "Direction=" + encodeURIComponent("" + direction) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWeeklyTrendReportExcel(_response);
        });
    }

    protected processGetWeeklyTrendReportExcel(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Get trend billing by dates report paged
     * @param from (optional) 
     * @param to (optional) 
     * @param pageSize (optional) 
     * @param pageNumber (optional) 
     * @param orderBy (optional) 
     * @param direction (optional) 
     * @return Success
     */
    getTrendBillingByDatesReport(from: Date | undefined, to: Date | undefined, pageSize: number | undefined, pageNumber: number | undefined, orderBy: TrendBillingByDatesSortFieldEnum | undefined, direction: SortingEnum | undefined): Promise<TrendBillingByDatesPagedResponse> {
        let url_ = this.baseUrl + "/backoffice/financialReports/trend-report-by-dates?";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (direction === null)
            throw new Error("The parameter 'direction' cannot be null.");
        else if (direction !== undefined)
            url_ += "Direction=" + encodeURIComponent("" + direction) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTrendBillingByDatesReport(_response);
        });
    }

    protected processGetTrendBillingByDatesReport(response: Response): Promise<TrendBillingByDatesPagedResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TrendBillingByDatesPagedResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TrendBillingByDatesPagedResponse>(null as any);
    }

    /**
     * TrendReport by dates detail excel.
     * @param from (optional) 
     * @param to (optional) 
     * @param pageSize (optional) 
     * @param pageNumber (optional) 
     * @param orderBy (optional) 
     * @param direction (optional) 
     * @return Success
     */
    getTrendReportExcelByDates(from: Date | undefined, to: Date | undefined, pageSize: number | undefined, pageNumber: number | undefined, orderBy: TrendBillingByDatesSortFieldEnum | undefined, direction: SortingEnum | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/backoffice/financialReports/trend-report-by-dates/excel?";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (direction === null)
            throw new Error("The parameter 'direction' cannot be null.");
        else if (direction !== undefined)
            url_ += "Direction=" + encodeURIComponent("" + direction) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTrendReportExcelByDates(_response);
        });
    }

    protected processGetTrendReportExcelByDates(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Get trend mix billing report paged
     * @param from (optional) 
     * @param to (optional) 
     * @param pageSize (optional) 
     * @param pageNumber (optional) 
     * @param orderBy (optional) 
     * @param direction (optional) 
     * @return Success
     */
    getWeeklyTrendMixReport(from: Date | undefined, to: Date | undefined, pageSize: number | undefined, pageNumber: number | undefined, orderBy: string | undefined, direction: SortingEnum | undefined): Promise<TrendMixReportViewModel> {
        let url_ = this.baseUrl + "/backoffice/financialReports/trend-mix-report?";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (direction === null)
            throw new Error("The parameter 'direction' cannot be null.");
        else if (direction !== undefined)
            url_ += "Direction=" + encodeURIComponent("" + direction) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWeeklyTrendMixReport(_response);
        });
    }

    protected processGetWeeklyTrendMixReport(response: Response): Promise<TrendMixReportViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TrendMixReportViewModel;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TrendMixReportViewModel>(null as any);
    }

    /**
     * Get Trend - Weekly Profit by Customer paged
     * @param from (optional) 
     * @param to (optional) 
     * @param pageSize (optional) 
     * @param pageNumber (optional) 
     * @param orderBy (optional) 
     * @param direction (optional) 
     * @return Success
     */
    getWeeklyTrendProfitReport(from: Date | undefined, to: Date | undefined, pageSize: number | undefined, pageNumber: number | undefined, orderBy: string | undefined, direction: SortingEnum | undefined): Promise<TrendProfitReportViewModel> {
        let url_ = this.baseUrl + "/backoffice/financialReports/trend-weekly-profit-report?";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (direction === null)
            throw new Error("The parameter 'direction' cannot be null.");
        else if (direction !== undefined)
            url_ += "Direction=" + encodeURIComponent("" + direction) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWeeklyTrendProfitReport(_response);
        });
    }

    protected processGetWeeklyTrendProfitReport(response: Response): Promise<TrendProfitReportViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TrendProfitReportViewModel;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TrendProfitReportViewModel>(null as any);
    }

    /**
     * Trend - Weekly Profit by Customer detail excel.
     * @param from (optional) 
     * @param to (optional) 
     * @param pageSize (optional) 
     * @param pageNumber (optional) 
     * @param orderBy (optional) 
     * @param direction (optional) 
     * @return Success
     */
    getWeeklyTrendProfitReportExcel(from: Date | undefined, to: Date | undefined, pageSize: number | undefined, pageNumber: number | undefined, orderBy: string | undefined, direction: SortingEnum | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/backoffice/financialReports/trend-weekly-profit-report/excel?";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (direction === null)
            throw new Error("The parameter 'direction' cannot be null.");
        else if (direction !== undefined)
            url_ += "Direction=" + encodeURIComponent("" + direction) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWeeklyTrendProfitReportExcel(_response);
        });
    }

    protected processGetWeeklyTrendProfitReportExcel(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Get trend mix billing report detail excel.
     * @param from (optional) 
     * @param to (optional) 
     * @param pageSize (optional) 
     * @param pageNumber (optional) 
     * @param orderBy (optional) 
     * @param direction (optional) 
     * @return Success
     */
    getTrendMixBillingReportExcel(from: Date | undefined, to: Date | undefined, pageSize: number | undefined, pageNumber: number | undefined, orderBy: string | undefined, direction: SortingEnum | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/backoffice/financialReports/trend-mix-report/excel?";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (direction === null)
            throw new Error("The parameter 'direction' cannot be null.");
        else if (direction !== undefined)
            url_ += "Direction=" + encodeURIComponent("" + direction) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTrendMixBillingReportExcel(_response);
        });
    }

    protected processGetTrendMixBillingReportExcel(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Get billing and profit by customer report paged
     * @param from (optional) 
     * @param to (optional) 
     * @param pageSize (optional) 
     * @param pageNumber (optional) 
     * @param orderBy (optional) 
     * @param direction (optional) 
     * @return Success
     */
    getBillingAndProfitByCustomerReport(from: Date | undefined, to: Date | undefined, pageSize: number | undefined, pageNumber: number | undefined, orderBy: BillingAndProfitSortFieldEnum | undefined, direction: SortingEnum | undefined): Promise<BillingAndProfitByCustomerReportViewModel> {
        let url_ = this.baseUrl + "/backoffice/financialReports/billing-and-profit-by-customer-report?";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (direction === null)
            throw new Error("The parameter 'direction' cannot be null.");
        else if (direction !== undefined)
            url_ += "Direction=" + encodeURIComponent("" + direction) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBillingAndProfitByCustomerReport(_response);
        });
    }

    protected processGetBillingAndProfitByCustomerReport(response: Response): Promise<BillingAndProfitByCustomerReportViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BillingAndProfitByCustomerReportViewModel;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BillingAndProfitByCustomerReportViewModel>(null as any);
    }

    /**
     * Get billing and profit by customer report excel
     * @param from (optional) 
     * @param to (optional) 
     * @param pageSize (optional) 
     * @param pageNumber (optional) 
     * @param orderBy (optional) 
     * @param direction (optional) 
     * @return Success
     */
    getBillingAndProfitByCustomerReportExcel(from: Date | undefined, to: Date | undefined, pageSize: number | undefined, pageNumber: number | undefined, orderBy: BillingAndProfitSortFieldEnum | undefined, direction: SortingEnum | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/backoffice/financialReports/billing-and-profit-by-customer-report/excel?";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (direction === null)
            throw new Error("The parameter 'direction' cannot be null.");
        else if (direction !== undefined)
            url_ += "Direction=" + encodeURIComponent("" + direction) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBillingAndProfitByCustomerReportExcel(_response);
        });
    }

    protected processGetBillingAndProfitByCustomerReportExcel(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Get average rates by customer report paged
     * @param from (optional) 
     * @param to (optional) 
     * @param pageSize (optional) 
     * @param pageNumber (optional) 
     * @param orderBy (optional) 
     * @param direction (optional) 
     * @return Success
     */
    getAverageRatesByCustomerReport(from: Date | undefined, to: Date | undefined, pageSize: number | undefined, pageNumber: number | undefined, orderBy: AverageRatesSortFieldEnum | undefined, direction: SortingEnum | undefined): Promise<AverageRatesByCustomerReportViewModel> {
        let url_ = this.baseUrl + "/backoffice/financialReports/average-rates-by-customer-report?";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (direction === null)
            throw new Error("The parameter 'direction' cannot be null.");
        else if (direction !== undefined)
            url_ += "Direction=" + encodeURIComponent("" + direction) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAverageRatesByCustomerReport(_response);
        });
    }

    protected processGetAverageRatesByCustomerReport(response: Response): Promise<AverageRatesByCustomerReportViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AverageRatesByCustomerReportViewModel;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AverageRatesByCustomerReportViewModel>(null as any);
    }

    /**
     * Get average rates by customer report excel
     * @param from (optional) 
     * @param to (optional) 
     * @param pageSize (optional) 
     * @param pageNumber (optional) 
     * @param orderBy (optional) 
     * @param direction (optional) 
     * @return Success
     */
    getAverageRatesByCustomerExcel(from: Date | undefined, to: Date | undefined, pageSize: number | undefined, pageNumber: number | undefined, orderBy: AverageRatesSortFieldEnum | undefined, direction: SortingEnum | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/backoffice/financialReports/average-rates-by-customer-report/excel?";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (direction === null)
            throw new Error("The parameter 'direction' cannot be null.");
        else if (direction !== undefined)
            url_ += "Direction=" + encodeURIComponent("" + direction) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAverageRatesByCustomerExcel(_response);
        });
    }

    protected processGetAverageRatesByCustomerExcel(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Registration
     * @param body (optional) 
     * @return Success
     */
    createNewAccount(body: RegRecruiterModel | undefined): Promise<string> {
        let url_ = this.baseUrl + "/backoffice/account/registration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateNewAccount(_response);
        });
    }

    protected processCreateNewAccount(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Get my user profile
     * @return Success
     */
    getMyUserProfile(): Promise<BackofficeUserModel> {
        let url_ = this.baseUrl + "/backoffice/account/user/profile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMyUserProfile(_response);
        });
    }

    protected processGetMyUserProfile(response: Response): Promise<BackofficeUserModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BackofficeUserModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BackofficeUserModel>(null as any);
    }

    /**
     * Registration
     * @param body (optional) 
     * @return Success
     */
    createInvitedUserAccount(body: RegInvitedUserModel | undefined): Promise<string> {
        let url_ = this.baseUrl + "/backoffice/account/registration-invited-user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateInvitedUserAccount(_response);
        });
    }

    protected processCreateInvitedUserAccount(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Get Invited User Detail
     * @param email (optional) 
     * @return Success
     */
    getInvitedUserDetail(email: string | undefined): Promise<InvitedUserDetailEntity> {
        let url_ = this.baseUrl + "/backoffice/account/invited-user-detail?";
        if (email === null)
            throw new Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "Email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetInvitedUserDetail(_response);
        });
    }

    protected processGetInvitedUserDetail(response: Response): Promise<InvitedUserDetailEntity> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InvitedUserDetailEntity;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvitedUserDetailEntity>(null as any);
    }

    /**
     * Create initial profile
     * @param body (optional) 
     * @return Success
     */
    setupInitialProfile(body: InitialProfileRequestModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/account/initial-profile/setup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetupInitialProfile(_response);
        });
    }

    protected processSetupInitialProfile(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * HideUserPulsatingIndicator
     * @param body (optional) 
     * @return Success
     */
    hideUserPulsatingIndicator(body: BOUsersHideIndicatorModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/account/hide-user-pulsating-indicator";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHideUserPulsatingIndicator(_response);
        });
    }

    protected processHideUserPulsatingIndicator(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Update password
     * @return Success
     */
    updatePassword(body: UpdatePasswordRequestModel): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/account/update-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdatePassword(_response);
        });
    }

    protected processUpdatePassword(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Update two factor auth status
     * @return Success
     */
    updateTwoFactorAuthStatus(body: UpdateTwoFactorAuthStatusRequestModel): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/account/update-two-factor-auth-status";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateTwoFactorAuthStatus(_response);
        });
    }

    protected processUpdateTwoFactorAuthStatus(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get profile types
     * @return Success
     */
    getProfileTypes(): Promise<ProfileTypeEnum[]> {
        let url_ = this.baseUrl + "/backoffice/account/profile-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetProfileTypes(_response);
        });
    }

    protected processGetProfileTypes(response: Response): Promise<ProfileTypeEnum[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProfileTypeEnum[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProfileTypeEnum[]>(null as any);
    }

    /**
     * Send two factor auth code
     * @return Success
     */
    sendTwoFactorAuthCode(messageTypeEnum: TwoFactorAuthSendMessageTypeEnum): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/account/two-factor-auth/{messageTypeEnum}/send-code";
        if (messageTypeEnum === undefined || messageTypeEnum === null)
            throw new Error("The parameter 'messageTypeEnum' must be defined.");
        url_ = url_.replace("{messageTypeEnum}", encodeURIComponent("" + messageTypeEnum));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendTwoFactorAuthCode(_response);
        });
    }

    protected processSendTwoFactorAuthCode(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Summary tab. My customers.
     * @return Success
     */
    getMyCustomers(): Promise<SummaryCustomerResponseModel> {
        let url_ = this.baseUrl + "/backoffice/homepage/summary/customers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMyCustomers(_response);
        });
    }

    protected processGetMyCustomers(response: Response): Promise<SummaryCustomerResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SummaryCustomerResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SummaryCustomerResponseModel>(null as any);
    }

    /**
     * Summary tab. My customers detail.
     * @return Success
     */
    getMyCustomersDetail(pageNumber: number): Promise<SummaryCustomerDetailResponseModel> {
        let url_ = this.baseUrl + "/backoffice/homepage/summary/customers/detail?";
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMyCustomersDetail(_response);
        });
    }

    protected processGetMyCustomersDetail(response: Response): Promise<SummaryCustomerDetailResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SummaryCustomerDetailResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SummaryCustomerDetailResponseModel>(null as any);
    }

    /**
     * Summary tab. My active customers detail excel.
     * @return Success
     */
    getMyActiveCustomersDetailExcel(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/backoffice/homepage/summary/customers/active/detail/excel";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMyActiveCustomersDetailExcel(_response);
        });
    }

    protected processGetMyActiveCustomersDetailExcel(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Summary tab. My active assignments.
     * @return Success
     */
    getMyActiveAssignments(): Promise<SummaryAssignmentResponseModel> {
        let url_ = this.baseUrl + "/backoffice/homepage/summary/assignments/active";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMyActiveAssignments(_response);
        });
    }

    protected processGetMyActiveAssignments(response: Response): Promise<SummaryAssignmentResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SummaryAssignmentResponseModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SummaryAssignmentResponseModel>(null as any);
    }

    /**
     * Summary tab. My active assignments detail.
     * @param pageNumber (optional) 
     * @param assignmentTypes (optional) 
     * @return Success
     */
    getMyActiveAssignmentsDetail(pageNumber: number | undefined, assignmentTypes: AssignmentTypeFilterEnum[] | undefined): Promise<SummaryAssignmentDetailResponseModel> {
        let url_ = this.baseUrl + "/backoffice/homepage/summary/assignments/active/detail?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (assignmentTypes === null)
            throw new Error("The parameter 'assignmentTypes' cannot be null.");
        else if (assignmentTypes !== undefined)
            assignmentTypes && assignmentTypes.forEach(item => { url_ += "AssignmentTypes=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMyActiveAssignmentsDetail(_response);
        });
    }

    protected processGetMyActiveAssignmentsDetail(response: Response): Promise<SummaryAssignmentDetailResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SummaryAssignmentDetailResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SummaryAssignmentDetailResponseModel>(null as any);
    }

    /**
     * Summary tab. My active assignments detail excel.
     * @param assignmentTypes (optional) 
     * @return Success
     */
    getMyActiveAssignmentsDetailExcel(assignmentTypes: AssignmentTypeFilterEnum[] | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/backoffice/homepage/summary/assignments/active/detail/excel?";
        if (assignmentTypes === null)
            throw new Error("The parameter 'assignmentTypes' cannot be null.");
        else if (assignmentTypes !== undefined)
            assignmentTypes && assignmentTypes.forEach(item => { url_ += "assignmentTypes=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMyActiveAssignmentsDetailExcel(_response);
        });
    }

    protected processGetMyActiveAssignmentsDetailExcel(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Get summary weekly trend billing report
     * @param from (optional) 
     * @param to (optional) 
     * @param pageSize (optional) 
     * @param pageNumber (optional) 
     * @param orderBy (optional) 
     * @param direction (optional) 
     * @return Success
     */
    getSummaryWeeklyTrendBillingReport(from: Date | undefined, to: Date | undefined, pageSize: number | undefined, pageNumber: number | undefined, orderBy: TrendBillingSortFieldEnum | undefined, direction: SortingEnum | undefined): Promise<SummaryTrendBillingItemViewModel[]> {
        let url_ = this.baseUrl + "/backoffice/homepage/summary/weekly-trend-report?";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (direction === null)
            throw new Error("The parameter 'direction' cannot be null.");
        else if (direction !== undefined)
            url_ += "Direction=" + encodeURIComponent("" + direction) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSummaryWeeklyTrendBillingReport(_response);
        });
    }

    protected processGetSummaryWeeklyTrendBillingReport(response: Response): Promise<SummaryTrendBillingItemViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SummaryTrendBillingItemViewModel[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SummaryTrendBillingItemViewModel[]>(null as any);
    }

    /**
     * Get trend billing by dates report
     * @param from (optional) 
     * @param to (optional) 
     * @param pageSize (optional) 
     * @param pageNumber (optional) 
     * @param orderBy (optional) 
     * @param direction (optional) 
     * @return Success
     */
    getTrendBillingByDatesListReport(from: Date | undefined, to: Date | undefined, pageSize: number | undefined, pageNumber: number | undefined, orderBy: TrendBillingByDatesSortFieldEnum | undefined, direction: SortingEnum | undefined): Promise<SummaryTrendBillingByDatesItemViewModel[]> {
        let url_ = this.baseUrl + "/backoffice/homepage/summary/trend-report-by-dates?";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (direction === null)
            throw new Error("The parameter 'direction' cannot be null.");
        else if (direction !== undefined)
            url_ += "Direction=" + encodeURIComponent("" + direction) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTrendBillingByDatesListReport(_response);
        });
    }

    protected processGetTrendBillingByDatesListReport(response: Response): Promise<SummaryTrendBillingByDatesItemViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SummaryTrendBillingByDatesItemViewModel[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SummaryTrendBillingByDatesItemViewModel[]>(null as any);
    }

    /**
     * Get billing and profit by customer report
     * @param from (optional) 
     * @param to (optional) 
     * @param pageSize (optional) 
     * @param pageNumber (optional) 
     * @param orderBy (optional) 
     * @param direction (optional) 
     * @return Success
     */
    getBillingAndProfitByCustomerReportAll(from: Date | undefined, to: Date | undefined, pageSize: number | undefined, pageNumber: number | undefined, orderBy: BillingAndProfitSortFieldEnum | undefined, direction: SortingEnum | undefined): Promise<SummaryBillingAndProfitReportViewModel[]> {
        let url_ = this.baseUrl + "/backoffice/homepage/summary/billing-and-profit-by-customer-report?";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (direction === null)
            throw new Error("The parameter 'direction' cannot be null.");
        else if (direction !== undefined)
            url_ += "Direction=" + encodeURIComponent("" + direction) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBillingAndProfitByCustomerReportAll(_response);
        });
    }

    protected processGetBillingAndProfitByCustomerReportAll(response: Response): Promise<SummaryBillingAndProfitReportViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SummaryBillingAndProfitReportViewModel[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SummaryBillingAndProfitReportViewModel[]>(null as any);
    }

    /**
     * Get customer mix trend report
     * @param from (optional) 
     * @param to (optional) 
     * @param pageSize (optional) 
     * @param pageNumber (optional) 
     * @param orderBy (optional) 
     * @param direction (optional) 
     * @return Success
     */
    getSummaryCustomerMixTrendReport(from: Date | undefined, to: Date | undefined, pageSize: number | undefined, pageNumber: number | undefined, orderBy: string | undefined, direction: SortingEnum | undefined): Promise<SummaryTrendByCustomerReportViewModel[]> {
        let url_ = this.baseUrl + "/backoffice/homepage/summary/trend-mix-report?";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (direction === null)
            throw new Error("The parameter 'direction' cannot be null.");
        else if (direction !== undefined)
            url_ += "Direction=" + encodeURIComponent("" + direction) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSummaryCustomerMixTrendReport(_response);
        });
    }

    protected processGetSummaryCustomerMixTrendReport(response: Response): Promise<SummaryTrendByCustomerReportViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SummaryTrendByCustomerReportViewModel[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SummaryTrendByCustomerReportViewModel[]>(null as any);
    }

    /**
     * Get customer profit trend report
     * @param from (optional) 
     * @param to (optional) 
     * @param pageSize (optional) 
     * @param pageNumber (optional) 
     * @param orderBy (optional) 
     * @param direction (optional) 
     * @return Success
     */
    getSummaryCustomerProfitTrendReport(from: Date | undefined, to: Date | undefined, pageSize: number | undefined, pageNumber: number | undefined, orderBy: string | undefined, direction: SortingEnum | undefined): Promise<SummaryTrendByCustomerReportViewModel[]> {
        let url_ = this.baseUrl + "/backoffice/homepage/summary/trend-profit-report?";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (direction === null)
            throw new Error("The parameter 'direction' cannot be null.");
        else if (direction !== undefined)
            url_ += "Direction=" + encodeURIComponent("" + direction) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSummaryCustomerProfitTrendReport(_response);
        });
    }

    protected processGetSummaryCustomerProfitTrendReport(response: Response): Promise<SummaryTrendByCustomerReportViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SummaryTrendByCustomerReportViewModel[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SummaryTrendByCustomerReportViewModel[]>(null as any);
    }

    /**
     * Get preview trend weekly billing and profit report
     * @param pageNumber (optional) 
     * @param sortField (optional) 
     * @param sortType (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param fieldsFilter (optional) 
     * @return Success
     */
    getPreviewTrendWeeklyBillingAndProfitReport(pageNumber: number | undefined, sortField: FinancialReportSortFieldEnum | undefined, sortType: SortingEnum | undefined, startDate: Date | undefined, endDate: Date | undefined, fieldsFilter: FinancialReportFieldFilterModel[] | undefined): Promise<PreviewWeeklyBillingAndProfitReportViewModel[]> {
        let url_ = this.baseUrl + "/backoffice/homepage/preview/trend-weekly-billing-and-profit-report?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (sortField === null)
            throw new Error("The parameter 'sortField' cannot be null.");
        else if (sortField !== undefined)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (sortType === null)
            throw new Error("The parameter 'sortType' cannot be null.");
        else if (sortType !== undefined)
            url_ += "SortType=" + encodeURIComponent("" + sortType) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (fieldsFilter === null)
            throw new Error("The parameter 'fieldsFilter' cannot be null.");
        else if (fieldsFilter !== undefined)
            fieldsFilter && fieldsFilter.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "FieldsFilter[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPreviewTrendWeeklyBillingAndProfitReport(_response);
        });
    }

    protected processGetPreviewTrendWeeklyBillingAndProfitReport(response: Response): Promise<PreviewWeeklyBillingAndProfitReportViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PreviewWeeklyBillingAndProfitReportViewModel[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PreviewWeeklyBillingAndProfitReportViewModel[]>(null as any);
    }

    /**
     * Summary tab. My active assignments.
     * @return Success
     */
    getAssignmentsEndingSoon(): Promise<SummaryAssignmentEndingSoonResponseModel> {
        let url_ = this.baseUrl + "/backoffice/homepage/summary/assignments/ending-soon";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAssignmentsEndingSoon(_response);
        });
    }

    protected processGetAssignmentsEndingSoon(response: Response): Promise<SummaryAssignmentEndingSoonResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SummaryAssignmentEndingSoonResponseModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SummaryAssignmentEndingSoonResponseModel>(null as any);
    }

    /**
     * Summary tab. Assignments ending soon. Details.
     * @param pageNumber (optional) 
     * @param assignmentTypes (optional) 
     * @return Success
     */
    getAssignmentsEndingSoonDetail(pageNumber: number | undefined, assignmentTypes: AssignmentTypeFilterEnum[] | undefined): Promise<SummaryAssignmentDetailResponseModel> {
        let url_ = this.baseUrl + "/backoffice/homepage/summary/assignments/ending-soon/detail?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (assignmentTypes === null)
            throw new Error("The parameter 'assignmentTypes' cannot be null.");
        else if (assignmentTypes !== undefined)
            assignmentTypes && assignmentTypes.forEach(item => { url_ += "AssignmentTypes=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAssignmentsEndingSoonDetail(_response);
        });
    }

    protected processGetAssignmentsEndingSoonDetail(response: Response): Promise<SummaryAssignmentDetailResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SummaryAssignmentDetailResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SummaryAssignmentDetailResponseModel>(null as any);
    }

    /**
     * Summary tab. Ending-soon assignments detail excel.
     * @param assignmentTypes (optional) 
     * @return Success
     */
    getAssignmentsEndingSoonDetailExcel(assignmentTypes: AssignmentTypeFilterEnum[] | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/backoffice/homepage/summary/assignments/ending-soon/detail/excel?";
        if (assignmentTypes === null)
            throw new Error("The parameter 'assignmentTypes' cannot be null.");
        else if (assignmentTypes !== undefined)
            assignmentTypes && assignmentTypes.forEach(item => { url_ += "assignmentTypes=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAssignmentsEndingSoonDetailExcel(_response);
        });
    }

    protected processGetAssignmentsEndingSoonDetailExcel(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Timesheet status report.
     * @param pageSize (optional) 
     * @return Success
     */
    getTimesheetStatusReport(pageSize: number | undefined): Promise<TimesheetReportResponseModel> {
        let url_ = this.baseUrl + "/backoffice/homepage/summary/timesheet-status-report?";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTimesheetStatusReport(_response);
        });
    }

    protected processGetTimesheetStatusReport(response: Response): Promise<TimesheetReportResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TimesheetReportResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TimesheetReportResponseModel>(null as any);
    }

    /**
     * Timesheet status report. Table
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @param states (optional) 
     * @param customerIds (optional) 
     * @param workerIds (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param companyIds (optional) 
     * @return Success
     */
    getTimesheetStatusReportNotSubmittedDetails(pageNumber: number | undefined, pageSize: number | undefined, states: TimesheetStatusEnum[] | undefined, customerIds: string[] | undefined, workerIds: string[] | undefined, startDate: Date | undefined, endDate: Date | undefined, companyIds: string[] | undefined): Promise<TimesheetStatusReportDetailResponseModel> {
        let url_ = this.baseUrl + "/backoffice/homepage/summary/timesheet-status-report/detail?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (states === null)
            throw new Error("The parameter 'states' cannot be null.");
        else if (states !== undefined)
            states && states.forEach(item => { url_ += "States=" + encodeURIComponent("" + item) + "&"; });
        if (customerIds === null)
            throw new Error("The parameter 'customerIds' cannot be null.");
        else if (customerIds !== undefined)
            customerIds && customerIds.forEach(item => { url_ += "CustomerIds=" + encodeURIComponent("" + item) + "&"; });
        if (workerIds === null)
            throw new Error("The parameter 'workerIds' cannot be null.");
        else if (workerIds !== undefined)
            workerIds && workerIds.forEach(item => { url_ += "WorkerIds=" + encodeURIComponent("" + item) + "&"; });
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (companyIds === null)
            throw new Error("The parameter 'companyIds' cannot be null.");
        else if (companyIds !== undefined)
            companyIds && companyIds.forEach(item => { url_ += "CompanyIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTimesheetStatusReportNotSubmittedDetails(_response);
        });
    }

    protected processGetTimesheetStatusReportNotSubmittedDetails(response: Response): Promise<TimesheetStatusReportDetailResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TimesheetStatusReportDetailResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TimesheetStatusReportDetailResponseModel>(null as any);
    }

    /**
     * Timesheet status report excel
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @param states (optional) 
     * @param customerIds (optional) 
     * @param workerIds (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param companyIds (optional) 
     * @return Success
     */
    getTimesheetStatusReportDetailsExcel(pageNumber: number | undefined, pageSize: number | undefined, states: TimesheetStatusEnum[] | undefined, customerIds: string[] | undefined, workerIds: string[] | undefined, startDate: Date | undefined, endDate: Date | undefined, companyIds: string[] | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/backoffice/homepage/summary/timesheet-status-report/detail/excel?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (states === null)
            throw new Error("The parameter 'states' cannot be null.");
        else if (states !== undefined)
            states && states.forEach(item => { url_ += "States=" + encodeURIComponent("" + item) + "&"; });
        if (customerIds === null)
            throw new Error("The parameter 'customerIds' cannot be null.");
        else if (customerIds !== undefined)
            customerIds && customerIds.forEach(item => { url_ += "CustomerIds=" + encodeURIComponent("" + item) + "&"; });
        if (workerIds === null)
            throw new Error("The parameter 'workerIds' cannot be null.");
        else if (workerIds !== undefined)
            workerIds && workerIds.forEach(item => { url_ += "WorkerIds=" + encodeURIComponent("" + item) + "&"; });
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (companyIds === null)
            throw new Error("The parameter 'companyIds' cannot be null.");
        else if (companyIds !== undefined)
            companyIds && companyIds.forEach(item => { url_ += "CompanyIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTimesheetStatusReportDetailsExcel(_response);
        });
    }

    protected processGetTimesheetStatusReportDetailsExcel(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Send timesheet status report excel
     * @param body (optional) 
     * @return Success
     */
    sendTimesheetStatusReportDetailsExcel(body: SendTimesheetStatusReportDetailRequestModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/homepage/summary/timesheet-status-report/detail/send";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendTimesheetStatusReportDetailsExcel(_response);
        });
    }

    protected processSendTimesheetStatusReportDetailsExcel(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get preview aging summary report
     * @param pageNumber (optional) 
     * @param sortType (optional) 
     * @param sortField (optional) 
     * @param pageSize (optional) 
     * @return Success
     */
    getPreviewAgingSummaryReport(pageNumber: number | undefined, sortType: SortingEnum | undefined, sortField: AgingSummarySortFieldEnum | undefined, pageSize: number | undefined): Promise<PreviewAgingReport[]> {
        let url_ = this.baseUrl + "/backoffice/homepage/preview/aging-summary?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (sortType === null)
            throw new Error("The parameter 'sortType' cannot be null.");
        else if (sortType !== undefined)
            url_ += "SortType=" + encodeURIComponent("" + sortType) + "&";
        if (sortField === null)
            throw new Error("The parameter 'sortField' cannot be null.");
        else if (sortField !== undefined)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPreviewAgingSummaryReport(_response);
        });
    }

    protected processGetPreviewAgingSummaryReport(response: Response): Promise<PreviewAgingReport[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PreviewAgingReport[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PreviewAgingReport[]>(null as any);
    }

    /**
     * Get preview average rates by customer report paged
     * @param pageSize (optional) 
     * @param orderBy (optional) 
     * @param direction (optional) 
     * @return Success
     */
    getPreviewAverageRatesByCustomerReport(pageSize: number | undefined, orderBy: AverageRatesSortFieldEnum | undefined, direction: SortingEnum | undefined): Promise<AverageRatesByCustomerReportItemViewModel[]> {
        let url_ = this.baseUrl + "/backoffice/homepage/preview/average-rates-by-customer-report?";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (direction === null)
            throw new Error("The parameter 'direction' cannot be null.");
        else if (direction !== undefined)
            url_ += "Direction=" + encodeURIComponent("" + direction) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPreviewAverageRatesByCustomerReport(_response);
        });
    }

    protected processGetPreviewAverageRatesByCustomerReport(response: Response): Promise<AverageRatesByCustomerReportItemViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AverageRatesByCustomerReportItemViewModel[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AverageRatesByCustomerReportItemViewModel[]>(null as any);
    }

    /**
     * Import customer list from plain table
     * @param file (optional) 
     * @return Success
     */
    importCustomerListFromPlainTable(file: FileParameter | undefined): Promise<CreateCustomerRequest[]> {
        let url_ = this.baseUrl + "/backoffice/import/customer/upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processImportCustomerListFromPlainTable(_response);
        });
    }

    protected processImportCustomerListFromPlainTable(response: Response): Promise<CreateCustomerRequest[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateCustomerRequest[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateCustomerRequest[]>(null as any);
    }

    /**
     * Create a list of customers
     * @return Success
     */
    createCustomers(body: CreateCustomerRequest[]): Promise<BulkCustomerImportResponse[]> {
        let url_ = this.baseUrl + "/backoffice/import/customer/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateCustomers(_response);
        });
    }

    protected processCreateCustomers(response: Response): Promise<BulkCustomerImportResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkCustomerImportResponse[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkCustomerImportResponse[]>(null as any);
    }

    /**
     * Get template File
     * @return Success
     */
    getTemplateFile(typeEnum: FileTypeEnum): Promise<ResourceDownloadResponse> {
        let url_ = this.baseUrl + "/backoffice/import/download/template-file?";
        if (typeEnum === undefined || typeEnum === null)
            throw new Error("The parameter 'typeEnum' must be defined and cannot be null.");
        else
            url_ += "typeEnum=" + encodeURIComponent("" + typeEnum) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTemplateFile(_response);
        });
    }

    protected processGetTemplateFile(response: Response): Promise<ResourceDownloadResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResourceDownloadResponse;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResourceDownloadResponse>(null as any);
    }

    /**
     * InternalRecruiter
     * @param body (optional) 
     * @return Success
     */
    createNewInternalRecruiter(body: CreateInternalRecruiterModel | undefined): Promise<string> {
        let url_ = this.baseUrl + "/backoffice/internalRecruiter/internalRecruiter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateNewInternalRecruiter(_response);
        });
    }

    protected processCreateNewInternalRecruiter(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * InternalRecruiters
     * @param pageNumber (optional) 
     * @return Success
     */
    getInternalRecruiters(pageNumber: number | undefined): Promise<InternalRecruiterPagedResponseModel> {
        let url_ = this.baseUrl + "/backoffice/internalRecruiter/internalRecruiter-requests?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetInternalRecruiters(_response);
        });
    }

    protected processGetInternalRecruiters(response: Response): Promise<InternalRecruiterPagedResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InternalRecruiterPagedResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InternalRecruiterPagedResponseModel>(null as any);
    }

    /**
     * allinternalrecruiters
     * @return Success
     */
    getAllMyInternalRecruiters(): Promise<InternalRecruiterResponseModel[]> {
        let url_ = this.baseUrl + "/backoffice/internalRecruiter/allinternalrecruiters";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllMyInternalRecruiters(_response);
        });
    }

    protected processGetAllMyInternalRecruiters(response: Response): Promise<InternalRecruiterResponseModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InternalRecruiterResponseModel[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InternalRecruiterResponseModel[]>(null as any);
    }

    /**
     * Send question form
     * @param body (optional) 
     * @return No Content
     */
    sendQuestionForm(body: LandingPageQuestionForm | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/LandingPage/ask-question";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendQuestionForm(_response);
        });
    }

    protected processSendQuestionForm(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Send let us call you form
     * @param body (optional) 
     * @return No Content
     */
    sendLetUsCallYouForm(body: LandingPageQuestionForm | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/LandingPage/contact-us";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendLetUsCallYouForm(_response);
        });
    }

    protected processSendLetUsCallYouForm(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Increment profile type count statistics
     * @return No Content
     */
    incrementProfileTypeCount(profileType: LandingStatisticProfileType): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/LandingPage/profile-type/{profileType}";
        if (profileType === undefined || profileType === null)
            throw new Error("The parameter 'profileType' must be defined.");
        url_ = url_.replace("{profileType}", encodeURIComponent("" + profileType));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processIncrementProfileTypeCount(_response);
        });
    }

    protected processIncrementProfileTypeCount(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get all pay rate types
     * @return Success
     */
    getPayRateTypes(): Promise<PayRateTypeModel[]> {
        let url_ = this.baseUrl + "/backoffice/multirates/pay-rate-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPayRateTypes(_response);
        });
    }

    protected processGetPayRateTypes(response: Response): Promise<PayRateTypeModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PayRateTypeModel[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PayRateTypeModel[]>(null as any);
    }

    /**
     * Get all pay codes
     * @param payRateTypeId (optional) 
     * @return Success
     */
    getPayCodes(payRateTypeId: string | undefined): Promise<PayCodeModel[]> {
        let url_ = this.baseUrl + "/backoffice/multirates/pay-codes?";
        if (payRateTypeId === null)
            throw new Error("The parameter 'payRateTypeId' cannot be null.");
        else if (payRateTypeId !== undefined)
            url_ += "payRateTypeId=" + encodeURIComponent("" + payRateTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPayCodes(_response);
        });
    }

    protected processGetPayCodes(response: Response): Promise<PayCodeModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PayCodeModel[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PayCodeModel[]>(null as any);
    }

    /**
     * Get all assignments types pay codes
     * @return Success
     */
    getAssignmentTypesPayCode(): Promise<AssignmentsTypePayCodes[]> {
        let url_ = this.baseUrl + "/backoffice/multirates/assignments-pay-codes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAssignmentTypesPayCode(_response);
        });
    }

    protected processGetAssignmentTypesPayCode(response: Response): Promise<AssignmentsTypePayCodes[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AssignmentsTypePayCodes[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssignmentsTypePayCodes[]>(null as any);
    }

    /**
     * Get pay codes groups
     * @return Success
     */
    getPayCodeGroups(): Promise<PayCodesGroup[]> {
        let url_ = this.baseUrl + "/backoffice/multirates/pay-code-groups";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPayCodeGroups(_response);
        });
    }

    protected processGetPayCodeGroups(response: Response): Promise<PayCodesGroup[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PayCodesGroup[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PayCodesGroup[]>(null as any);
    }

    /**
     * Partner
     * @param body (optional) 
     * @return Success
     */
    createNewPartner(body: CreatePartnerModel | undefined): Promise<string> {
        let url_ = this.baseUrl + "/backoffice/partners";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateNewPartner(_response);
        });
    }

    protected processCreateNewPartner(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Requests statuses
     * @param pageNumber (optional) 
     * @return Success
     */
    getPartnerRequests(pageNumber: number | undefined): Promise<PartnerPagedResponseModel> {
        let url_ = this.baseUrl + "/backoffice/partners/requests?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPartnerRequests(_response);
        });
    }

    protected processGetPartnerRequests(response: Response): Promise<PartnerPagedResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PartnerPagedResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PartnerPagedResponseModel>(null as any);
    }

    /**
     * Requests statuses by status group
     * @param pageNumber (optional) 
     * @return Success
     */
    getPartnerRequestsByStatusGroup(pageNumber: number | undefined, statusGroup: PartnerStatusGroupFilterEnum): Promise<PartnerPagedResponseModel> {
        let url_ = this.baseUrl + "/backoffice/partners/status-group/{StatusGroup}?";
        if (statusGroup === undefined || statusGroup === null)
            throw new Error("The parameter 'statusGroup' must be defined.");
        url_ = url_.replace("{StatusGroup}", encodeURIComponent("" + statusGroup));
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPartnerRequestsByStatusGroup(_response);
        });
    }

    protected processGetPartnerRequestsByStatusGroup(response: Response): Promise<PartnerPagedResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PartnerPagedResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PartnerPagedResponseModel>(null as any);
    }

    /**
     * Get All My partners
     * @return Success
     */
    getAllMyPartnerRequests(): Promise<PartnerResponseModel[]> {
        let url_ = this.baseUrl + "/backoffice/partners/my-partners";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllMyPartnerRequests(_response);
        });
    }

    protected processGetAllMyPartnerRequests(response: Response): Promise<PartnerResponseModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PartnerResponseModel[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PartnerResponseModel[]>(null as any);
    }

    /**
     * Get info for Partner
     * @param partnerId Partner UUID
     * @return Success
     */
    getPartnerDetail(partnerId: string): Promise<PartnerResponseModel> {
        let url_ = this.baseUrl + "/backoffice/partners/{partnerId}/info";
        if (partnerId === undefined || partnerId === null)
            throw new Error("The parameter 'partnerId' must be defined.");
        url_ = url_.replace("{partnerId}", encodeURIComponent("" + partnerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPartnerDetail(_response);
        });
    }

    protected processGetPartnerDetail(response: Response): Promise<PartnerResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PartnerResponseModel;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PartnerResponseModel>(null as any);
    }

    /**
     * Get fill data for registration new account
     * @param partnerId Partner invited UUID
     * @return Success
     */
    getRegistrationDataForExternalPartnerInvitation(partnerId: string): Promise<PartnerResponseModel> {
        let url_ = this.baseUrl + "/backoffice/partners/external-invitations/{partnerId}/registration-data";
        if (partnerId === undefined || partnerId === null)
            throw new Error("The parameter 'partnerId' must be defined.");
        url_ = url_.replace("{partnerId}", encodeURIComponent("" + partnerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRegistrationDataForExternalPartnerInvitation(_response);
        });
    }

    protected processGetRegistrationDataForExternalPartnerInvitation(response: Response): Promise<PartnerResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PartnerResponseModel;
            return result200;
            });
        } else if (status === 418) {
            return response.text().then((_responseText) => {
            let result418: any = null;
            result418 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Client Error", status, _responseText, _headers, result418);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PartnerResponseModel>(null as any);
    }

    /**
     * Accept invite for existing partner
     * @param partnerId Partner invited UUID
     * @return Success
     */
    acceptExistingPartnerInvitation(partnerId: string): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/partners/external-invitations/{partnerId}/accept-invite";
        if (partnerId === undefined || partnerId === null)
            throw new Error("The parameter 'partnerId' must be defined.");
        url_ = url_.replace("{partnerId}", encodeURIComponent("" + partnerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAcceptExistingPartnerInvitation(_response);
        });
    }

    protected processAcceptExistingPartnerInvitation(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 406) {
            return response.text().then((_responseText) => {
            let result406: any = null;
            result406 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Acceptable", status, _responseText, _headers, result406);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets reports dates range info
     * @return Success
     */
    getReportsDatesRangeInfo(): Promise<ReportsDatesRangeInfoModel> {
        let url_ = this.baseUrl + "/backoffice/reports-features/date-range-info";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetReportsDatesRangeInfo(_response);
        });
    }

    protected processGetReportsDatesRangeInfo(response: Response): Promise<ReportsDatesRangeInfoModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportsDatesRangeInfoModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportsDatesRangeInfoModel>(null as any);
    }

    /**
     * Sets new dates for all company's reports
     * @param newEndDate (optional) 
     * @return No Content
     */
    setNewEndDateForReports(newEndDate: Date | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/reports-features/change-dates?";
        if (newEndDate === null)
            throw new Error("The parameter 'newEndDate' cannot be null.");
        else if (newEndDate !== undefined)
            url_ += "newEndDate=" + encodeURIComponent(newEndDate ? "" + newEndDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetNewEndDateForReports(_response);
        });
    }

    protected processSetNewEndDateForReports(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Create new Assignment
     * @return Success
     */
    createNewAssignment(body: AssignmentPrimaryDocumentEditModel): Promise<CreateAssignmentResponse> {
        let url_ = this.baseUrl + "/backoffice/assignments/requests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateNewAssignment(_response);
        });
    }

    protected processCreateNewAssignment(response: Response): Promise<CreateAssignmentResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateAssignmentResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationDetailsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateAssignmentResponse>(null as any);
    }

    /**
     * Assignment merge edit model
     * @return Success
     */
    getAssignmentEditModel(assignmentId: string): Promise<AssignmentEditUserResponseModel> {
        let url_ = this.baseUrl + "/backoffice/assignments/requests/{assignmentId}/edit";
        if (assignmentId === undefined || assignmentId === null)
            throw new Error("The parameter 'assignmentId' must be defined.");
        url_ = url_.replace("{assignmentId}", encodeURIComponent("" + assignmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAssignmentEditModel(_response);
        });
    }

    protected processGetAssignmentEditModel(response: Response): Promise<AssignmentEditUserResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AssignmentEditUserResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssignmentEditUserResponseModel>(null as any);
    }

    /**
     * Update Assignment primary document
     * @param assignmentId Assignment UUID
     * @return Success
     */
    updateAssignmentPrimaryDocument(assignmentId: string, body: AssignmentPrimaryDocumentEditModel): Promise<CreateAssignmentResponse> {
        let url_ = this.baseUrl + "/backoffice/assignments/requests/{assignmentId}";
        if (assignmentId === undefined || assignmentId === null)
            throw new Error("The parameter 'assignmentId' must be defined.");
        url_ = url_.replace("{assignmentId}", encodeURIComponent("" + assignmentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateAssignmentPrimaryDocument(_response);
        });
    }

    protected processUpdateAssignmentPrimaryDocument(response: Response): Promise<CreateAssignmentResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateAssignmentResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationDetailsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateAssignmentResponse>(null as any);
    }

    /**
     * Renew Assignment with changes
     * @return Success
     */
    renewAssignmentWithChanges(body: RenewAssignmentWithChangesRequest): Promise<CreateAssignmentResponse> {
        let url_ = this.baseUrl + "/backoffice/assignments/requests/renew/with-changes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRenewAssignmentWithChanges(_response);
        });
    }

    protected processRenewAssignmentWithChanges(response: Response): Promise<CreateAssignmentResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateAssignmentResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationDetailsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateAssignmentResponse>(null as any);
    }

    /**
     * Rehire Assignment with changes
     * @return Success
     */
    rehireAssignmentWithChanges(renewKind: RenewKindEnum, body: AssignmentPrimaryDocumentEditModel): Promise<CreateAssignmentResponse> {
        let url_ = this.baseUrl + "/backoffice/assignments/requests/rehire/with-changes?";
        if (renewKind === undefined || renewKind === null)
            throw new Error("The parameter 'renewKind' must be defined and cannot be null.");
        else
            url_ += "renewKind=" + encodeURIComponent("" + renewKind) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRehireAssignmentWithChanges(_response);
        });
    }

    protected processRehireAssignmentWithChanges(response: Response): Promise<CreateAssignmentResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateAssignmentResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationDetailsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateAssignmentResponse>(null as any);
    }

    /**
     * Renew Assignment without changes
     * @return Success
     */
    renewAssignmentWithoutChanges(body: RenewAssignmentModel): Promise<CreateAssignmentResponse> {
        let url_ = this.baseUrl + "/backoffice/assignments/requests/renew/without-changes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRenewAssignmentWithoutChanges(_response);
        });
    }

    protected processRenewAssignmentWithoutChanges(response: Response): Promise<CreateAssignmentResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateAssignmentResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationDetailsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateAssignmentResponse>(null as any);
    }

    /**
     * Migrate draft to request Assignment
     * @param assignmentId Assignment UUID
     * @return Success
     */
    migrateDraftAssignment(assignmentId: string, body: AssignmentPrimaryDocumentEditModel): Promise<CreateAssignmentResponse> {
        let url_ = this.baseUrl + "/backoffice/assignments/requests/{assignmentId}/from-draft";
        if (assignmentId === undefined || assignmentId === null)
            throw new Error("The parameter 'assignmentId' must be defined.");
        url_ = url_.replace("{assignmentId}", encodeURIComponent("" + assignmentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMigrateDraftAssignment(_response);
        });
    }

    protected processMigrateDraftAssignment(response: Response): Promise<CreateAssignmentResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateAssignmentResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationDetailsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateAssignmentResponse>(null as any);
    }

    /**
     * Get link and key for upload document file
     * @param document_ext Extension for file, one of [doc, docx, pdf, rtf]
     * @return Success
     */
    getStorageUploadDocumentLink(document_ext: string): Promise<S3UploadResponse> {
        let url_ = this.baseUrl + "/backoffice/storage/upload/document-file?";
        if (document_ext === undefined || document_ext === null)
            throw new Error("The parameter 'document_ext' must be defined and cannot be null.");
        else
            url_ += "document-ext=" + encodeURIComponent("" + document_ext) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetStorageUploadDocumentLink(_response);
        });
    }

    protected processGetStorageUploadDocumentLink(response: Response): Promise<S3UploadResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as S3UploadResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<S3UploadResponse>(null as any);
    }

    /**
     * Get link and key for upload document file
     * @param image_ext (optional) Extension for file, one of [jpg, jpeg, png]
     * @return Success
     */
    getStorageUploadImageLink(image_ext: string | undefined): Promise<S3UploadResponse> {
        let url_ = this.baseUrl + "/backoffice/storage/upload/image-file?";
        if (image_ext === null)
            throw new Error("The parameter 'image_ext' cannot be null.");
        else if (image_ext !== undefined)
            url_ += "image-ext=" + encodeURIComponent("" + image_ext) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetStorageUploadImageLink(_response);
        });
    }

    protected processGetStorageUploadImageLink(response: Response): Promise<S3UploadResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as S3UploadResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<S3UploadResponse>(null as any);
    }

    /**
     * GetTeammatesWithParent
     * @return Success
     */
    getTeammatesWithParent(): Promise<SelectTeammateViewModel[]> {
        let url_ = this.baseUrl + "/backoffice/account/teammates/teammates-with-parent";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTeammatesWithParent(_response);
        });
    }

    protected processGetTeammatesWithParent(response: Response): Promise<SelectTeammateViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SelectTeammateViewModel[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectTeammateViewModel[]>(null as any);
    }

    /**
     * Teammates
     * @param pageNumber (optional) 
     * @return Success
     */
    getTeammates(pageNumber: number | undefined): Promise<TeammateModelPagedResponseModel> {
        let url_ = this.baseUrl + "/backoffice/account/teammates?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTeammates(_response);
        });
    }

    protected processGetTeammates(response: Response): Promise<TeammateModelPagedResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TeammateModelPagedResponseModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TeammateModelPagedResponseModel>(null as any);
    }

    /**
     * Edit Teammate
     * @param body (optional) 
     * @return Success
     */
    editTeammate(body: UpdateTeammateModel | undefined): Promise<string> {
        let url_ = this.baseUrl + "/backoffice/account/teammates/edit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEditTeammate(_response);
        });
    }

    protected processEditTeammate(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Delete Teammate
     * @param body (optional) 
     * @return Success
     */
    deleteRegisteredTeammate(body: string | undefined): Promise<string> {
        let url_ = this.baseUrl + "/backoffice/account/teammates/delete-registered";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteRegisteredTeammate(_response);
        });
    }

    protected processDeleteRegisteredTeammate(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Delete Teammate
     * @param body (optional) 
     * @return Success
     */
    deleteUnregisteredTeammate(body: string | undefined): Promise<string> {
        let url_ = this.baseUrl + "/backoffice/account/teammates/delete-unregistered";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteUnregisteredTeammate(_response);
        });
    }

    protected processDeleteUnregisteredTeammate(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Set teammate is locked out
     * @return No Content
     */
    setTeammateIsLockedOut(teammateId: string, isLockedOut: boolean): Promise<string> {
        let url_ = this.baseUrl + "/backoffice/account/teammates/{teammateId}/is-locked/{isLockedOut}";
        if (teammateId === undefined || teammateId === null)
            throw new Error("The parameter 'teammateId' must be defined.");
        url_ = url_.replace("{teammateId}", encodeURIComponent("" + teammateId));
        if (isLockedOut === undefined || isLockedOut === null)
            throw new Error("The parameter 'isLockedOut' must be defined.");
        url_ = url_.replace("{isLockedOut}", encodeURIComponent("" + isLockedOut));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetTeammateIsLockedOut(_response);
        });
    }

    protected processSetTeammateIsLockedOut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            let result204: any = null;
            result204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result204;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Get userEmailSettingss for current member
     * @return Success
     */
    getUserEmailSettingsForCurrentMember(): Promise<UserEmailSettingsModel> {
        let url_ = this.baseUrl + "/backoffice/emailsettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUserEmailSettingsForCurrentMember(_response);
        });
    }

    protected processGetUserEmailSettingsForCurrentMember(response: Response): Promise<UserEmailSettingsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserEmailSettingsModel;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserEmailSettingsModel>(null as any);
    }

    /**
     * Update userEmailSettings
     * @return No Content
     */
    updateUserEmailSettings(body: UserEmailSettingsModel): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/emailsettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateUserEmailSettings(_response);
        });
    }

    protected processUpdateUserEmailSettings(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get all work codes simple list
     * @return Success
     */
    getAllWorkCodesSimpleList(): Promise<string[]> {
        let url_ = this.baseUrl + "/backoffice/work-codes/simple-list";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllWorkCodesSimpleList(_response);
        });
    }

    protected processGetAllWorkCodesSimpleList(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * Get all work codes
     * @return Success
     */
    getAllWorkCodes(): Promise<WorkCodeModel[]> {
        let url_ = this.baseUrl + "/backoffice/work-codes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllWorkCodes(_response);
        });
    }

    protected processGetAllWorkCodes(response: Response): Promise<WorkCodeModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkCodeModel[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkCodeModel[]>(null as any);
    }

    /**
     * Create new worker
     * @return Success
     */
    createNewWorker(body: CreateWorkerModel): Promise<CreateEntityResult> {
        let url_ = this.baseUrl + "/backoffice/workers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateNewWorker(_response);
        });
    }

    protected processCreateNewWorker(response: Response): Promise<CreateEntityResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateEntityResult;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateEntityResult>(null as any);
    }

    /**
     * Get workers for current member
     * @return Success
     */
    getWorkersForCurrentMember(): Promise<WorkerDetailViewModel[]> {
        let url_ = this.baseUrl + "/backoffice/workers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWorkersForCurrentMember(_response);
        });
    }

    protected processGetWorkersForCurrentMember(response: Response): Promise<WorkerDetailViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkerDetailViewModel[];
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkerDetailViewModel[]>(null as any);
    }

    /**
     * Get paged workers with details for current member
     * @param workerName (optional) 
     * @param pageNumber (optional) 
     * @return Success
     */
    getPagedWorkersForCurrentMember(workerName: string | undefined, pageNumber: number | undefined): Promise<WorkerItemDetailViewModelPagedResponseModel> {
        let url_ = this.baseUrl + "/backoffice/workers/paged?";
        if (workerName === null)
            throw new Error("The parameter 'workerName' cannot be null.");
        else if (workerName !== undefined)
            url_ += "workerName=" + encodeURIComponent("" + workerName) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPagedWorkersForCurrentMember(_response);
        });
    }

    protected processGetPagedWorkersForCurrentMember(response: Response): Promise<WorkerItemDetailViewModelPagedResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkerItemDetailViewModelPagedResponseModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkerItemDetailViewModelPagedResponseModel>(null as any);
    }

    /**
     * Get worker detail
     * @return Success
     */
    getWorkerDetailById(workerId: string): Promise<WorkerDetailViewModel> {
        let url_ = this.baseUrl + "/backoffice/workers/{workerId}";
        if (workerId === undefined || workerId === null)
            throw new Error("The parameter 'workerId' must be defined.");
        url_ = url_.replace("{workerId}", encodeURIComponent("" + workerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWorkerDetailById(_response);
        });
    }

    protected processGetWorkerDetailById(response: Response): Promise<WorkerDetailViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkerDetailViewModel;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkerDetailViewModel>(null as any);
    }

    /**
     * Update worker
     * @return No Content
     */
    updateWorker(workerId: string, body: CreateWorkerModel): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/workers/{workerId}";
        if (workerId === undefined || workerId === null)
            throw new Error("The parameter 'workerId' must be defined.");
        url_ = url_.replace("{workerId}", encodeURIComponent("" + workerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateWorker(_response);
        });
    }

    protected processUpdateWorker(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get worker detail
     * @return Success
     */
    getWorkerDetailByKey(workerKey: string): Promise<WorkerDetailExtendedViewModel> {
        let url_ = this.baseUrl + "/backoffice/workers/{workerKey}";
        if (workerKey === undefined || workerKey === null)
            throw new Error("The parameter 'workerKey' must be defined.");
        url_ = url_.replace("{workerKey}", encodeURIComponent("" + workerKey));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWorkerDetailByKey(_response);
        });
    }

    protected processGetWorkerDetailByKey(response: Response): Promise<WorkerDetailExtendedViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkerDetailExtendedViewModel;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkerDetailExtendedViewModel>(null as any);
    }

    /**
     * Get workers for timesheet status report
     * @return Success
     */
    getWorkersForTimesheetStatusReport(): Promise<WorkerSearchResponseModel[]> {
        let url_ = this.baseUrl + "/backoffice/workers/timesheet-status-report";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWorkersForTimesheetStatusReport(_response);
        });
    }

    protected processGetWorkersForTimesheetStatusReport(response: Response): Promise<WorkerSearchResponseModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkerSearchResponseModel[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkerSearchResponseModel[]>(null as any);
    }

    /**
     * Get Worker file
     * @param workerId (optional) 
     * @return Success
     */
    getWorkerFile(workerId: string | undefined): Promise<ResourceDownloadResponse> {
        let url_ = this.baseUrl + "/backoffice/workers/download/worker-file?";
        if (workerId === null)
            throw new Error("The parameter 'workerId' cannot be null.");
        else if (workerId !== undefined)
            url_ += "workerId=" + encodeURIComponent("" + workerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWorkerFile(_response);
        });
    }

    protected processGetWorkerFile(response: Response): Promise<ResourceDownloadResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResourceDownloadResponse;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResourceDownloadResponse>(null as any);
    }

    /**
     * Get link and key for upload worker file
     * @param document_ext Extension for file, one of [doc, docx, pdf, rtf]
     * @param workerId (optional) 
     * @return Success
     */
    getWorkerFileUploadLink(document_ext: string, workerId: string | undefined): Promise<S3UploadResponse> {
        let url_ = this.baseUrl + "/backoffice/workers/upload/worker-file?";
        if (document_ext === undefined || document_ext === null)
            throw new Error("The parameter 'document_ext' must be defined and cannot be null.");
        else
            url_ += "document-ext=" + encodeURIComponent("" + document_ext) + "&";
        if (workerId === null)
            throw new Error("The parameter 'workerId' cannot be null.");
        else if (workerId !== undefined)
            url_ += "workerId=" + encodeURIComponent("" + workerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWorkerFileUploadLink(_response);
        });
    }

    protected processGetWorkerFileUploadLink(response: Response): Promise<S3UploadResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as S3UploadResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<S3UploadResponse>(null as any);
    }

    /**
     * Get worker lookups
     * @return Success
     */
    getWorkerLookups(): Promise<WorkerSearchResponseModel[]> {
        let url_ = this.baseUrl + "/backoffice/workers/lookup";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWorkerLookups(_response);
        });
    }

    protected processGetWorkerLookups(response: Response): Promise<WorkerSearchResponseModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkerSearchResponseModel[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkerSearchResponseModel[]>(null as any);
    }
}

export enum AbilityToPayEnum {
    DoNotKnow = 0,
    Low = 10,
    Fair = 20,
    High = 30,
}

export interface AdditionalInfoModel {
    potentialHeadcount?: CustomerSizeEnum;
    averageBillRate?: number | undefined;
    estimatedValue?: number | undefined;
    estimatedType?: DurationTypeEnum;
    industryName?: string | undefined;
    haveBusinessBefore?: boolean;
    yearsInBusiness?: YearsInBusinessEnum;
    abilityToPay?: AbilityToPayEnum;
}

export enum AgingDetailDateRangeTypeEnum {
    MoreThen0 = 0,
    LessThan30 = 1,
    MoreThan30 = 30,
    MoreThan60 = 60,
    MoreThan90 = 90,
}

export interface AgingDetailPagedResponse {
    customerKey?: string | undefined;
    customerCompanyName?: string | undefined;
    terms?: string | undefined;
    totalBalance?: string | undefined;
    lastSyncDate?: Date;
    totalCount?: number;
    pageNumber?: number;
    details?: AgingDetailReport[] | undefined;
}

export interface AgingDetailReport {
    workerName?: string | undefined;
    invoice?: string | undefined;
    invDate?: Date;
    dueDate?: Date | undefined;
    age?: number;
    balance?: string | undefined;
}

export interface AgingDetailTotalViewModel {
    customerKey?: string | undefined;
    customerCompanyName?: string | undefined;
    terms?: string | undefined;
    workerName?: string | undefined;
    invoice?: string | undefined;
    invDate?: Date;
    dueDate?: Date | undefined;
    age?: number;
    balance?: string | undefined;
}

export interface AgingSummaryReport {
    customerKey?: string | undefined;
    customerCompanyName?: string | undefined;
    terms?: string | undefined;
    lessThan30Balance?: string | undefined;
    moreThan30Balance?: string | undefined;
    moreThan60Balance?: string | undefined;
    moreThan90Balance?: string | undefined;
    totalBalance?: string | undefined;
}

export interface AgingSummaryReportPagedResponse {
    totalLessThan30Balance?: string | undefined;
    totalMoreThan30Balance?: string | undefined;
    totalMoreThan60Balance?: string | undefined;
    totalMoreThan90Balance?: string | undefined;
    totalBalance?: string | undefined;
    lastSyncDate?: Date;
    totalCount?: number;
    pageNumber?: number;
    details?: AgingSummaryReport[] | undefined;
}

export enum AgingSummarySortFieldEnum {
    Customer = 1,
}

export interface AgingTotalInfoViewModel {
    totalBalance?: string | undefined;
    lastSyncDate?: Date;
    totalCount?: number;
    pageNumber?: number;
    details?: AgingDetailTotalViewModel[] | undefined;
}

export enum AnticipatedScheduleTypeEnum {
    NotKnown = 0,
    From0800AmTo0500Pm = 1,
    From0700AmTo0400Pm = 2,
    From0900AmTo0600Pm = 3,
    NineEighty = 4,
    FourTen = 5,
    Other = 1024,
}

export interface AssignmentAdditionalInfoModel {
    assignmentId?: string;
    assignmetnKey?: string | undefined;
    assignmentType?: AssignmentTypeEnum;
    additionalInfo?: AssignmentAdminAdditionalInfoModel;
    contractorQuestionnaire?: AssignmentQuestionnaireInfoModel;
    memberQuestionnaire?: AssignmentQuestionnaireInfoModel;
}

export interface AssignmentAdditionalInfoReplyRequestModel {
    additionalInfoReply: string;
    currentStage: AssignmentStageEnum;
    assignmentId: string;
}

export interface AssignmentAdminAdditionalInfoModel {
    markup?: number | undefined;
    grossMarginPerHour?: number | undefined;
    grossMarginPercent?: number | undefined;
    anticipatedWeeklyCommission?: number | undefined;
    confirmationCommissionStructure?: boolean | undefined;
}

export interface AssignmentAnticipatedScheduleEditModel {
    fromTime?: TimePointEnum;
    fromAMPM?: TimeAMPMEnum;
    toTime?: TimePointEnum;
    toAMPM?: TimeAMPMEnum;
}

export interface AssignmentAnticipatedScheduleViewModel {
    fromTime?: TimePointEnum;
    fromAMPM?: TimeAMPMEnum;
    toTime?: TimePointEnum;
    toAMPM?: TimeAMPMEnum;
}

export interface AssignmentBillingContactEditModel {
    contactId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
}

export interface AssignmentBillingContactViewModel {
    id?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
}

export interface AssignmentBullhornViewModel {
    id?: string;
    candidateName?: string | undefined;
    clientCompany?: string | undefined;
    assignmentType?: AssignmentTypeEnum;
    startDate?: Date | undefined;
    payRate?: number | undefined;
    billRate?: number | undefined;
    assignmentId?: string | undefined;
    assignmentKey?: string | undefined;
    companyAssignemntsKey?: string[] | undefined;
    createdDate?: Date;
}

export interface AssignmentBullhornViewModelPagedResponseModel {
    totalCount?: number;
    pageNumber?: number;
    details?: AssignmentBullhornViewModel[] | undefined;
}

export enum AssignmentCategoryEnum {
    Recruiter = 1,
    Corporate = 2,
}

export interface AssignmentContactPersonEditModel {
    contactId?: string | undefined;
    title?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
}

export interface AssignmentContactPersonViewModel {
    id?: string | undefined;
    title?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
}

export interface AssignmentContractorCompanyInfoEditModel {
    companyId?: string | undefined;
    representativeContact?: BaseEmployeeModel;
    companyName?: string | undefined;
    location?: LocationModel;
    workerFile?: ResourceDownloadResponse;
}

export interface AssignmentContractorCompanyInfoViewModel {
    companyId?: string | undefined;
    companyKey?: string | undefined;
    companyName?: string | undefined;
    representativeContact?: BaseEmployeeModel;
    location?: LocationViewModel;
    isDuplicated?: boolean;
    workerFile?: ResourceDownloadResponse;
}

export interface AssignmentCustomerViewModel {
    customerId?: string | undefined;
    customerKey?: string | undefined;
    companyName?: string | undefined;
    additionalInvoiceName?: string | undefined;
    companyWebSite?: string | undefined;
    mspFee?: number | undefined;
    vmsFee?: number | undefined;
    breakInService?: BreakInServiceEnum;
}

export interface AssignmentEditUserResponseModel {
    assignmentId?: string;
    assignmentStatus?: AssignmentStatusTypeEnum;
    assignmentType?: AssignmentTypeEnum;
    assignmentCategory?: AssignmentCategoryEnum;
    assignmentStage?: AssignmentStageEnum;
    createdDate?: Date;
    updatedDate?: Date;
    assignmentTeammates?: AssignmentTeammateSelectModel[] | undefined;
    assignmentDocument?: AssignmentPrimaryDocumentEditModel;
}

export interface AssignmentFinancialInfoEditModel {
    payType?: PayTypeEnum;
    payRate?: number | undefined;
    billRate?: number | undefined;
    dtPayRate?: number | undefined;
    dtBillRate?: number | undefined;
    profitRate?: number | undefined;
    overtime?: OvertimeEnum;
    overtimePayRate?: number | undefined;
    overtimeBillRate?: number | undefined;
    mbpRate?: number | undefined;
    vmsFee?: number | undefined;
    vmsFeeIsOverridden?: boolean;
    mspFee?: number | undefined;
    mspFeeIsOverridden?: boolean;
}

export interface AssignmentFinancialInfoViewModel {
    payType?: PayTypeEnum;
    payRate?: number | undefined;
    billRate?: number | undefined;
    dtPayRate?: number | undefined;
    dtBillRate?: number | undefined;
    profitRate?: number | undefined;
    overtime?: OvertimeEnum;
    overtimePayRate?: number | undefined;
    overtimeBillRate?: number | undefined;
    mbpRate?: number | undefined;
    vmsFee?: number | undefined;
    vmsFeeIsOverridden?: boolean;
    mspFee?: number | undefined;
    mspFeeIsOverridden?: boolean;
}

export interface AssignmentFinancialSchedulerEditModel {
    effectiveDate?: Date;
    financialInfoScheduler?: FinancialInfoSchedulerEditModel;
    multiRateSchedulers?: MultiRateSchedulerEditModel[] | undefined;
}

export interface AssignmentFinancialSchedulerViewModel {
    effectiveDate?: Date;
    isSyncedOnNetSuite?: boolean;
    financialInfoScheduler?: FinancialInfoSchedulerViewModel;
    multiRateSchedulers?: MultiRateSchedulerViewModel[] | undefined;
}

export interface AssignmentHideIndicatorModel {
    assignmentId?: string;
    currentStage?: AssignmentStageEnum;
}

export interface AssignmentHistoryDetailsModel {
    oldData?: AssignmentHistoryResponse;
    newData?: AssignmentHistoryResponse;
}

export interface AssignmentHistoryResponse {
    w9FormFileName?: string | undefined;
    w9FormFileKey?: string | undefined;
    additionalInfo?: AssignmentAdminAdditionalInfoModel;
    assignmentStatus?: AssignmentStatusTypeEnum;
    stageStatus?: StageStatusEnum;
    status?: AssignmentStageEnum;
    priceAgreement?: BOUsersPriceAgreementRespModel;
    mspOrVmsOverviewInfo?: CustomerMspOrVmsOverviewDto;
    assignmentIsDraft?: boolean;
    assignmentType: AssignmentTypeEnum;
    assignmentCategory: AssignmentCategoryEnum;
    customerId?: string | undefined;
    customerCompanyName?: string | undefined;
    customerAdditionalInvoiceName?: string | undefined;
    assignmentTeammates?: AssignmentTeammateSelectModel[] | undefined;
    workerInfo?: AssignmentWorkerInfoEditModel;
    contractorCompanyInfo?: AssignmentContractorCompanyInfoEditModel;
    assignmentInfo?: AssignmentInfoEditModel;
    financialInfo?: AssignmentFinancialInfoEditModel;
    bestPrimaryContacts?: AssignmentContactPersonEditModel[] | undefined;
    bestBillingContacts?: AssignmentBillingContactEditModel[] | undefined;
    supervisorInfo?: AssignmentSupervisorInfoEditModel;
    timesheetApproverNotApplicable?: boolean;
    timesheetApproverSameAsSupervisor?: boolean;
    timesheetApproverInfo?: AssignmentTimesheetApproverInfoViewModel;
    additionalTimesheetApprovers?: AssignmentTimesheetApproverInfoViewModel[] | undefined;
    timesheetBackupApproverInfo?: AssignmentTimesheetBackupApproverInfoViewModel;
    workSameAsHomeOrBusinessLocation?: boolean;
    workLocation?: LocationModel;
    billingSameAsWorkLocation?: boolean;
    billingLocation?: LocationModel;
    billingEmail?: string | undefined;
    splitPartnerInfo?: AssignmentSplitHistoryModel;
    partnerDraft?: AssignmentPartnerDraftModel;
    renewType?: RenewAssignmentEnum;
    parentAssignmentId?: string | undefined;
    isNeedCreateTemplate?: boolean;
    templateName?: string | undefined;
    multiRates?: AssignmentMultiRateEditModel[] | undefined;
    financialScheduler?: AssignmentFinancialSchedulerEditModel;
    termination?: AssignmentHistoryTerminationViewModel;
    assignmentRenewHistoryModel?: AssignmentRenewHistoryModel;
}

export interface AssignmentHistoryTerminationViewModel {
    terminationDate?: Date;
    terminationReason?: AssignmentTerminationReasonTypeEnum;
    eligibleForRehire?: boolean;
    details?: string | undefined;
    attachments?: NamedAttachmentModel[] | undefined;
}

export interface AssignmentInfoEditModel {
    jobTitle?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    jobDescription?: string | undefined;
    workFromHome?: WorkFromHomeEnum;
    preScreeningRequired?: boolean;
    preScreeningBilledTo?: PreScreeningBilledToEnum;
    jobCategory?: JobCategoryEnum;
    workCode?: string | undefined;
    employmentType?: EmploymentTypeEnum;
    anticipatedScheduleType?: AnticipatedScheduleTypeEnum;
    anticipatedSchedule?: AssignmentAnticipatedScheduleEditModel;
    specialInstructions?: string | undefined;
    customerPurchaseOrder?: string | undefined;
    attachments?: NamedAttachmentModel[] | undefined;
}

export interface AssignmentInfoUserResponseModel {
    isAdditionalInfoExists?: boolean;
    assignmentId?: string;
    assignmentKey?: string | undefined;
    assignmentStatus?: AssignmentStatusTypeEnum;
    assignmentType?: AssignmentTypeEnum;
    assignmentCategory?: AssignmentCategoryEnum;
    assignmentStage?: AssignmentStageEnum;
    stageStatus?: StageStatusEnum;
    createdDate?: Date;
    updatedDate?: Date;
    memberId?: string;
    memberKey?: string | undefined;
    memberCompanyName?: string | undefined;
    stages?: AssignmentStageModel[] | undefined;
    assignmentDocument?: AssignmentPrimaryDocumentViewModel;
    creator?: CreatorUserModel;
    questionnaireInfo?: AssignmentQuestionnaireInfoModel;
    contractorQuestionnaireInfo?: AssignmentQuestionnaireInfoModel;
    customerInfo?: AssignmentCustomerViewModel;
    partnerInfo?: AssignmentPartnerViewModel;
    renewType?: RenewAssignmentEnum;
    renewKind?: RenewKindEnum;
    parentAssignmentId?: string | undefined;
    renewStatus?: RenewStatusEnum;
    availableRenewOptions?: AvailableRenewOptionsEnum;
    isWorkerDuplicated?: boolean;
    childAssignmentId?: string | undefined;
    childAssignmentKey?: string | undefined;
    parentAssignmentKey?: string | undefined;
    financialScheduler?: AssignmentFinancialSchedulerEditModel;
    assignmentTeammates?: AssignmentTeammateSelectModel[] | undefined;
    companyId?: string;
}

export interface AssignmentInfoViewModel {
    jobTitle?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    jobDescription?: string | undefined;
    workFromHome?: WorkFromHomeEnum;
    preScreeningRequired?: boolean;
    preScreeningBilledTo?: PreScreeningBilledToEnum;
    jobCategory?: JobCategoryEnum;
    workCode?: string | undefined;
    employmentType?: EmploymentTypeEnum;
    anticipatedScheduleType?: AnticipatedScheduleTypeEnum;
    anticipatedSchedule?: AssignmentAnticipatedScheduleViewModel;
    specialInstructions?: string | undefined;
    customerPurchaseOrder?: string | undefined;
    attachments?: NamedAttachmentModel[] | undefined;
}

export interface AssignmentLocationWithActualStateModel {
    isShowStatePriceAgreementWarning?: boolean;
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    stateId?: number | undefined;
    zipCode?: string | undefined;
    countryId?: number | undefined;
    country?: string | undefined;
    countryCode?: string | undefined;
    internationalCityName?: string | undefined;
    internationalStateName?: string | undefined;
}

export interface AssignmentMultiRateEditModel {
    id?: string | undefined;
    payType?: MultiRateEnum;
    specialInstructions?: string | undefined;
    memberBilledIndicator?: boolean;
    payCodeId?: string;
    payRate?: number | undefined;
    billRate?: number | undefined;
    hasPayRateCustomLogic?: boolean;
    hasBillRateCustomLogic?: boolean;
}

export interface AssignmentMultiRateViewModel {
    id?: string | undefined;
    payType?: MultiRateEnum;
    payRate?: number | undefined;
    billRate?: number | undefined;
    hasPayRateCustomLogic?: boolean;
    hasBillRateCustomLogic?: boolean;
    specialInstructions?: string | undefined;
    memberBilledIndicator?: boolean;
    payCodeId?: string;
}

export interface AssignmentPartnerDraftModel {
    companyName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    companyEIN?: string | undefined;
    subcontractorRate?: number | undefined;
    address?: string | undefined;
    city?: string | undefined;
    stateId?: number | undefined;
    countryId?: number | undefined;
    internationalCityName?: string | undefined;
    internationalStateName?: string | undefined;
    zipCode?: string | undefined;
}

export interface AssignmentPartnerViewModel {
    partnerId?: string | undefined;
    companyName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    partnerStatus?: PartnerStatusEnum;
    invitedCompanyId?: string | undefined;
}

export interface AssignmentPrimaryDocumentEditModel {
    assignmentIsDraft?: boolean;
    assignmentType: AssignmentTypeEnum;
    assignmentCategory: AssignmentCategoryEnum;
    customerId?: string | undefined;
    customerCompanyName?: string | undefined;
    customerAdditionalInvoiceName?: string | undefined;
    assignmentTeammates?: AssignmentTeammatesEditModel[] | undefined;
    workerInfo?: AssignmentWorkerInfoEditModel;
    contractorCompanyInfo?: AssignmentContractorCompanyInfoEditModel;
    assignmentInfo?: AssignmentInfoEditModel;
    financialInfo?: AssignmentFinancialInfoEditModel;
    bestPrimaryContacts?: AssignmentContactPersonEditModel[] | undefined;
    bestBillingContacts?: AssignmentBillingContactEditModel[] | undefined;
    supervisorInfo?: AssignmentSupervisorInfoEditModel;
    timesheetApproverNotApplicable?: boolean;
    timesheetApproverSameAsSupervisor?: boolean;
    timesheetApproverInfo?: AssignmentTimesheetApproverInfoEditModel;
    additionalTimesheetApprovers?: AssignmentTimesheetApproverInfoEditModel[] | undefined;
    timesheetBackupApproverInfo?: AssignmentTimesheetBackupApproverInfoEditModel;
    workSameAsHomeOrBusinessLocation?: boolean;
    workLocation?: LocationModel;
    billingSameAsWorkLocation?: boolean;
    billingLocation?: LocationModel;
    billingEmail?: string | undefined;
    splitInfo?: AssignmentSplitInfoEditModel;
    partnerDraft?: AssignmentPartnerDraftModel;
    renewType?: RenewAssignmentEnum;
    renewKind?: RenewKindEnum;
    parentAssignmentId?: string | undefined;
    isNeedCreateTemplate?: boolean;
    templateName?: string | undefined;
    multiRates?: AssignmentMultiRateEditModel[] | undefined;
    financialScheduler?: AssignmentFinancialSchedulerEditModel;
}

export interface AssignmentPrimaryDocumentViewModel {
    assignmentType: AssignmentTypeEnum;
    assignmentCategory: AssignmentCategoryEnum;
    customerId?: string | undefined;
    workerInfo?: AssignmentWorkerInfoViewModel;
    companyInfo?: AssignmentContractorCompanyInfoViewModel;
    assignmentInfo: AssignmentInfoViewModel;
    financialInfo: AssignmentFinancialInfoViewModel;
    bestPrimaryContacts: AssignmentContactPersonViewModel[];
    bestBillingContacts: AssignmentBillingContactViewModel[];
    multiRates: AssignmentMultiRateViewModel[];
    financialScheduler?: AssignmentFinancialSchedulerViewModel;
    supervisorInfo: AssignmentSupervisorInfoViewModel;
    timesheetApproverNotApplicable?: boolean;
    timesheetApproverSameAsSupervisor?: boolean;
    timesheetApproverInfo?: AssignmentTimesheetApproverInfoViewModel;
    timesheetBackupApproverInfo?: AssignmentTimesheetBackupApproverInfoViewModel;
    additionalTimesheetApprovers?: AssignmentTimesheetApproverInfoViewModel[] | undefined;
    workSameAsHomeOrBusinessLocation?: boolean;
    workLocation: LocationViewModel;
    billingSameAsWorkLocation?: boolean;
    billingLocation: LocationViewModel;
    billingEmail?: string | undefined;
    splitInfo?: AssignmentSplitInfoViewModel;
}

export interface AssignmentQuestionnaireInfoModel {
    ongoingTrainingRequired?: QuestionnaireModel;
    customerControl?: QuestionnaireModel;
    clockInOrOutDictated?: QuestionnaireModel;
    supervisionOfWorker?: QuestionnaireModel;
    suppliesProvision?: QuestionnaireModel;
    businessExpensesReimbursed?: QuestionnaireModel;
    specializedSkillsetEmployeeAvailbility?: QuestionnaireModel;
    servicesAreKeyAspectOfBM?: QuestionnaireModel;
    workerPerformedSimilarServices?: QuestionnaireModel;
    servicesAdvertisedByWorker?: QuestionnaireModel;
}

export enum AssignmentRateTypeEnum {
    Percent = 1,
    Money = 2,
}

export interface AssignmentRenewHistoryModel {
    assignmentId?: string;
    renewType?: RenewAssignmentEnum;
    renewKind?: RenewKindEnum;
    action?: RenewActionEnum;
}

export interface AssignmentSplitHistoryModel {
    splitType?: SplitTypeEnum;
    partnerId?: string | undefined;
    splitPercent?: number | undefined;
    splitAmount?: number | undefined;
    companyName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    companyEIN?: string | undefined;
    subcontractorRate?: number | undefined;
    address?: string | undefined;
    city?: string | undefined;
    stateId?: number | undefined;
    state?: string | undefined;
    country?: string | undefined;
    internationalCityName?: string | undefined;
    internationalStateName?: string | undefined;
    zipCode?: string | undefined;
}

export interface AssignmentSplitInfoEditModel {
    splitType?: SplitTypeEnum;
    partnerId?: string | undefined;
    splitPercent?: number | undefined;
    splitAmount?: number | undefined;
}

export interface AssignmentSplitInfoViewModel {
    splitType?: SplitTypeEnum;
    partnerId?: string | undefined;
    splitPercent?: number | undefined;
    splitAmount?: number | undefined;
}

export enum AssignmentStageEnum {
    Pending = 1,
    EECandidateSentOnboarding = 21,
    EERatesAndCustomerReviewed = 41,
    EECandidateCompletedOnboarding = 61,
    EEOnboardingPackageVerified = 81,
    EEPreScreeningValidating = 101,
    EEPreScreeningCompleted = 121,
    EETimesheetAccountCreated = 141,
    EEAssignmentConfirmed = 161,
    ICMemberQuestionnaire = 179,
    ICMemberQuestionnaireComplete = 181,
    ICRatesAndCustomerReviewed = 201,
    ICContractorQuestionnaire = 219,
    ICContractorQuestionnaireComplete = 221,
    ICContractorChecklistVerified = 241,
    ICContractorSentPackage = 261,
    ICAcquiringApplicableInsurances = 281,
    ICPreScreeningValidating = 301,
    ICPreScreeningCompleted = 321,
    ICVendorProfileFinalized = 341,
    ICFinalAgreementUploaded = 361,
    SubcontractorContractorSentPackage = 381,
    SubcontractorRatesAndCustomerReviewed = 401,
    SubcontractorWorkAuthorizationVerified = 421,
    SubcontractorPreScreeningValidating = 441,
    SubcontractorPreScreeningCompleted = 461,
    SubcontractorVendorProfileFinalized = 481,
    SubcontractorFinalAgreementUploaded = 501,
    Renewed = 601,
    Rehired = 621,
}

export enum AssignmentStageFilterEnum {
    All = 0,
    Pending = 1,
    CandidateSentOnboarding = 2,
    MemberQuestionnaireComplete = 3,
    RatesAndCustomerReviewed = 4,
    CandidateCompletedOnboarding = 5,
    OnboardingPackageVerified = 6,
    ContractorQuestionnaireComplete = 7,
    ContractorChecklistVerified = 8,
    ContractorSentPackage = 9,
    AcquiringApplicableInsurances = 10,
    WorkAuthorizationVerified = 11,
    PreScreeningValidating = 12,
    PreScreeningCompleted = 13,
    TimesheetAccountCreated = 14,
    AssignmentConfirmed = 15,
    VendorProfileFinalized = 16,
    FinalAgreementUploaded = 17,
}

export interface AssignmentStageModel {
    stage?: AssignmentStageEnum;
    stageStatus?: StageStatusEnum;
    additionalInfoRequest?: string | undefined;
    additionalInfoReply?: string | undefined;
    showPulsatingIndicator?: boolean;
}

export enum AssignmentStatusTypeEnum {
    Draft = 0,
    Request = 1,
    Active = 2,
    Completed = 3,
    Cancelled = 4,
}

export interface AssignmentSummaryModel {
    assignmentId?: string;
    assignmentKey?: string | undefined;
    assignmentType?: AssignmentTypeEnum;
    jobStartDate?: Date | undefined;
    jobEndDate?: Date | undefined;
    workerName?: string | undefined;
    terminationDate?: Date | undefined;
}

export interface AssignmentSummaryWorkerModel {
    workerId?: string | undefined;
    workerKey?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    taxId?: number | undefined;
    workerFileKey?: string | undefined;
}

export interface AssignmentSupervisorInfoEditModel {
    supervisorId?: string | undefined;
    title?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
}

export interface AssignmentSupervisorInfoViewModel {
    id?: string | undefined;
    title?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
}

export interface AssignmentTeammateSelectModel {
    userId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    rate?: number | undefined;
    rateType?: AssignmentRateTypeEnum;
    pendingTeammateEmail?: string | undefined;
    externalFullName?: string | undefined;
    teammateType?: AssignmentTeammateTypeEnum;
}

export enum AssignmentTeammateTypeEnum {
    Teammate = 0,
    PendingTeammate = 1,
    ExternalRecruiter = 2,
}

export interface AssignmentTeammatesEditModel {
    userId?: string | undefined;
    pendingTeammateEmail?: string | undefined;
    externalFullName?: string | undefined;
    teammateType?: AssignmentTeammateTypeEnum;
    rate?: number | undefined;
    rateType?: AssignmentRateTypeEnum;
}

export interface AssignmentTemplateDetailsResponse {
    templateName?: string | undefined;
    assignmentId?: string;
    assignmentKey?: string | undefined;
    assignmentStatus?: AssignmentStatusTypeEnum;
    assignmentType?: AssignmentTypeEnum;
    assignmentCategory?: AssignmentCategoryEnum;
    assignmentStage?: AssignmentStageEnum;
    stageStatus?: StageStatusEnum;
    createdDate?: Date;
    updatedDate?: Date;
    memberId?: string;
    memberKey?: string | undefined;
    memberCompanyName?: string | undefined;
    stages?: AssignmentStageModel[] | undefined;
    assignmentDocument?: AssignmentPrimaryDocumentViewModel;
    creator?: CreatorUserModel;
    questionnaireInfo?: AssignmentQuestionnaireInfoModel;
    contractorQuestionnaireInfo?: AssignmentQuestionnaireInfoModel;
    customerInfo?: AssignmentCustomerViewModel;
    partnerInfo?: AssignmentPartnerViewModel;
    renewType?: RenewAssignmentEnum;
    renewKind?: RenewKindEnum;
    parentAssignmentId?: string | undefined;
    renewStatus?: RenewStatusEnum;
    availableRenewOptions?: AvailableRenewOptionsEnum;
    isWorkerDuplicated?: boolean;
    childAssignmentId?: string | undefined;
    childAssignmentKey?: string | undefined;
    parentAssignmentKey?: string | undefined;
    financialScheduler?: AssignmentFinancialSchedulerEditModel;
    assignmentTeammates?: AssignmentTeammateSelectModel[] | undefined;
    companyId?: string;
}

export interface AssignmentTemplateMiniViewModel {
    id?: string;
    templateName?: string | undefined;
}

export interface AssignmentTemplateResponseModel {
    assignmentId?: string;
    templateName?: string | undefined;
    creatorFullName?: string | undefined;
    assignmentType?: AssignmentTypeEnum;
    assignmentCategory?: AssignmentCategoryEnum;
    createdDate?: Date;
    updatedDate?: Date;
    assignmentTeammates?: AssignmentTeammateSelectModel[] | undefined;
    assignmentDocument?: AssignmentPrimaryDocumentEditModel;
}

export interface AssignmentTemplateSummaryResponseModel {
    id?: string;
    templateName?: string | undefined;
    assignmentType?: AssignmentTypeEnum;
    assignmentCategory?: AssignmentCategoryEnum;
    createdDate?: Date;
    updatedDate?: Date;
    workerInfo?: AssignmentSummaryWorkerModel;
    memberId?: string;
    memberKey?: string | undefined;
    memberCompanyName?: string | undefined;
    jobTitle?: string | undefined;
    jobStartDate?: Date | undefined;
    jobEndDate?: Date | undefined;
    workLocation?: LocationViewModel;
    billingLocation?: LocationViewModel;
    customerInfo?: AssignmentCustomerViewModel;
}

export interface AssignmentTerminationCreateUpdateApiModel {
    assignmentId?: string;
    terminationDate?: Date;
    terminationReason?: AssignmentTerminationReasonTypeEnum;
    eligibleForRehire?: boolean;
    details?: string | undefined;
    attachments?: NamedAttachmentModel[] | undefined;
}

export interface AssignmentTerminationModel {
    assignmentId?: string;
    terminationDate?: Date;
    terminationReason?: AssignmentTerminationReasonTypeEnum;
    eligibleForRehire?: boolean;
    details?: string | undefined;
    readonly attachments?: NamedAttachmentModel[] | undefined;
    createdDate?: Date;
    updatedDate?: Date;
    readonly isApplied?: boolean;
}

export enum AssignmentTerminationReasonTypeEnum {
    Converted = 1,
    AssignmentCancelled = 2,
    Resigned = 3,
    AttendanceIssue = 4,
    PerformanceIssue = 5,
    MisconductIssue = 6,
    AssignmentComplete = 7,
}

export interface AssignmentTimesheetApproverInfoEditModel {
    timesheetApproverId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
}

export interface AssignmentTimesheetApproverInfoViewModel {
    id?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
}

export interface AssignmentTimesheetBackupApproverInfoEditModel {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
}

export interface AssignmentTimesheetBackupApproverInfoViewModel {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
}

export interface AssignmentTitleInfoModel {
    assignmentId?: string;
    assignmentKey?: string | undefined;
    assignmentStatus?: AssignmentStatusTypeEnum;
    assignmentStage?: AssignmentStageEnum;
    assignmentType?: AssignmentTypeEnum;
    assignmentCategory?: AssignmentCategoryEnum;
    terminationReason?: AssignmentTerminationReasonTypeEnum;
    createdDate?: Date;
    updatedDate?: Date;
    workerInfo?: AssignmentSummaryWorkerModel;
    memberId?: string;
    memberKey?: string | undefined;
    memberCompanyName?: string | undefined;
    jobTitle?: string | undefined;
    jobStartDate?: Date | undefined;
    jobEndDate?: Date | undefined;
    workLocation?: LocationViewModel;
    billingLocation?: LocationViewModel;
    customerInfo?: AssignmentCustomerViewModel;
    renewType?: RenewAssignmentEnum;
    parentAssignmentId?: string | undefined;
    parentAssignmentKey?: string | undefined;
    renewStatus?: RenewStatusEnum;
    renewKind?: RenewKindEnum;
    childAssignmentId?: string | undefined;
}

export enum AssignmentTypeEnum {
    EEAssignment = 1,
    ICAssignment = 2,
    SCAssignment = 3,
}

export enum AssignmentTypeFilterEnum {
    All = 0,
    EEAssignment = 1,
    ICAssignment = 2,
    SCAssignment = 3,
}

export interface AssignmentWorkerInfoEditModel {
    workerId?: string | undefined;
    workerInfo?: BaseEmployeeModel;
    location?: LocationModel;
    workerType?: WorkerTypeEnum;
    workerFile?: ResourceDownloadResponse;
}

export interface AssignmentWorkerInfoViewModel {
    workerId?: string | undefined;
    workerInfo?: BaseEmployeeModel;
    workerKey?: string | undefined;
    workerType?: WorkerTypeEnum;
    workerFile?: ResourceDownloadResponse;
    location?: AssignmentLocationWithActualStateModel;
    isDuplicated?: boolean;
}

export interface AssignmentsTypePayCodes {
    assignmentType?: AssignmentTypeEnum;
    payCodeId?: string[] | undefined;
}

export enum AvailableRenewOptionsEnum {
    None = 0,
    Renew = 1,
    Rehire = 2,
}

export interface AverageRatesByCustomerReportItemViewModel {
    customerKey?: string | undefined;
    customerName?: string | undefined;
    avgBillRate?: string | undefined;
    avgPayRate?: string | undefined;
    spread?: string | undefined;
    markup?: string | undefined;
}

export interface AverageRatesByCustomerReportViewModel {
    grandTotal?: AverageRatesByCustomerTotalViewModel;
    items?: AverageRatesByCustomerReportItemViewModel[] | undefined;
    totalCount?: number;
    lastSyncDate?: Date;
}

export interface AverageRatesByCustomerTotalViewModel {
    avgBillRateTotal?: string | undefined;
    avgPayRateTotal?: string | undefined;
    spreadTotal?: string | undefined;
    markupTotal?: string | undefined;
}

export enum AverageRatesSortFieldEnum {
    Customer = 0,
    AvgBillRate = 1,
    AvgPayRate = 2,
    Spread = 3,
    Markup = 4,
}

export interface BOUserBullhornSessionViewModel {
    id?: string;
    accessToken?: string | undefined;
    tokenType?: string | undefined;
    expiresIn?: number;
    refreshToken?: string | undefined;
    updatedDate?: Date;
    expireDate?: Date;
    loginName?: string | undefined;
    syncStatus?: BullhornSessionStatusEnum;
}

export enum BOUserStatusEnum {
    All = 0,
    Pending = 1,
    Reviewed = 21,
    OutreachConducted = 41,
    PriceAgreementChanged = 59,
    PriceAgreementSent = 61,
    PriceAgreementSigned = 81,
    Completed = 101,
}

export enum BOUserTypeEnum {
    Company = 1,
    SelfEmployed = 2,
    International = 3,
}

export enum BOUsersBankingInfoTypeEnum {
    Default = 0,
    DirectDeposit = 1,
    MailMyChecks = 2,
    International = 3,
}

export interface BOUsersHideIndicatorModel {
    userId?: string;
    currentStage?: BOUserStatusEnum;
}

export interface BOUsersPriceAgreementConfirmModel {
    confirmationSignature?: string | undefined;
    confirmationDate?: Date;
    isConfirmation?: boolean;
}

export interface BOUsersPriceAgreementEditModel {
    eeInfoList?: PriceAgreementEEInfoModel[] | undefined;
    icPrice?: number;
}

export interface BOUsersPriceAgreementRespModel {
    companyId?: string;
    w2InfoList?: PriceAgreementW2InfoResponseModel[] | undefined;
    icPrice?: number;
    canBeConfirmed?: boolean;
    hasChangeRequest?: boolean;
    confirmationSignature?: string | undefined;
    confirmationDate?: Date | undefined;
    isConfirmation?: boolean | undefined;
    fundingType?: FundingTypeEnum;
    supportingFiles?: ExtendedNamedAttachmentModel[] | undefined;
}

export interface BOUsersStageModel {
    stage?: BOUserStatusEnum;
    stageStatus?: StageStatusEnum;
    additionalInfoRequest?: string | undefined;
    additionalInfoReply?: string | undefined;
    showPulsatingIndicator?: boolean;
}

export interface BackofficeUserModel {
    userId?: string;
    companyId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    companyName?: string | undefined;
    userStatus?: UserStatusEnum;
    isProfileComplete?: boolean;
    boUserType?: BOUserTypeEnum;
    profileType?: ProfileTypeEnum;
    roles?: string[] | undefined;
    outreach?: OutreachModel;
    isRegisteredOnMarketPlace?: boolean;
    isAccountSettingsComplete?: boolean;
    userHash?: string | undefined;
    isBOTwoFactorAuthStatus?: boolean;
    bullhornEnable?: boolean;
    bullhornNeedToRelogin?: boolean;
}

export enum BankingInfoAccountTypeEnum {
    Default = 0,
    Savings = 1,
    Checking = 2,
}

export interface BankingInfoDirectDepositModel {
    bankName?: string | undefined;
    holderName?: string | undefined;
    accountNumber?: string | undefined;
    routingNumber?: string | undefined;
    accountType?: BankingInfoAccountTypeEnum;
    ddEmailAddress?: string | undefined;
    isConfirmation?: boolean;
}

export interface BankingInfoInternationalModel {
    accountHolderName?: string | undefined;
    internationalBankName?: string | undefined;
    internationalAccountNumber?: string | undefined;
    swiftCode?: string | undefined;
    internationalRoutingCode?: string | undefined;
    confirmation1?: boolean;
    confirmation2?: boolean;
}

export interface BankingInfoMailMyChecksRequestModel {
    payableTo?: string | undefined;
    stateId?: number;
    city?: string | undefined;
    address?: string | undefined;
    zip?: string | undefined;
    isConfirmation?: boolean;
}

export interface BankingInfoMailMyChecksResponseModel {
    payableTo?: string | undefined;
    state?: string | undefined;
    stateId?: number | undefined;
    city?: string | undefined;
    address?: string | undefined;
    zip?: string | undefined;
    isConfirmation?: boolean;
}

export interface BankingInformationRequestModel {
    directDepositDetail?: BankingInfoDirectDepositModel;
    mailMyChecksDetail?: BankingInfoMailMyChecksRequestModel;
    internationalDetail?: BankingInfoInternationalModel;
    bankInfoFileKey?: string | undefined;
    bankingInformationType?: BOUsersBankingInfoTypeEnum;
}

export interface BankingInformationResponseModel {
    directDepositDetail?: BankingInfoDirectDepositModel;
    mailMyChecksDetail?: BankingInfoMailMyChecksResponseModel;
    internationalDetail?: BankingInfoInternationalModel;
    bankingInformationType?: BOUsersBankingInfoTypeEnum;
    bankInfoFileKey?: string | undefined;
    bankInfoFileName?: string | undefined;
}

export interface BaseAddressModel {
    address: string;
    city?: string | undefined;
    state?: string | undefined;
    stateId?: number | undefined;
    countryId?: number | undefined;
    countryName?: string | undefined;
    internationalCityName?: string | undefined;
    internationalStateName?: string | undefined;
    zip: string;
}

export interface BaseEmployeeModel {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    taxId?: number | undefined;
    workerFileKey?: string | undefined;
}

export interface BillingAndProfitByCustomerReportItemViewModel {
    customerKey?: string | undefined;
    customerName?: string | undefined;
    percentageOfProfit?: string | undefined;
    billing?: string | undefined;
    profit?: string | undefined;
}

export interface BillingAndProfitByCustomerReportViewModel {
    grandTotal?: BillingAndProfitByCustomerTotalViewModel;
    items?: BillingAndProfitByCustomerReportItemViewModel[] | undefined;
    totalCount?: number;
    lastSyncDate?: Date;
}

export interface BillingAndProfitByCustomerTotalViewModel {
    billingTotal?: string | undefined;
    profitTotal?: string | undefined;
    percentageOfProfitTotal?: string | undefined;
}

export enum BillingAndProfitSortFieldEnum {
    Customer = 0,
    Billing = 1,
    Profit = 2,
    ProfitPercentage = 3,
}

export interface BillingContactModel {
    contactId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
}

export interface BillingInfoResponseModel {
    billingContacts?: BillingContactModel[] | undefined;
    location?: BaseAddressModel;
    isBillingSameAsMainAddress?: boolean;
}

export interface BillingInformationModel {
    billingContacts?: BillingContactModel[] | undefined;
    location?: LocationModel;
    isBillingSameAsMainAddress?: boolean;
}

export enum BreakInServiceEnum {
    Days0 = 0,
    Days30 = 30,
    Days60 = 60,
    Days90 = 90,
    Days120 = 120,
    Days180 = 180,
}

export interface BulkCustomerImportResponse {
    companyName?: string | undefined;
    result?: CreateCustomerResponse;
    errors?: ValidationDetailsModel[] | undefined;
    validationFailures?: ValidationFailure[] | undefined;
    readonly success?: boolean;
}

export enum BullhornSessionStatusEnum {
    First = 0,
    Standart = 1,
}

export interface BusinessInfoModel {
    name?: string | undefined;
    phoneNumber?: string | undefined;
    location?: LocationModel;
    assignmentLocations?: number[] | undefined;
    industry?: string[] | undefined;
    assignment?: boolean;
    businessEmail?: string | undefined;
}

export interface BusinessInfoResponseModel {
    name?: string | undefined;
    phoneNumber?: string | undefined;
    location?: BaseAddressModel;
    assignmentLocations?: StateEntity[] | undefined;
    industries?: IndustryEntity[] | undefined;
    outreach?: OutreachModel;
    priceAgreement?: BOUsersPriceAgreementRespModel;
    entityInformation?: EntityInformationResponseModel;
    assignment?: boolean;
    businessEmail?: string | undefined;
}

export enum CommissionTypeEnum {
    SelfFunded = 1,
    PaidWhenPaid = 2,
    AdvancedCommission = 3,
}

export interface CompanyRequestModel {
    companyId?: string;
    website?: string | undefined;
    ownerInfo?: PersonInfoModel;
    bestContact?: PersonInfoModel;
    businessInfo?: BusinessInfoModel;
}

export interface ContactPersonModel {
    contactId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    title?: string | undefined;
}

export interface ContractorCompanyDetailViewModel {
    id?: string;
    companyName?: string | undefined;
    representativeContact?: BaseEmployeeModel;
    location?: LocationViewModel;
    contractorCompanyType?: ContractorCompanyTypeEnum;
    currentRevision?: number;
    companyKey?: string | undefined;
    isDuplicated?: boolean;
    createdBy?: CreatorUserModel;
    assignmentsCount?: number;
    memberCompanyFirstName?: string | undefined;
    memberCompanyLastName?: string | undefined;
    memberKey?: string | undefined;
}

export interface ContractorCompanyItemViewModel {
    id?: string;
    companyName?: string | undefined;
    representativeContact?: BaseEmployeeModel;
    location?: LocationViewModel;
    contractorCompanyType?: ContractorCompanyTypeEnum;
    currentRevision?: number;
    companyKey?: string | undefined;
    isDuplicated?: boolean;
    createdBy?: string;
    assignmentsCount?: number;
    memberCompanyFirstName?: string | undefined;
    memberCompanyLastName?: string | undefined;
    memberKey?: string | undefined;
}

export interface ContractorCompanyItemViewModelPagedResponseModel {
    totalCount?: number;
    pageNumber?: number;
    details?: ContractorCompanyItemViewModel[] | undefined;
}

export interface ContractorCompanyModel {
    id?: string;
    companyName?: string | undefined;
    representativeContact?: BaseEmployeeModel;
    contractorCompanyType?: ContractorCompanyTypeEnum;
    location?: LocationModel;
    companyKey?: string | undefined;
    isDuplicated?: boolean;
    createdBy?: string;
}

export enum ContractorCompanyTypeEnum {
    IC = 2,
    ParentSC = 3,
}

export interface CreateAssignmentResponse {
    assignmentId?: string;
    assignmentKey?: string | undefined;
}

export interface CreateContractorCompanyModel {
    companyName?: string | undefined;
    representativeContact?: BaseEmployeeModel;
    contractorCompanyType?: ContractorCompanyTypeEnum;
    location?: LocationModel;
}

export interface CreateCustomerGeneralInfo {
    companyInfo: CustomerCompanyInfoModel;
    primaryContacts: ContactPersonModel[];
}

export interface CreateCustomerRequest {
    generalInfo: CreateCustomerGeneralInfo;
    additionalInfo: AdditionalInfoModel;
    agreementDetailsInfo: ServiceAgreementInfoModel;
    billingInfo: BillingInformationModel;
    customerGroupName?: string | undefined;
    customerGroupId?: string | undefined;
}

export interface CreateCustomerResponse {
    customerId?: string;
    customerKey?: string | undefined;
}

export interface CreateEntityResult {
    createdId?: string;
}

export interface CreateInternalRecruiterModel {
    firstName?: string | undefined;
    lastName?: string | undefined;
}

export interface CreatePartnerModel {
    primaryContact?: PartnerPrimaryContactModel;
    generalInfo?: PartnerGeneralInfoModel;
}

export interface CreateWorkerModel {
    workerInfo?: BaseEmployeeModel;
    location?: LocationModel;
    workerType?: WorkerTypeEnum;
}

export interface CreatorUserModel {
    id?: string;
    fullName?: string | undefined;
}

export interface CustomerAdditionalInfo3Model {
    assignmentRequirements?: CustomerAssignmentRequirementsModel;
    specialAssignmentRequirements?: CustomerSpecialAssignmentRequirementsModel;
}

export interface CustomerAdditionalInfoModel {
    generalContractInformation?: CustomerGeneralContractInformation;
    financialInformation?: CustomerFinancialInformationModel;
    additionalInfo3?: CustomerAdditionalInfo3Model;
}

export interface CustomerAdditionalInfoReplyRequestModel {
    additionalInfoReply: string;
    currentStage: CustomerStatusEnum;
    customerId: string;
}

export interface CustomerAdditionalInfoResponseModel {
    customerId?: string;
    customerCompanyName?: string | undefined;
    generalContractInformation?: CustomerGeneralContractInformation;
    financialInformation?: CustomerFinancialInformationModel;
    additionalInfo3?: CustomerAdditionalInfo3Model;
    customerKey?: string | undefined;
}

export interface CustomerAssignmentRequirementsModel {
    isIndependentContractors?: boolean | undefined;
    isPreScreeningRequired?: boolean | undefined;
    preScreeningBilledTo?: CustomerPreScreeningProviderEnum;
    preScreening?: string | undefined;
    isOnboardingDocumentationRequired?: boolean | undefined;
    onboardingDocumentationFileKeys?: string[] | undefined;
    onboardingDocumentationFileNames?: string[] | undefined;
    designatedPreScreeningProvider?: boolean | undefined;
    specialInstructions?: string | undefined;
    terminationInstructions?: string | undefined;
}

export interface CustomerCompanyInfoModel {
    companyName?: string | undefined;
    additionalInvoiceName?: string | undefined;
    companyWebSite?: string | undefined;
    companyEmail?: string | undefined;
    companyPhoneNumber?: string | undefined;
    location: LocationModel;
}

export enum CustomerCostingMethodTypeEnum {
    Blended = 0,
    CostPlus = 1,
}

export interface CustomerDraftResponse {
    customerId?: string;
    generalInfo: CreateCustomerGeneralInfo;
    additionalInfo: AdditionalInfoModel;
    agreementDetailsInfo: ServiceAgreementInfoModel;
    billingInfo: BillingInformationModel;
    customerGroupName?: string | undefined;
    customerGroupId?: string | undefined;
}

export interface CustomerEditResponse {
    customerId: string;
    status?: CustomerStatusEnum;
    memberId?: string;
    memberCompanyId?: string;
    createdDate?: Date;
    updatedDate?: Date;
    customerGroupId?: string | undefined;
    customerGroupName?: string | undefined;
    customerDocument: CreateCustomerRequest;
}

export interface CustomerFinancialInformationModel {
    financialOverview?: CustomerFinancialOverviewModel;
    rateOverview?: CustomerRateOverviewModel;
    mspOrVmsOverview?: CustomerMspOrVmsOverviewModel;
}

export interface CustomerFinancialOverviewModel {
    creditCheckScore?: string | undefined;
    commissionTypeApproval?: CommissionTypeEnum;
    advancedCommission?: string | undefined;
    paidWhenPaid?: string | undefined;
    selfFunded?: string | undefined;
    addedNotes?: string | undefined;
    paymentTerm?: PaymentTermEnum;
    customerCostingMethodType?: CustomerCostingMethodTypeEnum;
}

export interface CustomerGeneralContractInformation {
    insuranceRequirements?: CustomerInsuranceRequirementsModel;
}

export interface CustomerHideIndicatorModel {
    customerId?: string;
    currentStage?: CustomerStatusEnum;
}

export interface CustomerHistoryDetailsModel {
    oldData?: FullCustomerInfoResponseModel;
    newData?: FullCustomerInfoResponseModel;
}

export interface CustomerInfoCompanyInfoModel {
    companyName: string;
    additionalInvoiceName?: string | undefined;
    companyWebSite?: string | undefined;
    companyPhoneNumber?: string | undefined;
    companyEmail?: string | undefined;
    location: BaseAddressModel;
}

export interface CustomerInfoResponseModel {
    customerId?: string;
    customerKey?: string | undefined;
    userId?: string;
    companyId?: string;
    status?: CustomerStatusEnum;
    stageStatus?: StageStatusEnum;
    stages?: CustomerStageModel[] | undefined;
    recruiterCompanyName?: string | undefined;
    recruiterCompanyId?: string;
    recruiterCompanyKey?: string | undefined;
    createdDate?: Date;
    updatedDate?: Date;
    customerInfo: CustomerInfoCompanyInfoModel;
    primaryContacts: ContactPersonModel[];
    billingInfo: BillingInfoResponseModel;
    additionalInfo: AdditionalInfoModel;
    agreementDetails: CustomerInfoServiceAgreementModel;
    isAdminAdditionalInfoExists?: boolean;
    creator?: CreatorUserModel;
    customerGroupId?: string | undefined;
    customerGroupName?: string | undefined;
}

export interface CustomerInfoServiceAgreementModel {
    agreementDetailsType: ServiceAgreementTypeEnum;
    agreementAttachments: ExtendedNamedAttachmentModel[];
}

export interface CustomerInsuranceRequirementsModel {
    certificateOfInsuranceSpecifications?: string | undefined;
    submittedTo?: string | undefined;
    certificateOfInsuranceCreatedFileKey?: string | undefined;
    certificateOfInsuranceCreatedFileName?: string | undefined;
    isCreditCheckVerified?: boolean | undefined;
    sowRequired?: boolean | undefined;
    sowTemplateFileKey?: string | undefined;
    sowTemplateFileName?: string | undefined;
    sowSpecialInstructions?: string | undefined;
}

export interface CustomerMspOrVmsOverviewDto {
    mspFee?: string | undefined;
    vmsFee?: number | undefined;
    invoicingInformation?: string | undefined;
    specialInvoicingInstructions?: string | undefined;
    invoicingCycle?: InvoicingCycleEnum;
    payrollCycle?: PayPeriodEnum;
    isThereThirdPartyWorkforce?: boolean | undefined;
    url?: string | undefined;
    credentials?: string | undefined;
    mspOrVmsProviderName?: string | undefined;
    purchaseOrder?: boolean | undefined;
    purchaseOrderFileKey?: string | undefined;
    purchaseOrderInstructions?: string | undefined;
}

export interface CustomerMspOrVmsOverviewModel {
    mspFee?: number | undefined;
    vmsFee?: number | undefined;
    invoicingInformation?: string | undefined;
    specialInvoicingInstructions?: string | undefined;
    invoicingCycle?: InvoicingCycleEnum;
    payrollCycle?: PayPeriodEnum;
    isThereThirdPartyWorkforce?: boolean | undefined;
    url?: string | undefined;
    credentials?: string | undefined;
    mspOrVmsProviderName?: string | undefined;
    purchaseOrder?: boolean | undefined;
    purchaseOrderFileKey?: string | undefined;
    purchaseOrderFileName?: string | undefined;
    purchaseOrderInstructions?: string | undefined;
}

export interface CustomerPagedResponseModel {
    totalCount?: number;
    pageNumber?: number;
    details?: CustomerInfoResponseModel[] | undefined;
}

export enum CustomerPreScreeningProviderEnum {
    Member = 1,
    MBP = 2,
    Customer = 3,
}

export interface CustomerRateOverviewModel {
    fixedMarkupRate?: string | undefined;
    otRateMultiplier?: string | undefined;
    tempToPermConversionFileKey?: string | undefined;
    tempToPermConversionFileName?: string | undefined;
    dtBillRateMultiplier?: number | undefined;
}

export interface CustomerResponseModel {
    customerId?: string;
    primaryContacts?: ContactPersonModel[] | undefined;
    billingContacts?: BillingContactModel[] | undefined;
    companyId?: string;
    companyName?: string | undefined;
    additionalInvoiceName?: string | undefined;
    customerCompanyId?: string;
    customerCompanyName?: string | undefined;
    customerAdditionalInvoiceName?: string | undefined;
    state?: string | undefined;
    stateId?: number;
    city?: string | undefined;
    internationalCity?: string | undefined;
    internationalState?: string | undefined;
    countryName?: string | undefined;
    countryId?: number | undefined;
    address?: string | undefined;
    zipCode?: string | undefined;
    status?: CustomerStatusEnum;
    createdDate?: Date;
    isOtherPrimaryContactAvailable?: boolean;
    isOtherBillingContactAvailable?: boolean;
    billingAPEmail?: string | undefined;
    billingLocation?: BaseAddressModel;
    mspOrVmsOverviewInfo?: CustomerMspOrVmsOverviewDto;
    breakInService?: BreakInServiceEnum;
}

export interface CustomerSearchResponseModel {
    customerId?: string;
    companyName?: string | undefined;
    additionalInvoiceName?: string | undefined;
    customerKey?: string | undefined;
}

export enum CustomerSizeEnum {
    From0To20 = 0,
    From21To80 = 21,
    From81To200 = 81,
    From201To800 = 201,
    From801To1500 = 801,
    From1501Plus = 1501,
}

export interface CustomerSpecialAssignmentRequirementsModel {
    guaranteedWorkPerformance?: string | undefined;
    tempToPermConversion?: string | undefined;
    addedNotes?: string | undefined;
    timeEntry?: string | undefined;
    breakInService?: BreakInServiceEnum;
}

export interface CustomerStageModel {
    stage?: CustomerStatusEnum;
    stageStatus?: StageStatusEnum;
    additionalInfoRequest?: string | undefined;
    additionalInfoReply?: string | undefined;
    showPulsatingIndicator?: boolean;
}

export enum CustomerStatusEnum {
    Requested = 1,
    NewCustomerSetupStarted = 21,
    CreditCheckVerified = 41,
    UnderLegalReview = 61,
    AcquiringCertificateOfInsurance = 81,
    ApprovedByFinance = 101,
    ApprovedByLegal = 121,
    CounterSignaturesCompleted = 141,
    StaffOnboardingPackagesCreated = 161,
    FinalAgreementUploaded = 181,
    NewCustomerSetupComplete = 201,
    Draft = -1,
}

export enum CustomerStatusFilterEnum {
    All = 0,
    Requested = 1,
    InProgress = 2,
    NewCustomerSetupStarted = 21,
    CreditCheckVerified = 41,
    UnderLegalReview = 61,
    AcquiringCertificateOfInsurance = 81,
    ApprovedByFinance = 101,
    ApprovedByLegal = 121,
    CounterSignaturesCompleted = 141,
    StaffOnboardingPackagesCreated = 161,
    FinalAgreementUploaded = 181,
    NewCustomerSetupComplete = 201,
    Draft = -1,
}

export interface DateTimeModel {
    date?: Date | undefined;
    time?: string | undefined;
    timeZone?: string | undefined;
}

export enum DurationTypeEnum {
    Week = 1,
    Month = 2,
    Year = 3,
}

export enum EmploymentTypeEnum {
    FullTime = 1,
    PartTime = 2,
}

export enum EntityInfoNumberTypeEnum {
    Ssn = 1,
    Ein = 2,
}

export interface EntityInformationRequestModel {
    companyId?: string;
    name?: string | undefined;
    number?: string | undefined;
    numberType?: EntityInfoNumberTypeEnum;
    entityInfoFileKey?: string | undefined;
    countryId?: number | undefined;
}

export interface EntityInformationResponseModel {
    name?: string | undefined;
    number?: string | undefined;
    numberType?: EntityInfoNumberTypeEnum;
    entityInfoFileKey?: string | undefined;
    entityInfoFileName?: string | undefined;
    countryId?: number | undefined;
    countryName?: string | undefined;
}

export interface ExtendedNamedAttachmentModel {
    createdDate?: Date | undefined;
    fileKey?: string | undefined;
    fileName?: string | undefined;
}

export enum FileTypeEnum {
    CustomerCreationTemplate = 1,
    AssignmentCreationTemplate = 2,
}

export interface FinancialFilterViewModel {
    isMember1Name?: boolean;
    isMember2Name?: boolean;
    isWorkerTypeOrWorkerId?: boolean;
    isParentVendor?: boolean;
    isWorkerName?: boolean;
    isWorkerJobTitle?: boolean;
    isCommissionDetails?: boolean;
    isDate?: boolean;
    isMemberMarkup?: boolean;
    isBillHoursReg?: boolean;
    isBillHoursOt?: boolean;
    isBillRateReg?: boolean;
    isBillRateOt?: boolean;
    isBillAmount?: boolean;
    isPayHoursReg?: boolean;
    isPayHoursOt?: boolean;
    isPayRateReg?: boolean;
    isPayRateOt?: boolean;
    isPayAmount?: boolean;
    isMBPRate?: boolean;
    isMBPFee?: boolean;
    isMSPFee?: boolean;
    isVMSFee?: boolean;
    isTotalProfit?: boolean;
    isMember1USDHr?: boolean;
    isMember2USDHr?: boolean;
    isMember1ProfitPercent?: boolean;
    isMember2ProfitPercent?: boolean;
    isMember1Profit?: boolean;
    isMember2Profit?: boolean;
    isInvoiceNumber?: boolean;
}

export interface FinancialInfoSchedulerEditModel {
    payType?: PayTypeEnum;
    overtime?: OvertimeEnum;
    mbpRate?: number | undefined;
    vmsFee?: number | undefined;
    vmsFeeIsOverridden?: boolean | undefined;
    mspFee?: number | undefined;
    mspFeeIsOverridden?: boolean | undefined;
    payRate?: number | undefined;
    billRate?: number | undefined;
    dtBillRate?: number | undefined;
    overtimeBillRate?: number | undefined;
    overtimePayRate?: number | undefined;
    profitRate?: number | undefined;
}

export interface FinancialInfoSchedulerViewModel {
    payRate?: number | undefined;
    mbpRate?: number | undefined;
    vmsFee?: number | undefined;
    vmsFeeIsOverridden?: boolean | undefined;
    mspFee?: number | undefined;
    mspFeeIsOverridden?: boolean | undefined;
    billRate?: number | undefined;
    profitRate?: number | undefined;
    dtBillRate?: number | undefined;
    overtimeBillRate?: number | undefined;
    payType?: PayTypeEnum;
    overtimePayRate?: number | undefined;
    overtime?: OvertimeEnum;
}

export interface FinancialReportDetailsResponseModel {
    invoiceNumber?: string | undefined;
    netSuiteInvoiceId?: number;
    commissionDetails?: string | undefined;
    date?: Date;
    period?: string | undefined;
    customerInfo?: ReportCustomerInfo;
    member1?: ReportMemberInfoResponse;
    member2?: ReportMemberInfoResponse;
    workerInfo?: ReportWorkerInfo;
    mbpCalculations?: ReportMbpCalculationsResponse;
    parentVendor?: string | undefined;
}

export interface FinancialReportFieldFilterModel {
    fieldType?: FinancialReportSortFieldEnum;
    values?: string[] | undefined;
}

export enum FinancialReportSortFieldEnum {
    CustomerName = 1,
    Member1Name = 2,
    Member2Name = 3,
    WorkerTypeWorkerID = 4,
    ParentVendor = 5,
    WorkerName = 6,
    WorkerJobTitle = 7,
    CommissionDetails = 8,
    Date = 9,
    MemberMarkup = 10,
    BillHoursReg = 11,
    BillHoursOT = 12,
    BillAmount = 13,
    PayHoursReg = 14,
    PayHoursOT = 15,
    PayRateReg = 16,
    PayRateOT = 17,
    PayAmount = 18,
    MBPRate = 19,
    MBPFee = 20,
    MSPFee = 21,
    VMSFee = 22,
    TotalProfit = 23,
    Member1USDHr = 24,
    Member2USDHr = 25,
    Member1ProfitPercent = 26,
    Member2ProfitPercent = 27,
    Member1Profit = 28,
    Member2Profit = 29,
    InvoiceNumber = 30,
    BillRateReg = 31,
    BillRateOT = 32,
}

export interface FinancialReportTotalsModel {
    billHoursReg?: string | undefined;
    billHoursOT?: string | undefined;
    billAmount?: string | undefined;
    payHoursReg?: string | undefined;
    payHoursOT?: string | undefined;
    payAmount?: string | undefined;
    mbpFee?: string | undefined;
    mspFee?: string | undefined;
    vmsFee?: string | undefined;
    totalProfit?: string | undefined;
    member1Profit?: string | undefined;
    member2Profit?: string | undefined;
}

export interface FinancialReportsRequestModel {
    pageNumber?: number;
    sortField?: FinancialReportSortFieldEnum;
    sortType?: SortingEnum;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    fieldsFilter?: FinancialReportFieldFilterModel[] | undefined;
}

export interface FinancialResponseModel {
    grandTotal?: FinancialReportTotalsModel;
    filter?: FinancialFilterViewModel;
    lastSyncDate?: Date;
    totalCount?: number;
    pageNumber?: number;
    details?: FinancialReportDetailsResponseModel[] | undefined;
}

export interface FullBOUserResponseModel {
    companyId?: string;
    userId?: string;
    memberKey?: string | undefined;
    memberLogoUrl?: string | undefined;
    website?: string | undefined;
    registeredEmail?: string | undefined;
    registeredFirstName?: string | undefined;
    registeredLastName?: string | undefined;
    status?: BOUserStatusEnum;
    stageStatus?: StageStatusEnum;
    stages?: BOUsersStageModel[] | undefined;
    boUserType?: BOUserTypeEnum;
    profileType?: ProfileTypeEnum;
    createdDate?: Date;
    ownerInfo?: PersonInfoModel;
    bestContact?: PersonInfoModel;
    businessInfo?: BusinessInfoResponseModel;
    bankingInformation?: BankingInformationResponseModel;
    corporateInfo?: ProfileCorporateInfoModel;
}

export interface FullCustomerInfoResponseModel {
    additionalInfo?: CustomerAdditionalInfoModel;
    generalInfo?: CreateCustomerRequest;
    status?: CustomerStatusEnum;
    stageStatus?: StageStatusEnum;
}

export enum FundingTypeEnum {
    Funded = 0,
    SelfFunded = 1,
    Both = 2,
}

export interface IndustryEntity {
    id?: number;
    name?: string | undefined;
}

export interface InitialProfileRequestModel {
    userType?: BOUserTypeEnum;
    profileType?: ProfileTypeEnum;
    company?: CompanyRequestModel;
    selfEmployed?: SelfEmployedRequestModel;
    international?: InternationalRequestModel;
    outreach?: OutreachModel;
}

export interface InternalRecruiterPagedResponseModel {
    totalCount?: number;
    pageNumber?: number;
    details?: InternalRecruiterResponseModel[] | undefined;
}

export interface InternalRecruiterResponseModel {
    id?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
}

export interface InternalionalLocationModel {
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    countryId?: number | undefined;
    zipCode?: string | undefined;
    stateId?: number | undefined;
    country?: string | undefined;
    countryCode?: string | undefined;
    internationalCityName?: string | undefined;
    internationalStateName?: string | undefined;
}

export interface InternationalBusinessInfoModel {
    name?: string | undefined;
    phoneNumber?: string | undefined;
    location?: InternalionalLocationModel;
    assignmentLocations?: number[] | undefined;
    industry?: string[] | undefined;
    assignment?: boolean;
    businessEmail?: string | undefined;
}

export interface InternationalRequestModel {
    companyId?: string;
    website?: string | undefined;
    ownerInfo?: PersonInfoModel;
    bestContact?: PersonInfoModel;
    businessInfo?: InternationalBusinessInfoModel;
}

export interface InvitedUserDetailEntity {
    isInvitedUser?: boolean;
    isRegistred?: boolean;
}

export interface InvitedUserRequestModel {
    email?: string | undefined;
}

export enum InvoicingCycleEnum {
    Weekly = 1,
    BiWeekly = 2,
    Monthly = 3,
    SemiMonthly = 4,
    SowWeekly = 5,
    SowMonthly = 6,
}

export enum JobCategoryEnum {
    IT = 1,
    Clerical = 2,
    Executive = 3,
    Engineering = 4,
    AccountingOrFinance = 5,
    WarehousingOrLightIndustrial = 6,
    Healthcare = 7,
    Other = 8,
}

export interface LandingPageQuestionForm {
    email?: string | undefined;
    name?: string | undefined;
    question?: string | undefined;
    phoneNumber?: string | undefined;
}

export enum LandingStatisticProfileType {
    IndependentRecruiter = 1,
    IndependentConsultant = 2,
    CorporateTAEntity = 3,
}

export interface LocationModel {
    address?: string | undefined;
    city?: string | undefined;
    stateId?: number | undefined;
    state?: string | undefined;
    countryId?: number | undefined;
    country?: string | undefined;
    countryCode?: string | undefined;
    internationalCityName?: string | undefined;
    internationalStateName?: string | undefined;
    zipCode?: string | undefined;
}

export interface LocationViewModel {
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    stateId?: number | undefined;
    zipCode?: string | undefined;
    countryId?: number | undefined;
    country?: string | undefined;
    countryCode?: string | undefined;
    internationalCityName?: string | undefined;
    internationalStateName?: string | undefined;
}

export interface LoginRequestModel {
    login: string;
    password: string;
}

export interface MemberAdditionalInfoReplyRequestModel {
    additionalInfoReply: string;
    currentStage: BOUserStatusEnum;
}

export interface MemberHistoryDetailsModel {
    oldData?: FullBOUserResponseModel;
    newData?: FullBOUserResponseModel;
}

export interface MemberLogoInfoEditModel {
    logoFileKey?: string | undefined;
}

export interface MemberLogoInfoViewModel {
    logoUrl?: string | undefined;
}

export enum MultiRateEnum {
    ProjectRate = 0,
    ShiftRa = 1,
    OnCall = 2,
    PaidTimeOff = 3,
    TaxableAmount = 4,
    NotTaxedAmount = 5,
}

export interface MultiRateSchedulerEditModel {
    payCodeId?: string;
    payRate?: number | undefined;
    billRate?: number | undefined;
    hasPayRateCustomLogic?: boolean;
    hasBillRateCustomLogic?: boolean;
}

export interface MultiRateSchedulerViewModel {
    payRate?: number | undefined;
    billRate?: number | undefined;
    payCodeId?: string;
    hasPayRateCustomLogic?: boolean;
    hasBillRateCustomLogic?: boolean;
}

export interface NamedAttachmentModel {
    fileKey?: string | undefined;
    fileName?: string | undefined;
}

export enum OutreachEnum {
    Phone = 1,
    Email = 2,
}

export interface OutreachModel {
    outreachType?: OutreachEnum;
    phone?: string | undefined;
    email?: string | undefined;
    dates?: DateTimeModel[] | undefined;
}

export enum OvertimeEnum {
    Exempt = 1,
    Nonexempt = 2,
}

export interface PartnerGeneralInfoModel {
    companyName?: string | undefined;
    companyEIN?: string | undefined;
    subcontractorRate?: number | undefined;
    address?: string | undefined;
    city?: string | undefined;
    stateId?: number | undefined;
    countryId?: number | undefined;
    internationalCityName?: string | undefined;
    internationalStateName?: string | undefined;
    zipCode?: string | undefined;
}

export interface PartnerGeneralInfoResponseModel {
    userId?: string;
    userKey?: string | undefined;
    companyName?: string | undefined;
    companyEIN?: string | undefined;
    subcontractorRate?: number | undefined;
    address?: string | undefined;
    cityId?: number | undefined;
    city?: string | undefined;
    stateId?: number | undefined;
    state?: string | undefined;
    country?: string | undefined;
    countryId?: number | undefined;
    internationalCityName?: string | undefined;
    internationalStateName?: string | undefined;
    zipCode?: string | undefined;
    assignmentsCount?: number | undefined;
    isRegisteredOnMarketplace?: boolean;
    userFirstName?: string | undefined;
    userLastName?: string | undefined;
    userCompanyName?: string | undefined;
}

export interface PartnerPagedResponseModel {
    totalCount?: number;
    pageNumber?: number;
    details?: PartnerResponseModel[] | undefined;
}

export interface PartnerPrimaryContactModel {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
}

export interface PartnerResponseModel {
    id?: string;
    isDeleted?: boolean;
    primaryContact?: PartnerPrimaryContactModel;
    generalInfo?: PartnerGeneralInfoResponseModel;
    invitedCompanyId?: string | undefined;
    partnerStatus?: PartnerStatusEnum;
    creator?: CreatorUserModel;
}

export enum PartnerStatusEnum {
    None = 0,
    InvitationRequested = 1,
    Registered = 2,
    ProfileCompleted = 3,
    PendingPartnership = 4,
}

export enum PartnerStatusGroupFilterEnum {
    All = 0,
    ReadyForPayments = 1,
    Pending = 2,
}

export interface PayCodeModel {
    id?: string;
    payRateTypeId?: string;
    name?: string | undefined;
    description?: string | undefined;
    orderNumber?: number;
    memberBilledIndicatorDefaultValue?: boolean | undefined;
}

export interface PayCodesGroup {
    jobCategory?: JobCategoryEnum;
    payCodes?: string[] | undefined;
}

export enum PayPeriodEnum {
    WeeklyMondaySunday = 1,
    BiWeeklyMondaySunday1 = 2,
    Monthly = 3,
    SemiMonthly = 4,
    WeeklyMondaySundayWedSubmit = 5,
    WeeklySaturdayFriday = 6,
    WeeklySundaySaturday = 7,
    BiWeeklyMondaySunday2 = 8,
    BiWeeklySundaySaturday1 = 9,
    BiWeeklySundaySaturday2 = 10,
    WeeklyThursdayWednesday = 11,
}

export interface PayRateTypeModel {
    id?: string;
    name?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    additionalDescription?: string | undefined;
    orderNumber?: number;
}

export enum PayTypeEnum {
    Hourly = 1,
    Salary = 2,
}

export enum PaymentTermEnum {
    Net5 = 5,
    Net7 = 7,
    Net10 = 10,
    Net15 = 15,
    Net21 = 21,
    Net22 = 22,
    Net30 = 30,
    Net45 = 45,
    Net60 = 60,
    Net75 = 75,
    Net90 = 90,
    DueOnReceipt = -1,
}

export interface PersonInfoModel {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
}

export enum PreScreeningBilledToEnum {
    Member = 1,
    Customer = 2,
}

export interface PreviewAgingReport {
    customerKey?: string | undefined;
    customerCompanyName?: string | undefined;
    terms?: string | undefined;
    totalBalance?: string | undefined;
}

export interface PreviewWeeklyBillingAndProfitReportViewModel {
    customerName?: string | undefined;
    workerType?: string | undefined;
    workerId?: string | undefined;
    billHoursReg?: string | undefined;
    totalProfit?: string | undefined;
    invoiceNumber?: string | undefined;
}

export interface PriceAgreementEEInfoModel {
    w2Price?: number;
    placementStateIds?: number[] | undefined;
    workCodes?: string[] | undefined;
}

export interface PriceAgreementHistoryDetailsBaseModel {
    w2InfoList?: PriceAgreementW2InfoResponseModel[] | undefined;
    icPrice?: number;
}

export interface PriceAgreementHistoryDetailsModel {
    oldPriceAgreement?: PriceAgreementHistoryDetailsBaseModel;
    newPriceAgreement?: PriceAgreementHistoryDetailsBaseModel;
}

export interface PriceAgreementW2InfoResponseModel {
    w2Price?: number;
    placementStates?: StateEntity[] | undefined;
    workCodes?: string[] | undefined;
}

export interface ProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export interface ProfileCorporateBillingInfoModel {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
}

export interface ProfileCorporateInfoModel {
    companyId?: string;
    billingInfo?: ProfileCorporateBillingInfoModel;
    primaryContacts?: ProfileCorporatePrimaryContactInfoModel[] | undefined;
    supervisors?: ProfileCorporateSupervisorInfoModel[] | undefined;
    timesheetApprovers?: ProfileCorporateTimesheetApproverInfoModel[] | undefined;
}

export interface ProfileCorporatePrimaryContactInfoModel {
    contactId?: string | undefined;
    title?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
}

export interface ProfileCorporatePrimaryContactsInfoModel {
    primarycontacts?: ProfileCorporatePrimaryContactInfoModel[] | undefined;
}

export interface ProfileCorporateSupervisorInfoModel {
    supervisorId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    title?: string | undefined;
}

export interface ProfileCorporateSupervisorsInfoModel {
    supervisors?: ProfileCorporateSupervisorInfoModel[] | undefined;
}

export interface ProfileCorporateTimesheetApproverInfoModel {
    timesheetApproverId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
}

export interface ProfileCorporateTimesheetApproversInfoModel {
    timesheetApprovers?: ProfileCorporateTimesheetApproverInfoModel[] | undefined;
}

export enum ProfileTypeEnum {
    Recruiter = 1,
    Corporate = 2,
}

export interface QuestionnaireModel {
    isValue?: boolean | undefined;
    comment?: string | undefined;
}

export interface RegInvitedUserModel {
    email?: string | undefined;
    password?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    secretKey?: string;
}

export interface RegRecruiterModel {
    companyName?: string | undefined;
    email?: string | undefined;
    password?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    invitedPartnerId?: string | undefined;
}

export enum RenewActionEnum {
    Submited = 0,
    Approved = 1,
}

export enum RenewAssignmentEnum {
    Default = 0,
    WithChanges = 1,
    WithoutChanges = 2,
    WithChangeCustomer = 3,
}

export interface RenewAssignmentModel {
    parentAssignmentId?: string;
    jobStartDate?: Date;
    jobEndDate?: Date;
    renewKind?: RenewKindEnum;
}

export interface RenewAssignmentWithChangesRequest {
    assignmentIsDraft?: boolean;
    assignmentType: AssignmentTypeEnum;
    assignmentCategory: AssignmentCategoryEnum;
    assignmentTeammates?: AssignmentTeammatesEditModel[] | undefined;
    assignmentInfo?: AssignmentInfoEditModel;
    financialInfo?: AssignmentFinancialInfoEditModel;
    bestPrimaryContacts?: AssignmentContactPersonEditModel[] | undefined;
    supervisorInfo?: AssignmentSupervisorInfoEditModel;
    timesheetApproverNotApplicable?: boolean;
    timesheetApproverSameAsSupervisor?: boolean;
    timesheetApproverInfo?: AssignmentTimesheetApproverInfoEditModel;
    additionalTimesheetApprovers?: AssignmentTimesheetApproverInfoEditModel[] | undefined;
    timesheetBackupApproverInfo?: AssignmentTimesheetBackupApproverInfoEditModel;
    workSameAsHomeOrBusinessLocation?: boolean;
    workLocation?: LocationModel;
    billingSameAsWorkLocation?: boolean;
    billingLocation?: LocationModel;
    billingEmail?: string | undefined;
    splitInfo?: AssignmentSplitInfoEditModel;
    partnerDraft?: AssignmentPartnerDraftModel;
    renewType?: RenewAssignmentEnum;
    renewKind?: RenewKindEnum;
    parentAssignmentId?: string | undefined;
    isNeedCreateTemplate?: boolean;
    templateName?: string | undefined;
    multiRates?: AssignmentMultiRateEditModel[] | undefined;
    financialScheduler?: AssignmentFinancialSchedulerEditModel;
}

export enum RenewKindEnum {
    None = 0,
    Renew = 1,
    Rehire = 2,
}

export enum RenewStatusEnum {
    Regular = 0,
    RenewRequest = 1,
    ParentRenewRequest = 2,
    Renewed = 3,
}

export interface ReportCustomerInfo {
    customerName?: string | undefined;
    netSuiteCustomerId?: number | undefined;
    customerKey?: string | undefined;
}

export interface ReportMbpCalculationsResponse {
    memberMarkupPercentage?: string | undefined;
    billHoursRegular?: string | undefined;
    billHoursOvertime?: string | undefined;
    billRateRegular?: string | undefined;
    billRateOvertime?: string | undefined;
    billAmount?: string | undefined;
    payHoursRegular?: string | undefined;
    payHoursOvertime?: string | undefined;
    payRateRegular?: string | undefined;
    payRateOvertime?: string | undefined;
    payAmount?: string | undefined;
    mbpInvoiceRatePercentage?: string | undefined;
    mbpFee?: string | undefined;
    mspFee?: string | undefined;
    vmsFee?: string | undefined;
    totalProfit?: string | undefined;
}

export interface ReportMemberInfoResponse {
    name?: string | undefined;
    netSuiteMemberId?: number | undefined;
    memberKey?: string | undefined;
    usdPerHourRate?: string | undefined;
    profitPercentage?: string | undefined;
    profit?: string | undefined;
}

export interface ReportWorkerInfo {
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    workerKey?: string | undefined;
    workerType?: string | undefined;
    netSuiteWorkerId?: number | undefined;
    jobTitle?: string | undefined;
}

export interface ReportsDatesRangeInfoModel {
    dataMinDate?: Date;
    dataMaxDate?: Date;
    dataMaxPeriodDate?: Date;
    newDataPeriodDateFrom?: Date;
}

export interface ResourceDownloadResponse {
    /** File name to save */
    readonly fileName?: string | undefined;
    /** Url for get body of file from S3 via CloudFront */
    readonly downloadUrl: string;
    /** File key to save */
    readonly fileKey?: string | undefined;
}

export interface S3UploadResponse {
    /** S3Key for post model to BE */
    readonly s3Key: string;
    /** S3 required Header for upload */
    readonly contentType: string;
    /** Url for put body of file to S3 */
    readonly putUrl: string;
    /** Url for get body of file from S3 */
    readonly getUrl: string;
}

export interface SelectTeammateViewModel {
    teammateType?: AssignmentTeammateTypeEnum;
    userId?: string | undefined;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    roleId?: number | undefined;
    secretKey?: string;
    isLockedOut?: boolean;
}

export interface SelfEmployedRequestModel {
    companyId?: string;
    website?: string | undefined;
    ownerInfo?: PersonInfoModel;
    businessInfo?: BusinessInfoModel;
    bestContact?: PersonInfoModel;
}

export interface SendTimesheetStatusReportDetailRequestModel {
    email?: string | undefined;
    timesheetStatusReportDetailRequest?: TimesheetStatusReportDetailRequestModel;
}

export interface ServiceAgreementInfoModel {
    agreementDetailsType?: ServiceAgreementTypeEnum;
    agreementAttachments?: ExtendedNamedAttachmentModel[] | undefined;
    isAgreementNotAvailableConfirmed?: boolean | undefined;
}

export enum ServiceAgreementTypeEnum {
    MyBasePayAgreement = 1,
    ClientAgreement = 2,
    MemberAgreement = 3,
    NotAvailable = 4,
}

export enum Severity {
    Error = 0,
    Warning = 1,
    Info = 2,
}

export enum SortingEnum {
    Asc = 1,
    Desc = 2,
}

export enum SplitTypeEnum {
    NoSplit = 0,
    ExistingPartner = 1,
    NewPartner = 2,
}

export enum StageStatusEnum {
    Pending = 1,
    SoftStop = 21,
    SoftStopHalfCompleted = 41,
    HardStop = 61,
    Completed = 81,
}

export interface StateEntity {
    id?: number;
    stateCode?: string | undefined;
    name?: string | undefined;
    countryId?: number;
}

export interface SummaryAssignmentDetailModel {
    assignmentId?: string;
    assignmentKey?: string | undefined;
    assignmentType?: AssignmentTypeEnum;
    customerName?: string | undefined;
    customerAdditionalInvoiceName?: string | undefined;
    customerId?: string;
    customerKey?: string | undefined;
    breakInService?: BreakInServiceEnum;
    jobTitle?: string | undefined;
    jobStartDate?: Date;
    jobEndDate?: Date;
    createdDate?: Date;
    worker?: string | undefined;
    workerKey?: string | undefined;
    terminationDate?: Date | undefined;
    renewType?: RenewAssignmentEnum;
    parentAssignmentId?: string | undefined;
    renewStatus?: RenewStatusEnum;
    renewKind?: RenewKindEnum;
    renewOptions?: AvailableRenewOptionsEnum;
}

export interface SummaryAssignmentDetailResponseModel {
    pageNumber?: number;
    totalCount?: number;
    details?: SummaryAssignmentDetailModel[] | undefined;
}

export interface SummaryAssignmentEndingSoonResponseModel {
    assignmentTotalCount?: number;
    details?: AssignmentSummaryModel[] | undefined;
}

export interface SummaryAssignmentResponseModel {
    activeAssignmentTotalCount?: number;
    w2TotalCount?: number;
    w2PercentOfTotal?: number;
    icTotalCount?: number;
    icPercentOfTotal?: number;
    subcontractTotalCount?: number;
    subcontractPercentOfTotal?: number;
}

export interface SummaryBillingAndProfitReportViewModel {
    customerName?: string | undefined;
    billing?: number;
    profit?: number;
    profitPercentage?: number;
}

export interface SummaryCustomerDetailModel {
    customerId?: string;
    customerKey?: string | undefined;
    customerCompanyName?: string | undefined;
    customerAdditionalInvoiceName?: string | undefined;
    activeAssignmentsCount?: number;
    assignmentsCount?: number;
}

export interface SummaryCustomerDetailResponseModel {
    pageNumber?: number;
    totalCount?: number;
    details?: SummaryCustomerDetailModel[] | undefined;
}

export interface SummaryCustomerResponseModel {
    customerTotalCount?: number;
    activeAssignmentTotalCount?: number;
    chartsData?: SummaryCustomerViewModel[] | undefined;
}

export interface SummaryCustomerViewModel {
    customerId?: string;
    customerKey?: string | undefined;
    customerCompanyName?: string | undefined;
    customerAdditionalInvoiceName?: string | undefined;
    activeAssignmentCount?: number;
}

export interface SummaryTrendBillingByDatesItemViewModel {
    date?: string | undefined;
    billing?: number;
    profit?: number;
    profitPercentage?: number;
}

export interface SummaryTrendBillingItemViewModel {
    workweekEnding?: string | undefined;
    billing?: number;
    profit?: number;
    profitPercentage?: number;
}

export interface SummaryTrendByCustomerReportViewModel {
    customerName?: string | undefined;
    percentageOfGreatTotal?: number;
}

export interface TeammateModel {
    userId?: string | undefined;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    role?: TeammateRoleEnum;
    status?: TeammateStatusEnum;
    invitationLink?: string | undefined;
}

export interface TeammateModelPagedResponseModel {
    totalCount?: number;
    pageNumber?: number;
    details?: TeammateModel[] | undefined;
}

export enum TeammateRoleEnum {
    TeammateAdmin = 1,
    TeammateRecruiter = 2,
    TeammateSubAdmin = 3,
}

export enum TeammateStatusEnum {
    Pending = 10,
    Active = 100,
    InActive = 200,
}

export enum TimeAMPMEnum {
    AM = 1,
    PM = 2,
}

export enum TimePointEnum {
    T01H00M = 100,
    T02H00M = 200,
    T03H00M = 300,
    T04H00M = 400,
    T05H00M = 500,
    T06H00M = 600,
    T07H00M = 700,
    T08H00M = 800,
    T09H00M = 900,
    T10H00M = 1000,
    T11H00M = 1100,
    T12H00M = 1200,
}

export interface TimesheetReportResponseModel {
    notSubmittedAssignmentPercentOfTotal?: number;
    notSubmittedAssignmentTotalCount?: number;
    notApprovedAssignmentPercentOfTotal?: number;
    notApprovedAssignmentTotalCount?: number;
    approvedAssignmentPercentOfTotal?: number;
    approvedAssignmentTotalCount?: number;
}

export enum TimesheetStatusEnum {
    All = 0,
    Open = 1,
    Submitted = 2,
    Approved = 3,
}

export interface TimesheetStatusReportDetailModel {
    id?: number;
    assignmentKey?: string | undefined;
    customerKey?: string | undefined;
    customerName?: string | undefined;
    hours?: string | undefined;
    pto?: string | undefined;
    timesheetType?: string | undefined;
    assignmentType?: string | undefined;
    state?: string | undefined;
    timesheetStartDate?: Date;
    timesheetEndDate?: Date;
    approvedOn?: Date | undefined;
    approver?: string | undefined;
    workerKey?: string | undefined;
    workerFirstName?: string | undefined;
    workerLastName?: string | undefined;
    memberKey?: string | undefined;
    companyName?: string | undefined;
}

export interface TimesheetStatusReportDetailRequestModel {
    pageNumber?: number;
    pageSize?: number;
    states?: TimesheetStatusEnum[] | undefined;
    customerIds?: string[] | undefined;
    workerIds?: string[] | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    companyIds?: string[] | undefined;
}

export interface TimesheetStatusReportDetailResponseModel {
    pageNumber?: number;
    totalCount?: number;
    lastKronosSyncDate?: Date;
    details?: TimesheetStatusReportDetailModel[] | undefined;
}

export interface TrendBillingByDatesPagedResponse {
    totalBilling?: string | undefined;
    totalProfit?: string | undefined;
    totalProfitPercentage?: string | undefined;
    lastSyncDate?: Date;
    totalCount?: number;
    pageNumber?: number;
    details?: TrendBillingItemByDatesViewModel[] | undefined;
}

export enum TrendBillingByDatesSortFieldEnum {
    Date = 0,
    Billing = 1,
    Profit = 2,
    ProfitPercentage = 3,
}

export interface TrendBillingItemByDatesViewModel {
    date?: string | undefined;
    billing?: string | undefined;
    profit?: string | undefined;
    profitPercentage?: string | undefined;
}

export interface TrendBillingItemViewModel {
    workweekEnding?: string | undefined;
    billing?: string | undefined;
    profit?: string | undefined;
    profitPercentage?: string | undefined;
}

export enum TrendBillingSortFieldEnum {
    WorkweekEnding = 0,
    Billing = 1,
    Profit = 2,
    ProfitPercentage = 3,
}

export interface TrendMixGrandTotalViewModel {
    sundayReportDetails?: { [key: string]: string; } | undefined;
    billAmountTotal?: string | undefined;
    percentageOfGreatTotal?: string | undefined;
}

export interface TrendMixReportItemViewModel {
    customerKey?: string | undefined;
    customerName?: string | undefined;
    percentageOfGreatTotal?: string | undefined;
    billAmountTotal?: string | undefined;
    sundayReportDetails?: { [key: string]: string; } | undefined;
}

export interface TrendMixReportViewModel {
    grandTotal?: TrendMixGrandTotalViewModel;
    items?: TrendMixReportItemViewModel[] | undefined;
    totalCount?: number;
    lastSyncDate?: Date;
}

export interface TrendProfitGrandTotalViewModel {
    sundayReportDetails?: { [key: string]: string; } | undefined;
    profitAmountTotal?: string | undefined;
    percentageOfGreatTotal?: string | undefined;
}

export interface TrendProfitReportItemViewModel {
    customerKey?: string | undefined;
    customerName?: string | undefined;
    percentageOfGreatTotal?: string | undefined;
    profitAmountTotal?: string | undefined;
    sundayReportDetails?: { [key: string]: string; } | undefined;
}

export interface TrendProfitReportViewModel {
    grandTotal?: TrendProfitGrandTotalViewModel;
    items?: TrendProfitReportItemViewModel[] | undefined;
    totalCount?: number;
    lastSyncDate?: Date;
}

export enum TwoFactorAuthSendMessageTypeEnum {
    EnableTwoFactorAuth = 0,
    ResetPassword = 1,
}

export interface UpdateContractorCompanyModel {
    companyName?: string | undefined;
    representativeContact?: BaseEmployeeModel;
    location?: LocationModel;
}

export interface UpdatePasswordRequestModel {
    oldPassword?: string | undefined;
    newPassword?: string | undefined;
    code?: string | undefined;
}

export interface UpdateTeammateModel {
    userId?: string;
    role?: TeammateRoleEnum;
}

export interface UpdateTwoFactorAuthStatusRequestModel {
    code?: string | undefined;
    is2FAStatus?: boolean;
}

export interface UserEmailSettingsModel {
    isAssignmentApproval?: boolean;
    isAssignmentAdditionalInfoRequired?: boolean;
    isPartnershipRequest?: boolean;
    isAssignmentEndingSoon30?: boolean;
    isAssignmentEndingSoon60?: boolean;
    isAssignmentEndingSoon90?: boolean;
    isPricingAgreementUpdate?: boolean;
    isMemberOnboardingInformation?: boolean;
    isCustomerApproval?: boolean;
    isCustomerAdditionalInfoRequired?: boolean;
}

export interface UserPagedAssignmentResponseModel {
    totalCount?: number;
    pageNumber?: number;
    details?: AssignmentTitleInfoModel[] | undefined;
}

export interface UserPagedAssignmentTemplatesResponseModel {
    totalCount?: number;
    pageNumber?: number;
    details?: AssignmentTemplateSummaryResponseModel[] | undefined;
}

export enum UserStatusEnum {
    InActive = 0,
    Active = 1,
    Deleted = -1,
}

export interface ValidationDetailsModel {
    errorMessage?: string | undefined;
    errorDetails?: any | undefined;
}

export interface ValidationFailure {
    propertyName?: string | undefined;
    errorMessage?: string | undefined;
    attemptedValue?: any | undefined;
    customState?: any | undefined;
    severity?: Severity;
    errorCode?: string | undefined;
    formattedMessagePlaceholderValues?: { [key: string]: any; } | undefined;
}

export interface WeeklyTrendBillingPagedResponse {
    totalBilling?: string | undefined;
    totalProfit?: string | undefined;
    totalProfitPercentage?: string | undefined;
    lastSyncDate?: Date;
    totalCount?: number;
    pageNumber?: number;
    details?: TrendBillingItemViewModel[] | undefined;
}

export interface WorkCodeModel {
    id?: string;
    workCode?: string | undefined;
}

export enum WorkFromHomeEnum {
    Unknown = 0,
    HomeOnly = 1,
    OnsiteOnly = 2,
    OnsitePotentialForTravel = 3,
    Hybrid = 4,
}

export interface WorkerDetailExtendedViewModel {
    workerDetail?: WorkerDetailViewModel;
    referredAssignments?: WorkerRelatedAssignmentViewModel[] | undefined;
}

export interface WorkerDetailViewModel {
    id?: string;
    workerKey?: string | undefined;
    currentRevision?: number;
    workerType?: WorkerTypeEnum;
    workerInfo?: BaseEmployeeModel;
    isDuplicated?: boolean;
    createdDate?: Date;
    createdBy?: string;
    location?: LocationViewModel;
    assignmentsCount?: number | undefined;
    creator?: CreatorUserModel;
}

export interface WorkerHistoryDetailsModel {
    oldData?: WorkerHistoryRequest;
    newData?: WorkerHistoryRequest;
}

export interface WorkerHistoryRequest {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    taxId?: number | undefined;
    workerFileKey?: string | undefined;
    w9FileName?: string | undefined;
    location?: LocationModel;
    workerType?: WorkerTypeEnum;
}

export interface WorkerItemDetailViewModel {
    companyFirstName?: string | undefined;
    companyLastName?: string | undefined;
    memberKey?: string | undefined;
    id?: string;
    workerKey?: string | undefined;
    currentRevision?: number;
    workerType?: WorkerTypeEnum;
    workerInfo?: BaseEmployeeModel;
    isDuplicated?: boolean;
    createdDate?: Date;
    createdBy?: string;
    location?: LocationViewModel;
    assignmentsCount?: number | undefined;
    creator?: CreatorUserModel;
}

export interface WorkerItemDetailViewModelPagedResponseModel {
    totalCount?: number;
    pageNumber?: number;
    details?: WorkerItemDetailViewModel[] | undefined;
}

export interface WorkerRelatedAssignmentViewModel {
    assignmentId?: string;
    assignmentKey?: string | undefined;
}

export interface WorkerSearchResponseModel {
    id?: string;
    workerKey?: string | undefined;
    workerFirstName?: string | undefined;
    workerLastName?: string | undefined;
}

export enum WorkerTypeEnum {
    EE = 1,
    IC = 2,
    SC = 3,
    InternationalIC = 4,
}

export enum YearsInBusinessEnum {
    DoNotKnow = 0,
    From0To1 = 1,
    From1To3 = 2,
    From3To5 = 3,
    From5Plus = 5,
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}